export default {
  v5: {
    my_video_shorts: 'วิดีโอสั้นของฉัน',
    see_more: 'ดูเพิ่มเติม',
    no_shorts_found: 'ไม่พบวิดีโอสั้น',
    shorts: 'วิดีโอสั้น',
    general_information: 'ข้อมูลทั่วไป',
    gamification: 'การเล่นเกม',
    click_to_select_files: 'คลิกเพื่อเลือกไฟล์',
    selected_files: 'ไฟล์ที่เลือก',
    uploaded: 'อัปโหลดแล้ว',
    failed: 'ล้มเหลว',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'ระบบจะวิเคราะห์และเลือกเอกสารที่เกี่ยวข้องมากที่สุดจากคลังขององค์กรของคุณโดยอัตโนมัติ ตามความต้องการเนื้อหา',
    select_from_library: ' เลือกจากคลัง',
    search_document: 'ค้นหาเอกสาร...',
    selected: 'เลือกแล้ว',
    loading_documents: 'กำลังโหลดเอกสาร...',
    review_generated_content: 'ตรวจสอบเนื้อหาที่สร้างขึ้น',
    confirm_and_replace_content: 'ยืนยันและแทนที่เนื้อหา',
    the_generate_content_will_replace:
      'เนื้อหาที่สร้างขึ้นจะทำการแทนที่ข้อความปัจจุบันในหน้าที่เลือก หากคุณไม่ต้องการใช้การเปลี่ยนแปลงนี้ สามารถกลับไปยังขั้นตอนก่อนหน้าได้',
    pages_to_be_updated: 'หน้าที่จะอัปเดต',
    generated_revisions: 'การแก้ไขที่สร้างขึ้น',
    lesson_preview: 'ตัวอย่างบทเรียน',
    create_new_folder: 'สร้างโฟลเดอร์ใหม่',
    rename_item: 'เปลี่ยนชื่อรายการ',
    enter_folder_name: 'ป้อนชื่อโฟลเดอร์:',
    enter_new_name: 'ป้อนชื่อใหม่:',
    folder_name: 'ชื่อโฟลเดอร์:',
    new_name: 'ชื่อใหม่',
    move_items: 'ย้ายรายการ',
    copy_items: 'คัดลอกรายการ',
    move_here: 'ย้ายมาที่นี่',
    copy_here: 'คัดลอกมาที่นี่',
    select_destination_library_and_folder: 'เลือกคลังและโฟลเดอร์ปลายทาง:',
    items_selected: 'รายการที่เลือก',
    version: 'เวอร์ชัน',
    modified_by: 'แก้ไขโดย',
    size: 'ขนาด',
    restore: 'กู้คืน',
    are_you_sure_you_want_to_restore_this_version:
      'คุณแน่ใจหรือว่าต้องการกู้คืนเวอร์ชันนี้?',
    this_will_replce_the_current_version_with_the_selected_one:
      'สิ่งนี้จะแทนที่เวอร์ชันปัจจุบันด้วยเวอร์ชันที่เลือก',
    restore_this_version: 'กู้คืนเวอร์ชันนี้',
    restore_not_available: 'ไม่สามารถกู้คืนได้',
    version_history: 'ประวัติเวอร์ชัน:',
    by_making_items_public:
      'เมื่อทำรายการให้เป็นสาธารณะ รายการจะมองเห็นได้สำหรับทุกคน โปรดตรวจสอบข้อกำหนดและเงื่อนไขก่อนดำเนินการ',
    the_selected_items_will_be_copied:
      'รายการที่เลือกจะถูกคัดลอกไปยังคลังสาธารณะของคุณและมองเห็นได้สำหรับทุกคน',
    the_selected_items_will_be_copied_to_org:
      'รายการที่เลือกจะถูกคัดลอกไปยังคลังขององค์กรของคุณและมองเห็นได้สำหรับสมาชิกองค์กรทั้งหมด',
    the_selected_items_will_be_copied_to_your_private:
      'รายการที่เลือกจะถูกคัดลอกไปยังคลังส่วนตัวของคุณและมองเห็นได้เฉพาะคุณ',
    loading_organization: 'กำลังโหลดผู้ใช้องค์กร...',
    click_download_to_view: 'คลิกดาวน์โหลดเพื่อดู',
    archive_file: 'ไฟล์เก็บถาวร',
    no_preview_available: 'ไม่มีตัวอย่าง',
    audit_report: 'รายงานการตรวจสอบ',
    audit_type: 'ประเภทการดำเนินการ',
    i_agree_to_the_terms_and_conditions: 'ฉันยอมรับข้อกำหนดและเงื่อนไข',
    this_file_is_indexed_for_ai: 'ไฟล์นี้ถูกจัดทำดัชนีสำหรับ AI',
    file_is_not_indexed_for_ai: 'ไฟล์ไม่ได้จัดทำดัชนีสำหรับ AI',
    no_users_found: 'ไม่พบผู้ใช้',
    no_users_available: 'ไม่มีผู้ใช้',
    add_people: 'เพิ่มผู้คน',
    people: 'ผู้คน',
    access_type: 'ประเภทการเข้าถึง',
    no_group_found: 'ไม่พบกลุ่ม',
    add_group: 'เพิ่มกลุ่ม',
    groups: 'กลุ่ม',
    users_top: 'ผู้ใช้',
    confirm_delete: 'ยืนยันการลบ',
    do_you_want_remove: 'คุณต้องการลบหรือไม่',
    form_this_documents_permissions: 'จากสิทธิ์ของเอกสารนี้?',
    no_users_found_in_this_group: 'ไม่พบผู้ใช้ในกลุ่มนี้',
    add_selected_users: 'เพิ่มผู้ใช้ที่เลือก',
    choose_users_from_the_list: 'เลือกผู้ใช้จากรายการ',
    selected_users: 'ผู้ใช้ที่เลือก',
    archived: 'เก็บถาวร',
    request_approval: 'ขออนุมัติ',
    document_in_review: 'เอกสารอยู่ระหว่างการตรวจสอบ',
    approve: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    comment: 'ความคิดเห็น:',
    enter_your_commit: 'ป้อนความคิดเห็นของคุณ...',
    confirm_cancel: 'ยืนยันการยกเลิก',
    upload_3d_zip: 'อัปโหลดไฟล์ 3D ZIP',
    delete_items: 'ลบรายการ',
    video_upload_request: 'คำขออัปโหลดวิดีโอ',
    reject_video: 'ปฏิเสธวิดีโอ',
    enter_rejection_reason: 'ป้อนเหตุผลการปฏิเสธ...',
    please_provide_a_reason_for_reejection_this_video:
      'โปรดระบุเหตุผลในการปฏิเสธวิดีโอนี้',
    generate_trivia_with_ai: 'สร้างคำถาม Trivia ด้วย AI',
    select_category: 'เลือกหมวดหมู่:',
    number_of_question: 'จำนวนคำถาม',
    generated_questions: 'คำถามที่สร้างขึ้น',
    this_will_clear_all_generate_question:
      'สิ่งนี้จะลบคำถามที่สร้างทั้งหมด ดำเนินการต่อ?',
    sure_delete: 'คุณแน่ใจหรือว่าต้องการลบ?',
    delete_this_question: 'คุณแน่ใจหรือว่าต้องการลบคำถามนี้?',
    loading_quiz: 'กำลังโหลดแบบทดสอบ...',
    creteing_file: 'กำลังสร้างไฟล์',
    opening_desktop_app: 'กำลังเปิดแอปเดสก์ท็อป',
    this_folder_is_empty: 'โฟลเดอร์นี้ว่างเปล่า',
    select_a_competition: 'เลือกการแข่งขัน...',
    activity_badges: 'ป้ายกิจกรรม',
    awarded_every_badges:
      'มอบให้ทุกการเข้าสู่ระบบ 4, 8, 16, 32, 64, 128, 256, 512 ครั้ง',
    learning_badges: 'ป้ายการเรียนรู้',
    awarded_every_courses:
      'มอบให้ทุกหลักสูตรที่เสร็จสิ้น 1, 4, 8, 16, 32, 64, 128 หลักสูตร',
    test_badges: 'ป้ายการทดสอบ',
    awarded_every_passes_tests:
      'มอบให้ทุกการสอบผ่าน 2, 4, 8, 16, 32, 64, 128, 256 การสอบ',
    assignment_badges: 'ป้ายงาน',
    awarded_every_passed_assignments:
      'มอบให้ทุกงานที่ทำสำเร็จ 1, 2, 4, 8, 16, 32, 64, 128 งาน',
    perfectionism_badges: 'ป้ายความสมบูรณ์แบบ',
    awarded_every_assignments_with_scrore:
      'มอบให้ทุกการทดสอบ/งานที่ได้คะแนน 90%+ 1, 2, 4, 8, 16, 32, 64, 128',
    communication_badges: 'ป้ายการสื่อสาร',
    awarded_every_topics_or_comments:
      'มอบให้ทุกหัวข้อหรือความคิดเห็น 2, 4, 8, 16, 32, 64, 128, 256',
    certification_badges: 'ป้ายการรับรอง',
    awarded_every_certificates: 'มอบให้ทุกใบรับรอง 1, 2, 4, 8, 16, 32, 64, 128',
    level_name: 'ชื่อระดับ',
    delete_competition: 'ลบการแข่งขัน',
    this_week: 'สัปดาห์นี้',
    this_year: 'ปีนี้',
    make_organization: 'สร้างองค์กร',
    no_results_found: 'ไม่พบผลลัพธ์สำหรับ',
    no_items_available: 'ไม่มีรายการ',
    help_video: 'วิดีโอช่วยเหลือ',
    select_a_video_from_the_list: 'เลือกวิดีโอจากรายการเพื่อเริ่มเรียนรู้'
  },
  v4: {
    drop_files: 'ลากไฟล์แล้วเลือกตำแหน่งที่จะอัปโหลด',
    duplicate_lessoon: 'บทเรียนมีอยู่ในหลักสูตรแล้ว',
    skill_rule_title: 'กรุณาใส่ชื่อเส้นทางทักษะ',
    imageCreatorTitle: 'ตัวสร้างภาพ',
    isTranslated: 'แปลแล้ว',
    translationCourseDesc:
      'การแปลหลักสูตรนี้อาจใช้เวลาสักครู่ ขอบคุณสำหรับความอดทนของคุณ!',
    translateCourseTip:
      'สร้างหลักสูตรที่แปลแล้ว ซึ่งคุณสามารถแก้ไขได้อย่างอิสระจากต้นฉบับ รวมบทเรียนและหน้าเพจทั้งหมด',
    translateModalBtn: 'แปล',
    translationSuccess: 'หลักสูตร "<0/>" แปลสำเร็จแล้ว!',
    translatingCourse: 'กำลังแปลหลักสูตร...',
    translateModalTitle: 'แปลหลักสูตร',
    translateSelectLang: 'เลือกภาษา',
    fileDeleteconfirm:
      'คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้? การกระทำนี้ไม่สามารถย้อนกลับได้',
    fileDeleteMessage: 'ลบไฟล์สำเร็จแล้ว',
    fileDeleteFailedMessage: 'ไม่สามารถลบไฟล์ได้!',
    fileDelete: 'ลบไฟล์นี้',
    certificate_save_btn: 'เพิ่มใบประกาศนียบัตรไปที่ ',
    maze_path_info: 'ไม่มีเส้นทางที่ใช้ได้สำหรับกราฟ!',
    file_size_mb: 'ขนาดไฟล์ต้องน้อยกว่า 25MB!',
    reports: {
      products: 'ผลิตภัณฑ์',
      users: 'ผู้ใช้',
      ph_username: 'ค้นหาผู้ใช้ตามชื่อผู้ใช้',
      ph_id: 'ค้นหาผู้ใช้ตามหมายเลข ID',
      ph_email: 'ค้นหาผู้ใช้ตามอีเมล'
    },
    select_upload_section_id: 'จำเป็นต้องมีไฟล์ส่วน',
    tags_all: 'ทั้งหมด',
    delete_file_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้?',
    delete_file_title: 'ลบไฟล์',
    tooltip_publish: 'เผยแพร่หลักสูตรด้วยตัวเลือกที่เลือก',
    tooltip_save: 'บันทึกหลักสูตรพร้อมการอัปเดตปัจจุบัน',
    tooltip_next: 'ไปยังการตั้งค่าหลักสูตรถัดไป',
    tooltip_finish: 'เสร็จสิ้นและบันทึกการอัปเดตปัจจุบัน',
    stories_modal: {
      title_upload: 'อัปโหลดเรื่องราว',
      title_update: 'อัปเดตเรื่องราว',
      title_audio: 'ไฟล์เสียงเรื่องราว',
      btn_upload: 'อัปโหลด',
      btn_update: 'อัปเดต',
      btn_close: 'ปิด',
      btn_cancel: 'ยกเลิก',
      lbl_cover: 'ภาพหน้าปกเรื่องราว',
      rule_cover: 'กรุณาอัปโหลดภาพหน้าปกเรื่องราว!',
      lbl_title: 'ชื่อเสียงเรื่องราวเสียง',
      rule_title: 'กรุณาใส่ชื่อเรื่องเสียง!',
      lbl_description: 'คำอธิบายเรื่องราวเสียง',
      rule_description: 'กรุณาใส่คำอธิบาย!',
      lbl_file: 'อัปโหลดไฟล์เสียงเรื่องราว',
      rule_file: 'กรุณาอัปโหลดไฟล์เสียง!',
      rule_file_type: 'กรุณาอัปโหลดไฟล์เสียงที่ถูกต้อง!',
      lbl_select_file: 'เลือกไฟล์เสียงเรื่องราว',
      msg_valid_file: 'กรุณาเลือกไฟล์เสียงที่ถูกต้อง!',
      msg_success: 'อัปโหลดไฟล์เสียงเรื่องราวสำเร็จ!',
      msg_failed: 'ไม่สามารถกำหนดข้อมูลสื่อ!',
      msg_error: 'เกิดข้อผิดพลาดในการอัปโหลดไฟล์!'
    },
    audio_modal: {
      title_upload: 'อัปโหลด',
      title_update: 'อัปเดต',
      title_audio: 'ไฟล์เสียง',
      btn_upload: 'อัปโหลด',
      btn_update: 'อัปเดต',
      btn_close: 'ปิด',
      btn_cancel: 'ยกเลิก',
      lbl_cover: 'ภาพหน้าปกเสียง',
      rule_cover: 'กรุณาอัปโหลดภาพหน้าปกเสียง!',
      lbl_title: 'ชื่อเสียง',
      rule_title: 'กรุณาใส่ชื่อเสียง!',
      lbl_description: 'คำอธิบายเสียง',
      rule_description: 'กรุณาใส่คำอธิบาย!',
      lbl_file: 'อัปโหลดไฟล์เสียง',
      rule_file: 'กรุณาอัปโหลดไฟล์เสียง!',
      rule_file_type: 'กรุณาอัปโหลดไฟล์เสียงที่ถูกต้อง!',
      lbl_select_file: 'เลือกไฟล์เสียง',
      msg_valid_file: 'กรุณาเลือกไฟล์เสียงที่ถูกต้อง!',
      msg_success: 'อัปโหลดไฟล์เสียงสำเร็จ!',
      msg_failed: 'ไม่สามารถกำหนดข้อมูลสื่อ!',
      msg_error: 'เกิดข้อผิดพลาดในการอัปโหลดไฟล์!'
    },
    info_episode: 'ภาพหน้าปกสำหรับตอนนี้',
    btn_delete_episode: 'ลบตอนนี้ของพอดคาสต์',
    btn_edit_marketplace: 'แก้ไขรายละเอียดตลาด',
    btn_save_marketplace: 'บันทึกการเปลี่ยนแปลงปัจจุบัน',
    btn_ai_podcast: 'สร้างตอนพอดคาสต์ด้วย AI',
    btn_upload_podcast: 'อัปโหลดตอนพอดคาสต์ของคุณเอง',
    attach_file: 'อัปโหลดไฟล์เพื่อแชร์เนื้อหาเพิ่มเติมกับผู้ชมของคุณ',
    fileDownload: 'ดาวน์โหลดไฟล์นี้',
    singleEpishode: 'ตอน',
    podcast_music: 'พอดคาสต์, ดนตรี & เรื่องราว',
    publishHeader: 'เผยแพร่พอดคาสต์ ดนตรี & เรื่องราว',
    editHeader: 'แก้ไขพอดคาสต์ ดนตรี & เรื่องราว',
    createHeader: 'สร้างพอดคาสต์ ดนตรี & เรื่องราว',
    marketplaceHeader: 'รายละเอียดตลาดสำหรับพอดคาสต์ ดนตรี & เรื่องราว',
    message_marketplace: 'กรุณากรอกแบบฟอร์มตลาด!',
    create_podcast_live: 'พอดคาสต์และดนตรีสด',
    create_podcast_custom: 'พอดคาสต์และดนตรีที่กำหนดเอง',
    create_podcast_stories: 'เรื่องราว',
    ai_Assisted_podcast_reation: 'พอดคาสต์ & ดนตรีที่มี AI ช่วย',
    publishTitle: 'เผยแพร่พอดคาสต์ ดนตรี & เรื่องราวสู่สาธารณะ',
    customButton: 'สร้างเอง',
    customTitle: 'บันทึกการเปลี่ยนแปลงที่ทำกับพอดคาสต์',
    updateButton: 'อัปเดต',
    createButton: 'สร้าง',
    createNewButton: 'สร้างใหม่',
    updateTitle: 'อัปเดตรายละเอียดพอดคาสต์ ดนตรี & เรื่องราวปัจจุบัน',
    createTitle: 'สร้างพอดคาสต์ ดนตรี & เรื่องราวใหม่',
    createNewTitle: 'จะสร้างพอดคาสต์ ดนตรี & เรื่องราวใหม่ตามข้อมูลปัจจุบัน',
    podcastTitle: 'รายการตอน',
    podcastStoryTitle: 'รายการตอนเรื่องราว',
    podcastToolTipTitle: 'รายการตอนพอดคาสต์',
    uploadAudio: 'อัปโหลดเสียง',
    aiAudio: 'เสียง AI',
    emptyPodcast: 'ยังไม่มีการบันทึกพอดคาสต์ ดนตรี หรือเรื่องราว',
    emptyStoriesPodcast: 'ยังไม่มีเรื่องราวใดๆ',
    emptyCreatePodcast: 'กรุณาสร้างพอดคาสต์ก่อนเพิ่มเสียง',
    playPodcast: 'เล่นพอดคาสต์ ดนตรี & เรื่องราวที่เลือก',
    pausePodcast: 'หยุดเล่นพอดคาสต์ ดนตรี & เรื่องราวที่เลือก',
    selectPodcast: 'เลือกพอดคาสต์ ดนตรี & เรื่องราวนี้',
    downloadPodcast: 'ดาวน์โหลดเสียงนี้',
    uploadAudioFile: 'อัปโหลดเสียงใหม่แล้วแทนที่เสียงปัจจุบัน',
    deleteConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบเสียงนี้?',
    roomName: 'ชื่อพอดคาสต์',
    addGuestTitle: 'เพิ่มแขกรับเชิญ',
    showTime: 'เวลาชม',
    startTime: 'เวลาเริ่มต้น',
    endTime: 'เวลาสิ้นสุด',
    erorMsgImg: 'กรุณาเลือกภาพที่ถูกต้อง',
    failedMsgImg: 'อัปโหลดภาพล้มเหลว กรุณาลองใหม่!',
    failedMsgUpload: 'อัปโหลดหน้าปกล้มเหลว!',
    btnCoverUpload: 'อัปโหลดหน้าปก',
    is_private: 'ส่วนตัว',
    to_attach: 'แนบไฟล์',
    file_attached: 'ไฟล์ที่แนบ',
    main_event: 'เหตุการณ์หลัก',
    event: 'เหตุการณ์',
    upload_pdf: 'อัปโหลด PDF',
    portrait: 'แนวตั้ง',
    landscape: 'แนวนอน',
    import_from_library: 'นำเข้าข้อความจากคลังสื่อ',
    question_answer_ai: 'AI คำถาม/คำตอบ',
    take_maze: 'เริ่ม MetaMaze',
    training: 'การฝึกอบรม',
    select_transcribe_locale: 'เลือกภาษาสำหรับการถอดเสียง',
    transcribe_limit: 'กรุณากรอกนาทีสำหรับการถอดเสียง',
    not_complete: 'ข้อมูลตลาดยังไม่สมบูรณ์',
    complete: 'ข้อมูลตลาดสมบูรณ์แล้ว',
    not_admin: 'ต้องมีสิทธิ์แอดมินเพื่อเผยแพร่ในตลาด',
    no_course: 'กรุณากรอกชื่อเรื่องและเลือกภาพเพื่อเปิดใช้ตลาด',
    scorm_not_complete: 'กรุณากรอกชื่อเรื่องและเลือกภาพเพื่ออัปโหลดไฟล์ SCORM',
    not_found_maze: 'ไม่พบ MetaMaze',
    email_require: 'ต้องระบุอีเมล',
    poll_required: 'ต้องระบุข้อมูลแบบสำรวจ',
    alert: 'แจ้งเตือน!',
    warning: 'คำเตือน!',
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
    done: 'เสร็จสิ้น',
    insert: 'แทรก',
    private: 'ส่วนตัว',
    public: 'สาธารณะ',
    no_connection: 'การเชื่อมต่ออินเทอร์เน็ตขาดหาย',
    switch: 'สลับ',
    share_screen: 'แชร์หน้าจอ',
    stop_share_screen: 'หยุดแชร์หน้าจอ',
    share_screen_with_camera: 'แชร์หน้าจอพร้อมกล้อง',
    stop_share_screen_with_camera: 'หยุดแชร์หน้าจอพร้อมกล้อง',
    camera_on: 'เปิดกล้อง',
    camera_off: 'ปิดกล้อง',
    mic_on: 'เปิดไมค์',
    mic_off: 'ปิดไมค์',
    fullscreen: 'เต็มหน้าจอ',
    live_now: 'ถ่ายทอดสดตอนนี้',
    schedule_on: 'กำหนดเวลา:',
    organisations: 'องค์กร',
    org_groups: 'กลุ่มองค์กร',
    specific_user: 'ผู้ใช้เฉพาะ',
    gif: 'GIF',
    unavailable: 'ไม่พร้อมใช้งาน',
    yes: 'ใช่',
    no: 'ไม่',
    event_duration_message: 'สูงสุด 300 นาที (5 ชั่วโมง)',
    send_email: 'ส่งการแจ้งเตือนทางอีเมล',
    admin_only: 'สำหรับผู้ดูแลระบบเท่านั้น',
    join: 'เข้าร่วม',
    leave: 'ออก',
    share: 'แชร์',
    share_text: 'กรุณากรอกอีเมลของผู้ที่คุณต้องการแชร์ไฟล์นี้ด้วย',
    share_text_title: 'แชร์ PDF',
    share_text_title_txt: 'แชร์ข้อความ',
    select_users: 'เลือกผู้ใช้',
    delete: 'ลบ',
    attachment_event: 'ไฟล์แนบสำหรับกิจกรรม:',
    transcribe_limit: 'จำกัดนาทีในการถอดเสียง',
    monthly_transcribe: 'จำกัดการถอดเสียงรายเดือน:',
    enable_ai: 'เปิดใช้งาน AI:',
    enable_maze: 'เปิดใช้งาน MetaMaze:',
    media_service: 'บริการสื่อ',
    allow_others: 'อนุญาตให้ผู้อื่นแก้ไข',
    join_breakout_room: 'เข้าร่วมห้องย่อย',
    bio: 'ชีวประวัติ',
    linkedin: 'LinkedIn',
    select_org_report: 'กรุณาค้นหาและเลือกองค์กรเพื่อสร้างรายงาน',
    org_image_not_found: 'ไม่พบภาพ',
    insert_text: 'แทรกข้อความ',
    insert_question_answer: 'AI คำถาม/คำตอบ',
    modal_title2: 'คลังข้อความ',
    my_text_library: 'คลังข้อความของฉัน',
    ai: 'AI',
    public_text_library: 'คลังข้อความสาธารณะ',
    organization_text_library: 'คลังข้อความขององค์กร',
    no_transcribed_text: 'ไม่พบข้อความถอดเสียง',
    public_text_not_found: 'ไม่พบข้อความถอดเสียงสาธารณะ',
    org_text_not_found: 'ไม่พบข้อความถอดเสียงขององค์กร',
    org_video_not_found: 'ไม่พบวิดีโอ',
    canva: 'ทำใน Canva',
    canva_open: 'คลิกที่นี่เพื่อเปิด Canva Editor',
    pdf: 'PDF',
    txt: 'ข้อความ',
    human: 'พรีเมียม',
    shared_file: 'แชร์ไฟล์ของคุณเรียบร้อยแล้ว',
    error_shared_file: 'เกิดปัญหาในการแชร์ไฟล์ กรุณาลองใหม่อีกครั้ง',
    publish: 'เผยแพร่',
    maze_scenes: 'ฉากของ MetaMaze',
    pexel_images: 'ภาพจาก Pexel',
    group: 'กลุ่ม',
    group_name: 'ชื่อกลุ่ม',
    select_group: 'เลือกกลุ่ม',
    search_maze: 'ค้นหา MetaMaze',
    hosts: 'โฮสต์',
    avg_score: 'คะแนนเฉลี่ย',
    maze_report: 'รายงาน MetaMaze',
    maze_view: 'มุมมอง MetaMaze',
    title_maze: 'MetaMaze',
    author: 'ผู้เขียน',
    match: 'เส้นทางที่ตรงกัน',
    preview_mazeTitle: 'ชื่อเรื่อง:',
    other: 'อื่น ๆ',
    total: 'รวม',
    report_course: 'หลักสูตร',
    report_courses: 'หลักสูตร',
    report_event: 'กิจกรรม',
    report_events: 'กิจกรรม',
    report_maze: 'MAZE',
    report_personalize_learning: 'การเรียนรู้เฉพาะบุคคล',
    report_live_assessment: 'การประเมินสด',
    report_live_assessments: 'การประเมินสด',
    report_skill_journey: 'เส้นทางทักษะ',
    skill_journey: 'เส้นทางทักษะ',
    skill_journeys: 'เส้นทางทักษะ',
    date: 'วันที่:',
    search_people: 'ค้นหาผู้คน',
    passed: 'ผ่าน',
    failed: 'ไม่ผ่าน',
    item: 'รายการ',
    type: 'ประเภท',
    minimum_pass_score: 'คะแนนขั้นต่ำที่ผ่าน',
    resources_count: 'จำนวนทรัพยากร',
    back: 'ย้อนกลับ',
    resources: 'ทรัพยากร',
    time_spent: 'เวลาที่ใช้ (นาที)',
    detail: 'รายละเอียด',
    watched_time_mins: 'เวลาที่ดู (นาที)',
    personalize_learning: 'การเรียนรู้เฉพาะบุคคล',
    result: 'ผลลัพธ์',
    assessment_title: 'ชื่อเรื่อง',
    marketPlace_graph: 'กราฟตลาด',
    attachments: 'ไฟล์แนบเพิ่มเติม',
    new_scorm_course: 'อัปโหลดคอร์ส SCORM ใหม่',
    upload_scorm_course: 'อัปโหลดคอร์ส SCORM',
    new_maze: 'สร้าง MetaMaze ใหม่',
    new_skill_journey: 'สร้างเส้นทางทักษะ',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'เส้นทางทักษะ',
    new_discussion_room: 'สร้างพอดแคสต์ใหม่',
    title: 'วันนี้คุณต้องการทำอะไร?',
    build_course: 'สร้างคอร์สของฉัน',
    live_broadcast: 'ถ่ายทอดสด',
    invite_users: 'เชิญผู้ใช้งานเข้าสู่องค์กรของฉัน',
    build_voice_over: 'สร้างเสียงพากย์ของฉัน',
    view_reports: 'ดูรายงาน',
    upload_media: 'อัปโหลดสื่อหรือผลงานของฉันและแชร์',
    main_menu: 'เมนูหลัก',
    get_started: 'เริ่มต้น',
    search_group: 'ค้นหากลุ่มในองค์กร',
    ai_course: 'คอร์ส AI',
    search_user: 'ค้นหาชื่อบริษัท',
    no_maze: 'ขณะนี้ยังไม่มี MetaMaze',
    conference_event_title: 'กิจกรรมการประชุม',
    conference_event_subTitle: 'กิจกรรมการประชุมที่จบแล้ว',
    conference_event: 'ขณะนี้ยังไม่มีกิจกรรมการประชุม',
    no_skill: 'ขณะนี้ยังไม่มีเส้นทางทักษะ',
    no_podcast: 'ขณะนี้ยังไม่มีพอดแคสต์',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'การประเมินสดที่ผ่านมา',
    no_live_assessment: 'ขณะนี้ยังไม่มีการประเมินสด',
    enrolled_courses: 'คอร์สที่ลงทะเบียน',
    my_video_channel: 'ช่องวิดีโอของฉัน',
    enrolled_liveEvents: 'กิจกรรมสด',
    sharebot: 'Sharebot',
    selected_language: 'ภาษาที่เลือก',
    shareSphere_game: 'เกม ShareSphere',
    maze: 'MetaMaze',
    skill: 'เส้นทางทักษะ',
    channel: 'ช่องทาง',
    order: 'ลำดับ',
    is_record: 'บันทึก',
    no_maze_found: 'ไม่พบ MetaMaze',
    maze_self_limit_reached: 'ถึงขีดจำกัดการประเมิน MetaMaze ด้วยตนเองแล้ว',
    metamaze_two_times: 'คุณได้ทำ MetaMaze นี้แล้ว 2 ครั้ง',
    metamaze_two_times_no_result:
      'คุณได้ทำ MetaMaze นี้แล้ว 2 ครั้ง การทำซ้ำครั้งถัดไปจะไม่บันทึกผลลัพธ์ของคุณ',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'คะแนนขั้นต่ำที่ต้องผ่าน',
    organization: 'กรุณาเลือกองค์กร',
    pass_score_mark: 'กรุณากรอกคะแนนระหว่าง 1 ถึง 100',
    maze_cloning_success: 'MetaMaze "<0/>" ถูกโคลนเรียบร้อยแล้ว!',
    create_certificate: 'สร้างใบรับรอง',
    create_badge: 'สร้างเหรียญตรา',
    certificate_added: 'เพิ่มใบรับรองแล้ว',
    badge_added: 'เพิ่มเหรียญตราแล้ว',
    certificate_warning:
      'คุณไม่สามารถแก้ไขใบรับรอง/เหรียญตราหลังจากที่เผยแพร่แล้ว!',
    created_course_plan: 'แก้ไขและเผยแพร่คอร์สของคุณ พร้อมวางแผนกิจกรรมสด',
    market_place_space: 'ตลาด',
    select_course_language: 'เลือกภาษา (ไม่บังคับ)',
    select_language: 'เลือกภาษา',
    file_upload: 'อัปโหลดไฟล์',
    text: 'เขียนข้อความที่นี่…',
    attempts_count: 'จำนวนครั้งที่ผู้ใช้สามารถลองใหม่ได้',
    no_of_people_placeholder: 'จำนวนคน',
    back_to_maze: 'กลับไปยังสถานการณ์ MetaMaze',
    edit_maze: 'แก้ไข Maze',
    wait: 'กรุณารอสักครู่...',
    retry: 'ลองอีกครั้ง',
    publish_scorm_course: 'เผยแพร่คอร์ส SCORM ของคุณ',
    publish_maze: 'เผยแพร่ MetaMaze ของคุณ',
    import: 'นำเข้าองค์ประกอบ',
    answer_correct: 'เลือกคำตอบที่ถูกต้อง',
    author_name: 'กรุณาใส่ชื่อผู้แต่ง',
    select_category: 'กรุณาเลือกหมวดหมู่',
    course_outline: 'กรุณาใส่โครงร่างของหลักสูตร',
    course_obj: 'กรุณาใส่วัตถุประสงค์ของหลักสูตร',
    course_description: 'กรุณาใส่คำอธิบายหลักสูตร',
    maze_outline: 'กรุณาใส่โครงร่างของเขาวงกต',
    maze_obj: 'กรุณาใส่วัตถุประสงค์ของเขาวงกต',
    maze_description: 'กรุณาใส่คำอธิบายของเขาวงกต',
    lessons: 'กรุณาใส่จำนวนบทเรียน',
    user_email_require: 'จำเป็นต้องใส่อีเมลผู้ใช้',
    team_size: 'จำเป็นต้องใส่ขนาดทีม',
    enter_price: 'กรุณาใส่ราคา (ตั้งแต่ 5 ขึ้นไป)',
    input_title_maze: 'กรุณาใส่ชื่อของเขาวงกต',
    trainer_bio: 'กรุณาใส่ประวัติของผู้ฝึกสอน',
    trainer_linkedin: 'กรุณาใส่ลิงก์ LinkedIn ของผู้ฝึกสอน',
    error_video: 'กรุณาใส่จำนวนวิดีโอ',
    input_video_link: 'กรุณาใส่ลิงก์วิดีโอ',
    number_of_video: 'จำนวนวิดีโอ',
    number_of_lessions: 'จำนวนบทเรียน',
    no_of_people_in_conference: 'มีผู้เข้าร่วมประชุมกี่คน?',
    transcribe_settings: 'การตั้งค่าการถอดเสียง',
    transcribe: 'ถอดเสียง',
    cloning_maze: 'กำลังโคลน MetaMaze...',
    id_number: 'หมายเลขประจำตัว',
    timezone: 'เขตเวลา',
    edit_maze: 'แก้ไข',
    delete_maze: 'ลบ',
    view_maze: 'ดู',
    create_metamaze: 'สร้าง MetaMaze',
    metamaze_scenario: 'สถานการณ์ MetaMaze',
    publish_metamaze: 'การตั้งค่าการเผยแพร่',
    search_result: 'ผลการค้นหา:',
    search_for: 'ค้นหา',
    search_no_result: '- ไม่พบผลลัพธ์!',
    channel_no_available: 'ไม่มีช่องทางที่ใช้ได้!',
    this_card: 'นี่คือการ์ด',
    course_no_available: 'ไม่มีหลักสูตรที่ใช้ได้!',
    exit_fullscreen: 'ออกจากโหมดเต็มหน้าจอ',
    bg_image: 'ภาพพื้นหลัง',
    introduction: 'บทนำ',
    summary: 'สรุป',
    generate_introduction: 'สร้างบทนำ',
    generate_summary: 'สร้างสรุป',
    bullet_points: 'หัวข้อย่อย',
    title_simulation: 'กรุณาใส่ชื่อการจำลอง',
    view_generated_images: 'ดูภาพที่สร้างแล้ว',
    image_transparency: 'ความโปร่งใสของภาพ',
    template_bg_color: 'สีพื้นหลังของเทมเพลต',
    select_template_layout: 'เลือกเค้าโครงเทมเพลต',
    reload_template: '(โหลดเทมเพลตใหม่)',
    are_you_sure_want_close: 'คุณแน่ใจหรือไม่ว่าต้องการปิด?',
    all_your_changes_will_be_lost: 'การเปลี่ยนแปลงทั้งหมดจะหายไป',
    please_checked_before_generated_video:
      'กรุณาตรวจสอบเงื่อนไขทั้งหมดก่อนสร้างวิดีโอ',
    voice_must_be_selected: 'ต้องเลือกเสียง',
    avatar_must_be_selected: 'ต้องเลือกรูปอวาตาร์',
    maximum_five_slides_try_again:
      'เกิดข้อผิดพลาดขณะดึงภาพจากไฟล์ของคุณ ตรวจสอบว่าไฟล์มีไม่เกิน 5 สไลด์ และมีหมายเหตุในแต่ละสไลด์ กรุณาลองใหม่อีกครั้ง!',
    back_to_upload: 'กลับไปอัปโหลด',
    uploading_file_to_server: 'กำลังอัปโหลดไฟล์ของคุณไปยังเซิร์ฟเวอร์',
    extracting_images_from_your_file: 'กำลังดึงภาพจากไฟล์ของคุณ',
    upload_your_ppt_or_drag:
      'อัปโหลดไฟล์พรีเซนเทชันของคุณ (.PPTX) หรือลากมาที่นี่',
    maximum_five_slides_error:
      'โปรดตรวจสอบว่าไฟล์ PowerPoint ของคุณมีไม่เกิน 5 สไลด์ และมีหมายเหตุในแต่ละสไลด์ ไม่เช่นนั้นจะเกิดข้อผิดพลาด',
    number_of_questions_generated: 'จำนวนคำถามที่ต้องการสร้าง',
    quiz_page_this_cannot_be_done:
      'คุณแน่ใจหรือไม่ว่าต้องการเพิ่มแบบทดสอบในหน้านี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    confirm_selection: 'ยืนยันการเลือก',
    select_quiz_page: 'เลือกหน้าสำหรับแบบทดสอบ',
    lesson_do_you_want_add_this_quiz:
      'คุณต้องการเพิ่มแบบทดสอบในส่วนใดของบทเรียน?',
    beginning_of_lesson: 'ต้นบทเรียน',
    end_of_lesson: 'ท้ายบทเรียน',
    currently_active_page: 'หน้าที่ใช้งานอยู่ในขณะนี้',
    finish: 'เสร็จสิ้น',
    upload_selection_file: 'อัปโหลดไฟล์ส่วน',
    general_quiz: 'แบบทดสอบทั่วไป',
    manage_sequence: 'จัดการลำดับ',
    save_sequence: 'บันทึกลำดับ',
    new: 'ใหม่',
    in_progress: 'กำลังดำเนินการ',
    recommended_course: 'หลักสูตรแนะนำ',
    up_coming: 'เร็ว ๆ นี้',
    past_live: 'ถ่ายทอดสดที่ผ่านมา',
    input_your_channel_name: 'กรุณาใส่ชื่อช่องของคุณ!',
    organization_place: 'ตลาดขององค์กร',
    marketplace_report: 'รายงานตลาด',
    story_writing: 'การเขียนเรื่องราว',
    Ai_quiz: 'แบบทดสอบ AI',
    generate_quiz: 'สร้างแบบทดสอบ',
    create_story: 'สร้างเรื่องราว',
    change_layout_page: 'คุณกำลังจะเปลี่ยนเค้าโครงของหน้านี้',
    change_layout_message:
      'โปรดทราบว่าเฉพาะข้อความ รูปภาพ พื้นหลัง และโลโก้เท่านั้นที่จะถูกเก็บไว้ ส่วนประกอบอื่น ๆ ทั้งหมดจะถูกลบออก',
    reviews: 'รีวิว',
    tab_attachments: 'ไฟล์แนบ',
    zoom_in: 'ซูมเข้า',
    zoom_out: 'ซูมออก',
    zoom_reset: 'รีเซ็ตการซูม',
    no_attachment: 'ไม่มีไฟล์แนบ',
    select_upload_simulation: 'กรุณาเลือก/อัปโหลดการจำลอง',
    quiz_updated_successfully: 'อัปเดตแบบทดสอบเรียบร้อยแล้ว!',
    quizes: 'แบบทดสอบ',
    trivia: 'เรื่องไม่สำคัญ',
    closing: 'กำลังปิด...',
    products: 'สินค้า',
    ask_questions: 'เขียนคำถามของคุณที่นี่...',
    course_information: 'ข้อมูลหลักสูตร',
    course_assistance: 'ความช่วยเหลือสำหรับผู้สร้างหลักสูตร',
    go_back: 'ย้อนกลับ',
    ai_generate_content_progress: 'กำลังสร้างเนื้อหา...',
    view_generate_content: 'ดูเนื้อหาที่สร้าง',
    generate_error: 'เกิดข้อผิดพลาดในการสร้างเนื้อหา!',
    confirm_creating_course: 'คุณต้องการสร้างหลักสูตรจากเนื้อหานี้ใช่หรือไม่?',
    generate_content_automatically:
      'ระบบจะเพิ่มเนื้อหาทั้งหมดเป็นบทเรียนและหน้าในหลักสูตรโดยอัตโนมัติ',
    quiz_created_successfully: 'สร้างแบบทดสอบเรียบร้อยแล้ว!',
    create_quiz: 'สร้างแบบทดสอบ',
    quiz_setting: 'การตั้งค่าแบบทดสอบ',
    please_fill_quiz_setting: '* กรุณากรอกการตั้งค่าแบบทดสอบให้ครบถ้วน',
    question_list: 'รายการคำถาม',
    add_quiz_to_page: 'เพิ่มแบบทดสอบในหน้า',
    form_create_question: 'แบบฟอร์มสร้างคำถาม',
    user_information_updated: 'อัปเดตข้อมูลผู้ใช้เรียบร้อยแล้ว!',
    your_stripe_activete_to_continue:
      'บัญชี Stripe ของคุณยังไม่เปิดใช้งาน กรุณาเชื่อมต่อหรือเปิดใช้งานเพื่อดำเนินการต่อ',
    connect_tripe: 'เชื่อมต่อ Stripe',
    certificate_sent_sucessfully: 'ส่งใบรับรองไปยังอีเมลของคุณเรียบร้อยแล้ว',
    error_try_again: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!',
    error_delete_channel: 'เกิดข้อผิดพลาดขณะลบช่อง',
    error_update_sub: 'ไม่สามารถอัปเดตรายการสมัครสมาชิกได้',
    end_time_cannot_start: 'เวลาสิ้นสุดไม่สามารถน้อยกว่าเวลาเริ่มต้นได้',
    start_date_time_interval: 'ต้องระบุวันที่และเวลาเริ่มต้น!',
    podcast_updated_successful: 'อัปเดตพอดแคสต์เรียบร้อยแล้ว',
    podcast_created_successful: 'สร้างพอดแคสต์เรียบร้อยแล้ว',
    podcast_published_successful: 'เผยแพร่พอดแคสต์เรียบร้อยแล้ว',
    podcast_cover_updated: 'อัปเดตภาพหน้าปกพอดแคสต์แล้ว',
    new_podcast_details: 'จะสร้างพอดแคสต์ใหม่ด้วยรายละเอียดใหม่',
    current_update_podcast: 'อัปเดตพอดแคสต์ปัจจุบัน (รวมถึงเพลงและเนื้อหา)',
    create_new_podcast: 'สร้างพอดแคสต์ใหม่',
    publish_podcast_public_view: 'เผยแพร่พอดแคสต์ให้บุคคลทั่วไปเห็น',
    only_allowed_twenty_five_email: 'สามารถป้อนได้สูงสุด 25 อีเมลเท่านั้น',
    only_allowed_five_email: 'สามารถป้อนได้สูงสุด 5 อีเมลเท่านั้น',
    cover_is_required: 'จำเป็นต้องมีภาพหน้าปก',
    topic_is_required: 'จำเป็นต้องระบุหัวข้อ',
    delete_schedule: 'ลบกำหนดการ',
    make_as_coaching: 'เปลี่ยนเป็นเซสชันการฝึกสอน',
    manage_category: 'จัดการหมวดหมู่',
    threshold: 'เกณฑ์',
    threshold_popup: 'เปอร์เซ็นต์การแนะนำสำหรับหมวดหมู่ที่เลือก (%)',
    list_of_catagory: 'รายการหมวดหมู่',
    category_name: 'ชื่อหมวดหมู่',
    category_threshold: 'เกณฑ์ของหมวดหมู่',
    play_game: 'เล่นเกม',
    switching_organization: 'กำลังเปลี่ยนองค์กร...',
    coaching_session: 'เซสชันการฝึกสอน',
    required_channel_id: 'ต้องระบุ Channel ID!',
    error_occured_try_again: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!',
    please_complete_marketplace_form:
      'กรุณากรอกแบบฟอร์ม Marketplace ให้ครบถ้วน!',
    upload_file_corrupt: 'ไฟล์ที่อัปโหลดเสียหาย',
    course_not_published: 'หลักสูตรนี้ยังไม่ได้เผยแพร่!',
    error_request: 'เกิดข้อผิดพลาดในการร้องขอ กรุณาลองอีกครั้ง!',
    skill_request: 'กรุณากรอกข้อมูลที่จำเป็น!',
    error_occured: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!',
    show_time: 'แสดงเวลา',
    start_time: 'เวลาเริ่มต้น',
    end_time: 'เวลาสิ้นสุด',
    room_name: 'ชื่อห้องพอดแคสต์',
    add_guest_speaker: 'เพิ่มวิทยากรรับเชิญ',
    cover_picture: 'ภาพหน้าปก',
    guest_speaker: 'วิทยากรรับเชิญ',
    see_more: 'ดูเพิ่มเติม',
    see_less: 'ดูน้อยลง',
    background: 'พื้นหลัง',
    icon: 'ไอคอน',
    icon_size: 'ขนาดไอคอน',
    icon_color: 'สีไอคอน',
    only_text: 'ข้อความเท่านั้น',
    change_bg: 'เปลี่ยนสีพื้นหลัง',
    bg_color: 'สีพื้นหลัง',
    font_size: 'ขนาดตัวอักษร',
    normal: 'ปกติ',
    change_color: 'เปลี่ยนสีข้อความ',
    slant_text: 'เอียงข้อความ',
    text_radius: 'ความโค้งของข้อความ',
    vertical_align: 'จัดเรียงแนวตั้ง',
    horizontal_align: 'จัดเรียงแนวนอน',
    change_icon_color: 'เปลี่ยนสีไอคอน',
    upload_icon: 'อัปโหลดไอคอน',
    upload_signature: 'อัปโหลดลายเซ็น',
    add_another_sign: 'เพิ่มลายเซ็นอีกอัน',
    name_badges: 'ป้ายชื่อ',
    should_less_150: 'ต้องไม่เกิน 150 ตัวอักษร',
    your_badge: 'ป้ายของคุณ',
    do_you_want_delete_badge: 'คุณต้องการลบป้ายนี้หรือไม่?',
    do_you_want_delete_cert: 'คุณต้องการลบใบรับรองนี้หรือไม่?',
    upload_logo: 'อัปโหลดโลโก้',
    name_of_cert: 'ชื่อใบรับรอง',
    upload_cert: 'อัปโหลดใบรับรอง',
    your_cert: 'ใบรับรองของคุณ',
    translate_to: 'แปลเป็น',
    select_file_attach: 'เลือกไฟล์แนบ',
    certificate: 'ใบรับรอง',
    badge: 'ป้าย',
    publish_options: 'ตัวเลือกการเผยแพร่',
    publish_skills_journey: 'เผยแพร่เส้นทางทักษะ',
    videos: 'วิดีโอ',
    generate_ai_video:
      'การสร้างวิดีโอด้วย AI อาจใช้เวลา จะมีการแจ้งเตือนทางอีเมลเมื่อเสร็จสิ้น',
    trainer_information: 'ข้อมูลผู้ฝึกสอน',
    promotional_video_link: 'ลิงก์วิดีโอโฆษณา',
    please_select: 'กรุณาเลือก',
    image_name: 'ชื่อภาพ:',
    image_size: 'ขนาดภาพ:',
    charecters_fifteen_less: 'ไม่เกิน 15 ตัวอักษร',
    leadership: 'ภาวะผู้นำ',
    text_arc: 'ข้อความโค้ง',
    vertical: 'แนวตั้ง',
    horizontal: 'แนวนอน',
    badge_history: 'ประวัติป้าย',
    templates: 'เทมเพลต',
    sign: 'ลายเซ็น',
    logo: 'โลโก้',
    certificate_history: 'ประวัติใบรับรอง',
    please_wait: 'กรุณารอสักครู่...',
    information: 'ข้อมูล',
    support_five_thousand_live_event:
      'รองรับผู้เข้าร่วมกิจกรรมสดได้สูงสุด 5000 คน',
    support_ten_live_event: 'รองรับผู้เข้าร่วมกิจกรรมวิดีโอสดได้ 10 คน',
    we_will_back_participant: 'เราจะกลับมาพร้อมกับจำนวนผู้เข้าร่วมที่มากขึ้น',
    course_objectives: 'วัตถุประสงค์ของหลักสูตร',
    course_outlines: 'โครงร่างหลักสูตร',
    price_dollor: 'ราคา (USD)',
    not_completed: 'ยังไม่เสร็จ',
    enable_marketplace: 'เปิดใช้งาน Marketplace',
    enable_course_ai: 'เปิดใช้งานการสร้างหลักสูตรด้วย AI',
    enable_report_to_admin: 'เปิดใช้งานรายงานถึงผู้ดูแลระบบ',
    enable_white_label: 'เปิดใช้งาน White Label',
    enable_eleven_labs_for_maze_play: 'เปิดใช้งาน Elevenlabs สำหรับ Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'เปิดใช้งาน Elevenlabs สำหรับเสียงที่คัดลอก',
    simulation_quiz: 'แบบทดสอบจำลอง',
    bg_color_setting: 'การตั้งค่าสีพื้นหลัง',
    color_preview: 'ตัวอย่างสี',
    choose_new_color: 'เลือกสีใหม่',
    remove_color: 'ลบสี',
    apply_color: 'ใช้สี',
    elemeent_in_a_sceenario_page:
      'ไม่สามารถเพิ่มองค์ประกอบอื่นในหน้านี้ได้ กรุณาเลือกหน้าอื่นหรือลบองค์ประกอบที่มีอยู่',
    no_data_found: 'ไม่พบข้อมูล',
    references: 'การอ้างอิง',
    open_file: 'เปิดไฟล์',
    showing_result: 'กำลังแสดงผลลัพธ์:',
    fiften_day_free_trail: 'ทดลองใช้ฟรี 15 วัน',
    your_browser_does_not_support: 'เบราว์เซอร์ของคุณไม่รองรับแท็กเสียงนี้',
    podcast_desc: 'คำอธิบายพอดแคสต์',
    input_podcast_desc: 'กรุณากรอกคำอธิบายพอดแคสต์',
    podcast_obj: 'วัตถุประสงค์ของพอดแคสต์',
    input_podcast_obj: 'กรุณากรอกวัตถุประสงค์ของพอดแคสต์',
    podcast_outline: 'โครงร่างพอดแคสต์',
    input_podcast_outline: 'กรุณากรอกโครงร่างพอดแคสต์',
    add_file: 'เพิ่มไฟล์',
    generate_podcast_audio: 'สร้างเสียงพอดแคสต์',
    generate_uploaded_file_input_parameter:
      'สร้างเนื้อหาตามไฟล์ที่ผู้ใช้อัปโหลดและพารามิเตอร์ที่ระบุ',
    go_backe_generation_state: 'กลับไปยังสถานะการสร้างเนื้อหา',
    create_ai_powered_podcast: 'สร้างตอนพอดแคสต์ด้วย AI ที่มีเสียงอัตโนมัติ',
    generate_voice_for_all_podcast: 'กรุณาสร้างเสียงสำหรับตอนพอดแคสต์ทั้งหมด',
    create_podcast_episode: 'สร้างตอนพอดแคสต์',
    voice_name: 'ชื่อเสียง',
    input_custom_name: 'กรุณากรอกชื่อที่กำหนดเอง!',
    enter_custom_name: 'ป้อนชื่อเสียงที่กำหนดเอง',
    upload_complete: 'อัปโหลดเสร็จสิ้น',
    uploading_in_progress: 'กำลังอัปโหลด...',
    podcast_stream_content: 'สตรีมเนื้อหาพอดแคสต์',
    upload_podcast_cover: 'กรุณาอัปโหลดปกพอดแคสต์!',
    enter_podcast_name: 'กรุณากรอกชื่อพอดแคสต์!',
    podcast_topic: 'หัวข้อพอดแคสต์',
    enter_podcast_topic: 'กรุณากรอกหัวข้อพอดแคสต์!',
    enter_podcast_desc: 'กรุณากรอกคำอธิบายพอดแคสต์!',
    number_of_speaker: 'จำนวนผู้พูด',
    select_the_number_of_speaker: 'กรุณาเลือกจำนวนผู้พูด!',
    number_of_episode: 'จำนวนตอน',
    input_number_of_episode: 'กรุณากรอกจำนวนตอน!',
    podcast_length: 'ความยาวพอดแคสต์',
    select_the_podcast_length: 'กรุณาเลือกความยาวของพอดแคสต์!',
    short_podcast: 'สั้น (5-10 นาที)',
    medium_podcast: 'กลาง (15-18 นาที)',
    long_podcast: 'ยาว (18+ นาที)',
    name_of_host: 'ชื่อโฮสต์',
    enter_host_name: 'กรุณากรอกชื่อโฮสต์!',
    guest_name: 'ชื่อแขกรับเชิญ',
    enter_guest_name: 'กรุณากรอกชื่อแขกรับเชิญ!',
    choose_speaker_tone: 'เลือกโทนเสียงผู้พูด',
    enter_speaker_tone: 'กรุณาเลือกโทนเสียงของพอดแคสต์!',
    informal: 'ไม่เป็นทางการ',
    formal: 'เป็นทางการ',
    serious: 'จริงจัง',
    light_humor: 'ตลกเบาๆ',
    casual: 'สบายๆ',
    select_content_source: 'เลือกแหล่งเนื้อหา',
    from_internet: 'จากอินเทอร์เน็ต',
    upload_pdf_internet: 'อัปโหลด PDF หรือเอกสารภายใน',
    note: 'หมายเหตุ:',
    podcast_content_will_be_automatically_generated:
      'เนื้อหาพอดแคสต์จะถูกสร้างโดยอัตโนมัติโดยใช้แหล่งข้อมูลจากอินเทอร์เน็ตที่เชื่อถือได้',
    upload_or_select_file: 'กรุณาอัปโหลดหรือเลือกไฟล์!',
    podcast_eposode_title: 'ชื่อตอนพอดแคสต์',
    enter_podcast_title: 'กรุณากรอกชื่อตอน!',
    podcast_episode_des: 'คำอธิบายตอนพอดแคสต์',
    enter_podcast_episode_des: 'กรุณากรอกคำอธิบายตอน!',
    voice: 'เสียง',
    music: 'ดนตรี',
    select_music: 'เลือกเพลง',
    play_the_music: 'เล่นเพลง',
    stop_the_music: 'หยุดเพลง',
    context: 'บริบท',
    generate_audio_content_selected_voice:
      'ระบบจะสร้างเสียงจากเนื้อหาโดยใช้เสียงที่เลือกไว้',
    required_field_before_submitting: 'กรุณากรอกข้อมูลที่จำเป็นให้ครบก่อนส่ง',
    regenerate_voice: 'สร้างเสียงใหม่',
    generate_voice: 'สร้างเสียง',
    your_browser_does_not_suppot: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นเสียง',
    are_sure_leave_podcast: 'คุณแน่ใจหรือไม่ว่าจะออกจากพอดแคสต์?',
    broadcast_ongoing: 'กำลังออกอากาศอยู่ คุณแน่ใจหรือไม่ว่าจะออกจากหน้านี้?',
    brodcaster_unavailable: 'ไม่สามารถใช้งานผู้ถ่ายทอดได้ในขณะนี้',
    setting_calender_for_booking: 'ตั้งค่าปฏิทินสำหรับการจอง',
    add_calender: 'เพิ่มปฏิทิน',
    waiting_join_host: 'รอให้โฮสต์เข้าร่วม...',
    no_reviews_found: 'ไม่พบรีวิว',
    rated_already: 'คุณได้ให้คะแนนกิจกรรมนี้แล้ว',
    downlink_png: 'ดาวน์โหลด PNG',
    downlink_jpg: 'ดาวน์โหลด JPG',
    donwload_file_format: 'กรุณาเลือกประเภทไฟล์ที่ต้องการดาวน์โหลด',
    crashed_event: 'กิจกรรมนี้ล่ม กรุณาสร้างกิจกรรมใหม่ ขออภัยในความไม่สะดวก',
    prompt: 'พรอมต์:',
    generated_image: '🚀 กำลังสร้างภาพของคุณ... กรุณารอสักครู่',
    download_add: 'ดาวน์โหลดทั้งหมด',
    setting_generator: 'ตั้งค่าการสร้าง',
    enter_image_prompt: 'กรุณากรอกคำสั่งสำหรับภาพ',
    image_prompt: 'กรอกคำสั่งภาพ',
    negative_prompt: 'คำสั่งเชิงลบ',
    negative_image_prompt: 'กรอกคำสั่งภาพเชิงลบ',
    number_output: 'จำนวนผลลัพธ์',
    enter_number_output: 'กรุณากรอกจำนวนผลลัพธ์',
    image_style: 'กรุณาเลือกสไตล์ของภาพ',
    output_format: 'รูปแบบผลลัพธ์',
    seeds: 'ซีด',
    enter_seeds: 'กรุณากรอกจำนวนซีด',
    performance_mode: 'โหมดประสิทธิภาพ',
    quality: 'คุณภาพ',
    speed: 'ความเร็ว',
    balanced: 'สมดุล',
    guidance_scale: 'ระดับคำแนะนำ',
    enter_guidance: 'กรุณากรอกระดับคำแนะนำ',
    select_image: 'กรุณาเลือกภาพ',
    image_prmt: 'คำสั่งภาพ',
    generate_image_list_empty: 'รายการภาพที่สร้างว่างเปล่า',
    knowledge_center_tooltrip_des:
      'รับคำตอบสั้น กระชับ และตรงตามบริบทสำหรับคำถามทั่วไป โดยใช้ข้อมูลจาก AI ที่ฝึกฝนด้วยข้อความจากอินเทอร์เน็ตที่หลากหลาย',
    contexts: 'บริบท',
    ai_processing_video_sharebot:
      'การประมวลผลวิดีโอโดย AI จะใช้เวลาประมาณ 24 ชั่วโมงก่อนจะแสดงผลบน Sharebot',
    remove_sharebot_video:
      'หากคุณต้องการลบการอ้างอิงวิดีโอกับ Sharebot กรุณาลบสคริปต์และวิดีโอที่เกี่ยวข้อง',
    remove_sharebot_video_audio:
      'การลบสคริปต์จะลบการอ้างอิงวิดีโอ/เสียงจาก Sharebot แต่วิดีโอยังคงแสดงในไลบรารีสื่อ/ช่อง',
    monthly_live_stream:
      'หากต้องการเปลี่ยนขีดจำกัดสตรีมแบบถ่ายทอดสดรายเดือน โปรดติดต่อ',
    monthly_transcribe_limit:
      'หากต้องการเปลี่ยนขีดจำกัดการถอดเสียงรายเดือน โปรดติดต่อ',
    must_be_one_to_three_hundred: 'ต้องอยู่ระหว่าง 1 ถึง 300 นาที',
    all_field_required: 'ต้องกรอกทุกช่อง',
    duration_minute: 'ระยะเวลา (สูงสุด 300 นาที)',
    gender: 'เพศ',
    select_gender: 'เลือกเพศ',
    accent: 'สำเนียง',
    select_accent: 'เลือกสำเนียง',
    create_voice: 'สร้างเสียง',
    enter_voice_name: 'กรอกชื่อเสียง',
    select_voice_gender: 'กรุณาเลือกเพศของเสียง',
    upload_voice: 'อัปโหลดเสียงของคุณ',
    upload_voice_mp_three: 'อัปโหลดเสียงของคุณ (.mp3)',
    cloned_voice: 'เสียงที่โคลนไว้',
    voice_type: 'ประเภทเสียง',
    select_voice_type: 'เลือกประเภทเสียง',
    sharelook_stand: 'มาตรฐาน',
    sharelook_premium: 'พรีเมียม',
    sharelook_custum_voice: 'กำหนดเอง (โคลนเสียง)',
    create_auto_flow: 'สร้างกระบวนการอัตโนมัติ',
    how_many_layers: 'จำนวนเลเยอร์',
    verify_selection: 'ยืนยันการเลือก',
    uploaded_successful: 'อัปโหลดสำเร็จ',
    upload_failed: 'อัปโหลดล้มเหลว',
    upload_only_five_mb: 'อัปโหลดไฟล์ PDF ได้สูงสุด 5 ไฟล์',
    docs_from_org_library: 'ใช้เอกสารจากคลังขององค์กร',
    failed_maze_generate: 'สร้างเมซไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    generate_metamaze: 'กำลังสร้าง MetaMaze...',
    metamaze_being_generated:
      'ระบบกำลังสร้าง MetaMaze ของคุณ จะมีการแจ้งเตือนทางอีเมลเมื่อเสร็จสิ้น',
    metamaze_generate_successfully: 'สร้าง MetaMaze สำเร็จแล้ว!',
    metamaze_with_proceed: 'คุณสามารถดำเนินการต่อกับ MetaMaze ได้แล้ว',
    ai_metamaze_generate: 'การสร้าง MetaMaze ด้วย AI',
    what_kind_maze_create: 'คุณต้องการสร้างเมซประเภทใด?',
    manual_metamaze_creation: 'สร้าง MetaMaze ด้วยตนเอง',
    manually_maze_customizing_scnario:
      'สร้างเมซด้วยตนเองโดยกำหนดสถานการณ์และตัวเลือก',
    maze_ai_generated: 'สร้างเมซอัตโนมัติด้วย AI',
    unmark_deadend: 'ยกเลิกการทำเครื่องหมายเป็นทางตัน',
    mark_deadend: 'ทำเครื่องหมายเป็นทางตัน',
    select_multiple_image_for_scenario:
      'คุณสามารถเลือกภาพได้หลายภาพสำหรับสถานการณ์',
    select_your_image: 'ภาพที่คุณเลือก',
    click_to_preview: 'คลิกเพื่อดูตัวอย่าง',
    are_you_sure_delete_image: 'คุณแน่ใจหรือไม่ว่าต้องการลบภาพนี้?',
    select_image_from_library: 'เลือกภาพจากคลังสื่อ',
    uploading_video: 'กำลังอัปโหลดวิดีโอ...',
    tree_node_type: 'ประเภทโหนดของแผนผัง',
    correct_option_scenario: 'ตัวเลือกหรือสถานการณ์ที่ถูกต้อง',
    incorrect_option: 'ตัวเลือกที่ไม่ถูกต้อง',
    option_scenario_without_text: 'ตัวเลือกหรือสถานการณ์ที่ไม่มีข้อความ',
    dead_end: 'ทางตัน (ขอบสีแดง)',
    correct_path: 'เส้นทางที่ถูกต้อง',
    incorrect_path_not_selected_correct_option_path:
      'เส้นทางผิด / ไม่มีตัวเลือกที่ถูกต้อง',
    double_click_on_tree_node:
      'เมื่อคุณดับเบิลคลิกที่โหนด ระบบจะแสดงข้อความของโหนดนั้นในมุมมองโดยอัตโนมัติ',
    add_scenario: 'เพิ่มสถานการณ์',
    add_option: 'เพิ่มตัวเลือก',
    an_error_occured: 'เกิดข้อผิดพลาด:',
    download_summary: 'ดาวน์โหลดสรุป',
    step_wise_analysis: 'วิเคราะห์ตามลำดับขั้นตอน',
    step: 'ขั้นตอน',
    upload_csv_file: 'อัปโหลดไฟล์ CSV',
    download_template_to_import: 'ดาวน์โหลดแม่แบบเพื่อนำเข้า',
    please_input_email: 'กรุณากรอกอีเมล',
    email_at_least_three_characters: 'อีเมลต้องมีอย่างน้อย 3 ตัวอักษร',
    email_cannot_be_empty: 'อีเมลไม่สามารถเว้นว่างได้',
    input_email_in_new_line: 'กรุณากรอกอีเมล (อีเมลละบรรทัด)',
    role: 'บทบาท',
    select_role: 'กรุณาเลือกบทบาท',
    select_group: 'กรุณาเลือกกลุ่ม',
    identification_number: 'หมายเลขประจำตัว (ไม่บังคับ)',
    add_identification_number: 'กรุณากรอกหมายเลขประจำตัว',
    pie_chart_of_all_categories:
      'แผนภูมิวงกลมของหมวดหมู่ทั้งหมดที่ใช้งานบน Sharelook',
    total_sharesphere_question_answered_by_users:
      'จำนวนคำถาม ShareSphere ที่ผู้ใช้ตอบภายในองค์กรนี้ พร้อมผลลัพธ์ที่สำเร็จและล้มเหลวในแต่ละหมวดหมู่',
    voice_style_over_the_text: `คุณสามารถเลือกสไตล์เสียงหลากหลายแบบเหนือข้อความที่พิมพ์ Lorem Ipsum เป็นข้อความตัวอย่างของอุตสาหกรรมการพิมพ์`,
    input_your_question: 'กรุณากรอกคำถามของคุณ!',
    make_me_sales_manager: 'เช่น: อะไรที่ทำให้ฉันเป็นผู้จัดการฝ่ายขาย',
    enter_the_number_relevant_document: 'กรอกจำนวนเอกสารที่เกี่ยวข้อง',
    please_wait_loading_result: 'กรุณารอ ข้อมูลกำลังโหลด...',
    no_result_found: 'ไม่พบผลลัพธ์ ลองถามใหม่อีกครั้ง',
    browser_doesnot_support_iframes: 'เบราว์เซอร์ของคุณไม่รองรับ iframes',
    total_duration: 'ระยะเวลารวม',
    number_of_messages: 'จำนวนข้อความ',
    search_result: 'ผลลัพธ์การค้นหา',
    count_result: '(1244 ผลลัพธ์)',
    your_other_interests: 'ความสนใจอื่น ๆ ของคุณ',
    your_total_score: 'คะแนนรวมของคุณ',
    add_a_question: '+เพิ่มคำถาม',
    travia_question_empty: 'ไม่มีคำถาม Travia',
    video_generation_is_on_queue: 'วิดีโอของคุณอยู่ในคิว!',
    checking_video_status: 'กำลังตรวจสอบสถานะวิดีโอ...',
    total_quizzes: 'แบบทดสอบทั้งหมด',
    number_of_votes: 'จำนวนการโหวต',
    total_events: 'กิจกรรมทั้งหมด',
    number_of_rates: 'จำนวนการให้คะแนน',
    number_of_likes: 'จำนวนการกดถูกใจ',
    all_courses: 'คอร์สทั้งหมด',
    total_questions: 'คำถามทั้งหมด',
    no_skill_journey: 'ไม่มีเส้นทางทักษะ!',
    search_no_results: '- ไม่มีผลลัพธ์!',
    no_image_generated: 'ไม่มีการสร้างภาพ!',
    all_topic_in_this_lesson:
      'หัวข้อทั้งหมดในบทเรียนนี้จะถูกลบ ไม่สามารถกู้คืนได้',
    content_has_been_generated: 'เนื้อหาถูกสร้างแล้วสำหรับหัวข้อนี้',
    update_course_template: 'อัปเดตแม่แบบคอร์ส',
    add_course_template: 'เพิ่มแม่แบบคอร์ส',
    create_course_now: 'สร้างคอร์สตอนนี้',
    preview_course: 'ดูตัวอย่างคอร์ส',
    layout: 'เค้าโครง',
    import_from_youtube: 'นำเข้าจาก YouTube',
    my_media_library: 'คลังสื่อของฉัน',
    bg_added: 'เพิ่มพื้นหลังแล้ว',
    add_bg: 'เพิ่มพื้นหลัง',
    booked_schedule: 'ตารางเวลาที่จองไว้',
    add_schedule: 'เพิ่มตารางเวลา',
    are_you_delete_schedule: 'คุณแน่ใจหรือไม่ว่าจะลบตารางเวลานี้?',
    add_task: 'เพิ่มงาน',
    update_calender: 'อัปเดตปฏิทิน',
    manage_cookies: 'จัดการคุกกี้',
    cookie_banner_text:
      'เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์การท่องเว็บของคุณ วิเคราะห์การเข้าชมเว็บไซต์ และปรับเนื้อหาให้เหมาะกับคุณ ความเป็นส่วนตัวของคุณสำคัญสำหรับเรา',
    accept_all_cookies: 'ยอมรับคุกกี้ทั้งหมด',
    reject_all: 'ปฏิเสธทั้งหมด',
    customize: 'ปรับแต่ง',
    cookie_preferences_title: 'การตั้งค่าคุกกี้และความเป็นส่วนตัว',
    privacy_subtitle:
      'ความเป็นส่วนตัวของคุณมีความสำคัญ เลือกคุกกี้ที่คุณยินดีใช้งาน คุณสามารถเปลี่ยนการตั้งค่าได้ทุกเวลา',
    save_choices: 'บันทึกตัวเลือกของฉัน',
    strictly_necessary: 'จำเป็นอย่างยิ่ง',
    strictly_necessary_desc:
      'คุกกี้เหล่านี้จำเป็นต่อการทำงานของเว็บไซต์ เช่น การนำทางในหน้า การส่งแบบฟอร์ม และการเข้าถึงพื้นที่ที่ปลอดภัย เว็บไซต์ไม่สามารถทำงานได้อย่างถูกต้องหากไม่มีคุกกี้เหล่านี้',
    analytics_performance: 'วิเคราะห์ & ประสิทธิภาพ',
    analytics_performance_desc:
      'คุกกี้เหล่านี้ช่วยให้เราเข้าใจว่าผู้เข้าชมมีปฏิสัมพันธ์กับเว็บไซต์อย่างไร โดยเก็บและรายงานข้อมูลอย่างไม่ระบุตัวตน ช่วยปรับปรุงประสิทธิภาพเว็บไซต์และประสบการณ์ผู้ใช้',
    advertising_marketing: 'โฆษณา & การตลาด',
    advertising_marketing_desc:
      'คุกกี้เหล่านี้ใช้เพื่อทำให้ข้อความโฆษณามีความเกี่ยวข้องกับคุณมากขึ้น ป้องกันไม่ให้โฆษณาเดิมปรากฏซ้ำและช่วยให้โฆษณาแสดงอย่างถูกต้องสำหรับผู้ลงโฆษณา',
    tracking_social: 'ติดตาม & โซเชียลมีเดีย',
    tracking_social_desc:
      'คุกกี้เหล่านี้ช่วยให้ฟีเจอร์และการปรับแต่งมีประสิทธิภาพ เช่น ฟีเจอร์โซเชียลมีเดียและเนื้อหาส่วนตัว อาจถูกตั้งโดยเรา หรือผู้ให้บริการภายนอก',
    functional: 'ฟังก์ชัน',
    functional_desc:
      'คุกกี้เหล่านี้ช่วยให้ฟังก์ชันเพิ่มเติมทำงานได้ เช่น แชทช่วยเหลือ สนับสนุนสด และฟีเจอร์โต้ตอบอื่น ๆ ที่ปรับปรุงประสบการณ์เว็บไซต์ของคุณ',
    your_rights: 'สิทธิของคุณ:',
    rights_description:
      'คุณสามารถถอนความยินยอมได้ทุกเวลา เข้าถึงข้อมูลของคุณ หรือร้องขอให้ลบข้อมูลได้ทุกเวลา',
    withdraw_consent: 'ถอนความยินยอมทั้งหมด',

    how_many_options: 'มีกี่ตัวเลือก',
    add_content: 'เพิ่มเนื้อหา',
    downloads_center: 'ศูนย์ดาวน์โหลด',
    sharelook_help_center: 'ศูนย์ช่วยเหลือ Sharelook',
    channel_outline: 'โครงร่างช่อง',
    channel_objectives: 'วัตถุประสงค์ของช่อง',
    no_sop_available: 'ไม่มีรายการ SOP',
    generate_world_summary: 'สร้างสถานการณ์',
    world_scenario: 'สถานการณ์โลกจริง',
    drag_icon_hint: 'เคล็ดลับ: ลากไอคอนบนผืนผ้าใบเพื่อตำแหน่ง',
    drag_text_hint: 'เคล็ดลับ: ลากข้อความบนผืนผ้าใบเพื่อตำแหน่ง',
    edit_badge: 'แก้ไขป้าย',
    create_new_badge: 'ป้ายใหม่',
    select_video_preview: 'เลือกวิดีโอเพื่อดูตัวอย่าง',
    certificate_title_required: 'จำเป็นต้องมีชื่อใบรับรอง',
    discard_changes: 'ยกเลิกการเปลี่ยนแปลง',
    edit_certificate: 'แก้ไขใบรับรอง',
    add_another_logo: 'เพิ่มโลโก้อื่น',
    optional: 'ไม่จำเป็น',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'สร้างภารกิจใหม่',
    quest_filter_title: 'ภารกิจ',
    sharelook_assistance: 'การช่วยเหลือ Sharelook',
    upload_scorm_zip: 'อัปโหลดไฟล์ SCORM Zip',
    only_letters_numbers_space_dot_allowed:
      'อนุญาตเฉพาะตัวอักษร ตัวเลข เว้นวรรค และจุดเท่านั้น!',
    video_playing: 'กำลังเล่น',
    course_price_message:
      '*คอร์สนี้จะเผยแพร่เฉพาะผู้ใช้งานภายในองค์กรเท่านั้น และไม่สามารถขายต่อบนตลาดได้',
    lesson_must_be_positive: 'จำนวนบทเรียนต้องมากกว่า 1',
    btn_proceed: 'ดำเนินการต่อ',
    rule_select_music: 'กรุณาเลือกเพลง',
    course_info: 'ข้อมูลคอร์ส',
    content_selection: 'การเลือกเนื้อหา',
    course_content_source: 'แหล่งเนื้อหาคอร์ส',
    choose_how_to_source: 'เลือกวิธีการจัดหาเนื้อหาสำหรับคอร์สนี้:',
    automatic_selection: 'เลือกอัตโนมัติ',
    system_will_automatically_select_relavant_documents:
      'ระบบจะเลือกเอกสารที่เกี่ยวข้องจากคลังของคุณโดยอัตโนมัติ',
    manual_selection: 'เลือกด้วยตนเอง',
    choose_specific_documents_from_your_library:
      'เลือกเอกสารเฉพาะจากคลังของคุณ',
    upload_files: 'อัปโหลดไฟล์',
    upload_new_documents:
      'อัปโหลดเอกสารใหม่ (PDF, DOC, DOCX, PPT, PPTX, TXT) - สูงสุด 5 ไฟล์',
    file: 'ไฟล์',
    ready_to_upload: 'พร้อมอัปโหลด',
    clear_all: 'ล้างทั้งหมด',
    confirm_course_wide_premiew: 'ยืนยันตัวอย่างคอร์สทั้งหมด',
    generate_course_preview: 'สร้างตัวอย่างคอร์ส',
    instructions_across_the_course_to_generate:
      'เราจะใช้คำแนะนำของคุณทั่วทั้งคอร์สเพื่อสร้างตัวอย่าง ตรวจสอบทุกอย่างก่อนแล้วตัดสินใจว่าจะเก็บหรือทิ้งการเปลี่ยนแปลง',
    instruction_to_preview_course_wide: 'คำแนะนำสำหรับตัวอย่างคอร์สทั้งหมด:',
    edit_content: 'แก้ไขเนื้อหา',
    manage_course_template: 'จัดการเทมเพลตคอร์ส',
    undo: 'เลิกทำ',
    apply_changes: 'ใช้การเปลี่ยนแปลง',
    characters: 'ตัวอักษร',
    apply_all: 'ใช้ทั้งหมด',
    apply_to_all: 'ใช้กับทั้งหมด',
    use_this_content: 'ใช้เนื้อหานี้',
    original: 'ต้นฉบับ',
    edited: 'แก้ไขแล้ว',
    edited_content_preview: 'ตัวอย่างเนื้อหาที่แก้ไข',
    apply_edits_to_all_topices: 'ใช้การแก้ไขกับทุกหัวข้อ?',
    current_editing_instructions_across_the_whole_course:
      'จะใช้คำแนะนำในการแก้ไขปัจจุบันของคุณทั่วทั้งคอร์ส คุณสามารถตรวจสอบตัวอย่างรวมก่อนบันทึก',
    edit_content_instructions: 'คำแนะนำในการแก้ไขเนื้อหา',
    generate_content_for_this_topic_instruction:
      'สร้างเนื้อหาสำหรับหัวข้อนี้โดยใช้คำแนะนำของคุณ',
    descrip_edit_content:
      'อธิบายวิธีแก้ไขเนื้อหานี้ (เช่น ย่อ, ทำให้ง่ายขึ้น, ปรับคำใหม่)',
    try_short_clear_direcctives:
      'ลองใช้คำสั่งสั้นและชัดเจน ตัวอย่าง: "ย่อเป็น 100 คำ เก็บประเด็นสำคัญ", "ทำให้ภาษาง่ายขึ้น", "ทำให้กระชับและลบส่วนเกิน"',
    we_preserve_the_core_meaning: 'เรารักษาความหมายหลักขณะใช้คำแนะนำของคุณ',
    feedback_optional: 'ข้อเสนอแนะ (ไม่บังคับ)',
    write_your_feedback_here: 'เขียนข้อเสนอแนะของคุณที่นี่',
    from_web: 'จากเว็บ',
    from_desktop: 'จากเดสก์ท็อป',
    pleae_wait_processing: 'กรุณารอขณะดำเนินการ...',
    create_simulation_from_screen_capture: 'สร้างการจำลองจากการจับภาพหน้าจอ',
    sharelook_not_found: 'ไม่พบ ShareLook',
    sharelook_screen_capture_application_not_be_opened:
      'ไม่สามารถเปิดแอปพลิเคชัน ShareLook Screen Capture ได้ อาจไม่ได้ติดตั้งบนคอมพิวเตอร์ของคุณ',
    download_sharelook: 'ดาวน์โหลด ShareLook',
    launch_sharelook_application: 'เปิดแอป ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'จะเปิดแอป ShareLook สำหรับจับภาพหน้าจอ',
    sharelook_dosenot_open:
      'หาก ShareLook ไม่เปิด อาจไม่ได้ติดตั้งบนคอมพิวเตอร์ของคุณ',
    open_sharelook: 'เปิด ShareLook',
    download_app: 'ดาวน์โหลดแอป',
    background_image_setting: 'การตั้งค่าภาพพื้นหลัง',
    current_image: 'ภาพปัจจุบัน',
    change_image: 'เปลี่ยนภาพ',
    remove_image: 'ลบภาพ',
    no_background_image_selected: 'ไม่ได้เลือกภาพพื้นหลัง',
    add_image: 'เพิ่มภาพ',
    this_will_open_for_screen_recording:
      'จะเปิดแอป ShareLook สำหรับบันทึกหน้าจอ',
    ai_image_generation: 'สร้างภาพด้วย AI',
    image_edit: 'แก้ไขภาพ',
    text_to_image: 'ข้อความเป็นภาพ',
    output_gallary: 'คลังผลลัพธ์',
    instant_generation: 'พร้อมสำหรับการสร้างทันที',
    prompt_and_unleash_the_power: 'ป้อนคำสั่งแล้วปลดปล่อยพลัง',
    use_this_image: 'ใช้ภาพนี้',
    error_generating: 'เกิดข้อผิดพลาดในการสร้าง',
    generation_tips: 'เคล็ดลับการสร้าง',
    detailed_descriptions_for_more_accurate_results:
      'ใช้คำอธิบายอย่างละเอียดเพื่อผลลัพธ์ที่แม่นยำยิ่งขึ้น',
    reference_image: 'ภาพอ้างอิง',
    select_pixel_image: 'เลือกภาพพิกเซล',
    max_mb: 'สูงสุด 50MB',
    please_enter_text_to_appear_image: 'กรุณาป้อนข้อความที่จะแสดงในภาพ',
    enter_text_to_apear_in_the_image: 'ป้อนข้อความที่จะปรากฏในภาพ',
    generate_image: 'สร้างภาพ',
    prompt_assistant: 'ผู้ช่วยคำสั่ง',
    generate_image_using_suggested_prompt: 'สร้างภาพโดยใช้คำสั่งที่แนะนำ',
    talk_to_ai_about_the_image_generate:
      'สนทนากับ AI เกี่ยวกับภาพที่คุณต้องการสร้าง',
    ask_for_prompt_suggestions: 'ขอคำแนะนำเกี่ยวกับคำสั่ง...',
    enter_a_search_term_to_find_stock_images: 'ป้อนคำค้นหาเพื่อค้นหาภาพสต็อก',
    choose_your_content_source: 'เลือกแหล่งเนื้อหาของคุณ:',
    upload_new_document_from_your_device: 'อัปโหลดเอกสารใหม่จากอุปกรณ์ของคุณ',
    automatic_library_selection: 'การเลือกคลังอัตโนมัติ',
    system_automatically_selects_relevant_document:
      'ระบบจะเลือกเอกสารที่เกี่ยวข้องโดยอัตโนมัติ',
    manual_library_selection: 'การเลือกคลังด้วยตนเอง',
    generate_content: 'สร้างเนื้อหา',
    add_to_current_page: 'เพิ่มไปยังหน้าปัจจุบัน',
    generate_bullet_points: 'สร้างหัวข้อย่อ',
    generating: 'กำลังสร้าง',
    this_may_take_a_few_moments: 'อาจใช้เวลาสักครู่',
    apply_to_page: 'ใช้กับหน้า',
    scenario_escription: 'คำอธิบายสถานการณ์:',
    feedback: 'ข้อเสนอแนะ',
    form_mode: 'โหมดฟอร์ม',
    chat_mode: 'โหมดแชท',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'สิ่งนี้จะสร้างการต่อเนื่องของเรื่องที่เลือกโดยใช้ AI',
    continue_this_story_question: 'ต้องการต่อเรื่องนี้หรือไม่?',
    continue_this_story: 'ต่อเรื่องนี้',
    what_will_happen: 'จะเกิดอะไรขึ้น:',
    the_ai_will_analyze_the_existing_story_content:
      'AI จะวิเคราะห์เนื้อหาเรื่องที่มีอยู่',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'สร้างการต่อเนื่องที่เป็นธรรมชาติซึ่งสอดคล้องกับโทนและสไตล์เดียวกัน',
    create_new_content_that_build_upon_the_current_narrative:
      'สร้างเนื้อหาใหม่ที่ต่อยอดจากเรื่องปัจจุบัน',
    this_process_may_take_a_few_moments_to_complete:
      'กระบวนการนี้อาจใช้เวลาสักครู่ในการดำเนินการ',
    no_existing_stories_found_for_this_course: 'ไม่พบเรื่องใดสำหรับหลักสูตรนี้',
    create_your_first_story: 'สร้างเรื่องแรกของคุณ',
    existing_stories: 'เรื่องที่มีอยู่',
    create_new_story: 'สร้างเรื่องใหม่',
    tone: 'โทน',
    style: 'สไตล์',
    genre: 'ประเภท',
    loading_your_stories: 'กำลังโหลดเรื่องของคุณ...',
    edit_story: 'แก้ไขเรื่อง',
    story_preferences: 'การตั้งค่าเรื่อง',
    please_input_your: 'กรุณากรอก',
    add_character_names_and_press_enter: 'เพิ่มชื่อตัวละครแล้วกด Enter',
    select_or_type_your: 'เลือกหรือพิมพ์ของคุณ',
    enter_your: 'กรอกของคุณ',
    position_of_the_story_in_the_lesson:
      'ตำแหน่งของเรื่องในบทเรียน เรื่องจะถูกเพิ่มเป็นบล็อกในตำแหน่งที่กำหนด',
    save_previous_content_on_the_pages: 'บันทึกเนื้อหาเดิมบนหน้า',
    the_existing_content_in_the_selected_pages:
      'เนื้อหาที่มีอยู่ในหน้าที่เลือกจะถูกแทนที่ด้วยเรื่องที่สร้างขึ้น',
    real_world_scenario: 'สถานการณ์ในโลกจริง',
    add_optional_instructions: 'เพิ่มคำแนะนำเสริม (โทน, ความยาว, ผู้ชม, ฯลฯ)',
    ready_to_enerate_your_real_world_scenario:
      'พร้อมสร้างสถานการณ์โลกจริงของคุณ',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'คลิก "สร้างสถานการณ์โลกจริง" เพื่อสร้างสถานการณ์ที่สมจริงตามเนื้อหาบทเรียนของคุณ',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI จะวิเคราะห์หัวข้อและเนื้อหาบทเรียนของคุณ',
    generate_a_practical_real_world_scenario:
      'สร้างสถานการณ์โลกจริงที่ใช้ได้จริง',
    you_can_then_edit_and_customize_the_result:
      'คุณสามารถแก้ไขและปรับแต่งผลลัพธ์ได้',

    add_it_as_a_new_page_to_your_lesson: 'เพิ่มเป็นหน้าบทเรียนใหม่ของคุณ',
    regenerate_with_instructions: 'สร้างใหม่พร้อมคำแนะนำ',
    add_real_world_scenario: 'เพิ่มสถานการณ์โลกจริง',
    generate_real_world_scenario: 'สร้างสถานการณ์โลกจริง',
    simulation_has_been_stopped: 'การจำลองถูกหยุดแล้ว!',
    loading_simulation: 'กำลังโหลดการจำลอง...',
    you_have_exhausted_all_the_attempts: 'คุณใช้ความพยายามทั้งหมดแล้ว',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'ศึกษาสถานการณ์ในหน้านี้และเลือกคำตอบที่ถูกต้องจากตัวเลือกด้านล่าง',
    attempts_limit_reached:
      'ถึงขีดจำกัดความพยายามแล้ว คุณสามารถเล่นอีกครั้งแต่คะแนนจะไม่ถูกบันทึก',
    play_again: 'เล่นอีกครั้ง',
    import_music_from_computer: 'นำเข้าเพลงจากคอมพิวเตอร์',
    more: 'เพิ่มเติม',
    no_badge_yet: 'ยังไม่มีเหรียญรางวัล',
    competition_filter: 'ตัวกรองการแข่งขัน',
    global_leaderboard: 'กระดานผู้นำโลก',
    placeholder_for_the_global_leaderboard: 'นี่คือตำแหน่งสำหรับกระดานผู้นำโลก',
    badge_editor: 'ตัวแก้ไขเหรียญรางวัล',
    adjust_the_appearance_of_this_badge_icon:
      'ปรับลักษณะของไอคอนเหรียญนี้ การเปลี่ยนแปลงใช้กับเหรียญนี้เท่านั้น',
    badge_style: 'สไตล์เหรียญ',
    the_image_must_be_pixels: 'รูปภาพต้องมีขนาด 200x200 พิกเซล',
    badge_name: 'ชื่อเหรียญ',
    badge_descrription: 'คำอธิบายเหรียญ',
    enter_badge_criteria: 'ป้อนเกณฑ์เหรียญ',
    discard: 'ยกเลิก',
    badge_enable: 'เปิดใช้งานเหรียญ',
    award_users_with_badges_to_highlight_the_milestones:
      'มอบเหรียญให้ผู้ใช้เพื่อเน้นความสำเร็จในเส้นทางการเรียนรู้',
    badge_types: 'ประเภทเหรียญ',
    enable_or_disable_specific_badge_types_for_your_users:
      'เปิดหรือปิดใช้งานประเภทเหรียญเฉพาะสำหรับผู้ใช้ของคุณ',
    levels_enabled: 'เปิดใช้งานระดับ',
    level_rules: 'กฎระดับ',
    points: 'คะแนน',
    add_new_level: 'เพิ่มระดับใหม่',
    add_level: 'เพิ่มระดับ',
    points_enabled: 'เปิดใช้งานคะแนน',
    learning_activities_and_encourage_healthy_competition:
      'มอบคะแนนสำหรับกิจกรรมการเรียนรู้ที่หลากหลายและส่งเสริมการแข่งขันที่ดี',
    award_points: 'มอบคะแนน',
    the_following_equates_the_value_of_one_item_completion:
      'ด้านล่างเทียบเท่ากับค่าของการทำรายการหนึ่งเสร็จสมบูรณ์',
    general: 'ทั่วไป',
    others: 'อื่น ๆ',
    certificate: 'ใบรับรอง',
    quiz_passed: 'ผ่านแบบทดสอบ',
    tip_approved: 'เคล็ดลับได้รับการอนุมัติ',
    tip_liked: 'เคล็ดลับถูกใจ',
    rewards: 'รางวัล',
    offer_discounts_when_learners_achieve:
      'เสนอส่วนลดเมื่อผู้เรียนทำคะแนน, เหรียญ หรือระดับครบตามที่กำหนด',
    give_rewards: 'ให้รางวัล',
    discount_course_purchases_by: 'ส่วนลดการซื้อคอร์สโดย',
    with_points_more_than: 'มีคะแนนมากกว่า',
    with_badges_more_than: 'มีเหรียญมากกว่า',
    with_level_upwards_more_than: 'มีระดับสูงกว่า',
    leaderboard: 'กระดานผู้นำ',
    leaderboard_enabled: 'เปิดใช้งานกระดานผู้นำ',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'กระดานผู้นำให้ภาพรวมความก้าวหน้าการเรียนรู้ของผู้ใช้เทียบกับผู้อื่น',
    show_levels: 'แสดงระดับ',
    show_points: 'แสดงคะแนน',
    show_badges: 'แสดงเหรียญ',
    show_courses: 'แสดงคอร์ส',
    show_certificates: 'แสดงใบรับรอง',
    leaderboard_settings: 'การตั้งค่ากระดานผู้นำ',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'ตั้งค่ากระดานผู้นำที่น่าสนใจเพื่อเพิ่มแรงจูงใจผู้เรียน',
    award_users_with_points_for_different_learning_activities:
      'มอบคะแนนสำหรับกิจกรรมการเรียนรู้ที่หลากหลาย',
    badge_set: 'ชุดเหรียญ',
    choose_the_type_of_badges_your_users:
      'เลือกประเภทเหรียญที่ผู้ใช้จะได้รับเมื่อเรียน',
    levels: 'ระดับ',
    Levels_represent_the_stages: 'ระดับแทนขั้นตอนในเส้นทางการเรียนรู้ของผู้ใช้',
    enabled: 'เปิดใช้งาน',
    disabled: 'ปิดใช้งาน',
    quick_select: 'เลือกด่วน',
    yesterday: 'เมื่อวาน',
    last_week: 'สัปดาห์ที่แล้ว',
    Last_month: 'เดือนที่แล้ว',
    last_quarter: 'ไตรมาสที่แล้ว',
    historical_leaderboard: 'กระดานผู้นำย้อนหลัง',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'ติดตามผลการทำงานของคุณและดูอันดับของคุณเทียบกับเพื่อน',
    time_period: 'ช่วงเวลา',
    page_of: 'หน้า 1 จาก 1',
    edit_competition: 'แก้ไขการแข่งขัน',
    create_competition: 'สร้างการแข่งขัน',
    arrow_right: 'ลูกศรขวา',
    update_competition: 'อัปเดตการแข่งขัน',
    competition_title: 'ชื่อการแข่งขัน',
    enter_competition_title: 'กรอกชื่อการแข่งขัน',
    enter_competition_description: 'กรอกคำอธิบายการแข่งขัน',
    leaderboard_skill: 'ทักษะ',
    select_a_skill: 'เลือกทักษะ',
    no_skills_found: 'ไม่พบทักษะ',
    competition_period: 'ช่วงการแข่งขัน',
    add_badge_rule: 'เพิ่มกฎเหรียญ',
    create_badge: 'สร้างเหรียญ',
    add_level_rule: 'เพิ่มกฎระดับ',
    selected_participants: 'ผู้เข้าร่วมที่เลือก',
    no_participants: 'ไม่มีผู้เข้าร่วม',
    start_end_date: 'วันที่เริ่ม–สิ้นสุด',
    created_date: 'สร้างโดย',
    new_competition: 'การแข่งขันใหม่',
    competitions_list: 'รายการการแข่งขัน',
    search_competitions: 'ค้นหาการแข่งขัน...',
    are_you_sure_you_want_to_delete_the_competition:
      'คุณแน่ใจหรือว่าต้องการลบการแข่งขันนี้?',
    history: 'ประวัติ',
    export: 'ส่งออก',
    search_by_name: 'ค้นหาตามชื่อ...',
    no_historical_data_available_for_the_selected_period:
      'ไม่มีข้อมูลย้อนหลังสำหรับช่วงเวลาที่เลือก',
    no_leaderboard_data_available: 'ไม่มีข้อมูลกระดานผู้นำ',
    competitions: 'การแข่งขัน',
    leaderboards: 'กระดานผู้นำ',
    welcome_back: 'ยินดีต้อนรับกลับ',
    track_your_performance_and_see: 'ติดตามผลการทำงานและดูอันดับของคุณ',
    team_leaderboard: 'กระดานผู้นำทีม',
    try_again: 'ลองอีกครั้ง',
    no_competitions_for_search: 'ไม่พบการแข่งขันสำหรับ',
    no_competitions_available: 'ไม่มีการแข่งขัน',
    no_competitions_matching_search:
      'ไม่พบการแข่งขันที่ตรงกับการค้นหาของคุณ ลองปรับคำค้นหาหรือกลับมาตรวจสอบใหม่',
    no_competitions_general:
      'ปัจจุบันยังไม่มีการแข่งขันตั้งค่าไว้ กรุณากลับมาตรวจสอบใหม่หรือ ติดต่อผู้ดูแลเพื่อสร้างการแข่งขันใหม่',
    media_management: 'จัดการสื่อ',
    badgess_set: 'ชุดเหรียญ',
    choose_the_default_visual_style_for_badge:
      'เลือกสไตล์ไอคอนเหรียญเริ่มต้นที่ใช้ทั่วแพลตฟอร์ม',
    enable_badges: 'เปิดใช้งานเหรียญ',
    add_badge: 'เพิ่มเหรียญ',
    min: 'ต่ำสุด',
    max: 'สูงสุด',
    your_rank: 'อันดับของคุณ',
    your_points: 'คะแนนของคุณ',
    your_level: 'ระดับของคุณ',
    rank: 'อันดับ #',
    level: 'ระดับ',
    progress: 'ความก้าวหน้า',
    new_folder: 'โฟลเดอร์ใหม่',
    file_upload: 'อัปโหลดไฟล์',
    writer: 'ผู้เขียน',
    text_documents: 'เอกสารข้อความ',
    spreadsheets: 'สเปรดชีต',
    impress: 'พรีเซนต์',
    presentations: 'งานนำเสนอ',
    capture_desktop_screen: 'จับภาพหน้าจอเดสก์ท็อป',
    capture_desktop_screens: 'จับภาพหน้าจอเดสก์ท็อปหลายจอ',
    your_documents: 'เอกสารของคุณ',
    manage_your_videos_images_audio_files:
      'จัดการวิดีโอ รูปภาพ ไฟล์เสียง และทรัพยากรอื่น ๆ ที่ใช้ในการสร้างเนื้อหาของคุณ',
    your_organization_documents: 'เอกสารขององค์กรคุณ',
    keep_your_organization_creative_assets_organized:
      'จัดการทรัพยากรสร้างสรรค์ขององค์กรให้เป็นระเบียบและเข้าถึงได้ง่าย—ช่วยให้การทำงานเป็นทีมและการสร้างเนื้อหาราบรื่น',
    your_public_documents: 'เอกสารสาธารณะของคุณ',
    curated_collection_of_media_assets_available:
      'คอลเลกชันสื่อที่คัดสรรพร้อมใช้สำหรับทุกคน—สำรวจ ใช้ซ้ำ และสร้างสรรค์',
    your_download_center_documents: 'เอกสารศูนย์ดาวน์โหลดของคุณ',
    repository_of_approved_media_assets_for_download:
      'แหล่งรวมสื่อที่ได้รับการอนุมัติสำหรับดาวน์โหลดและใช้งานในโปรเจกต์ของคุณ',
    search_files_and_folders: 'ค้นหาไฟล์และโฟลเดอร์..',
    home: 'หน้าหลัก',
    folders: 'โฟลเดอร์',
    folder_name: 'ชื่อโฟลเดอร์',
    owner: 'เจ้าของ',
    last_updated: 'อัปเดตล่าสุด',
    action: 'การดำเนินการ',
    no_folders_found: 'ไม่พบโฟลเดอร์',
    files: 'ไฟล์',
    enabling_ai: 'กำลังเปิดใช้งาน AI...',
    rename: 'เปลี่ยนชื่อ',
    copy: 'คัดลอก',
    move: 'ย้าย',
    verson_history: 'ประวัติรุ่น',
    manage_permission: 'จัดการสิทธิ์',
    generate_audit_report: 'สร้างรายงานตรวจสอบ',
    last_edited: 'แก้ไขล่าสุด',
    no_files_found: 'ไม่พบไฟล์',
    are_you_sure_you_want_to_make_this_item_public:
      'คุณแน่ใจหรือว่าต้องการทำรายการนี้เป็นสาธารณะ? มันจะถูกคัดลอกไปที่ห้องสมุดสาธารณะของคุณ',
    move_to_organization: 'ย้ายไปองค์กร',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'คุณแน่ใจหรือว่าต้องการคัดลอกรายการนี้ไปยังห้องสมุดองค์กรของคุณ?',
    are_you_sure_you_want_to_make_this_item_private:
      'คุณแน่ใจหรือว่าต้องการทำรายการนี้เป็นส่วนตัว? มันจะถูกคัดลอกไปที่ห้องสมุดของคุณ',
    date_modified: 'วันที่แก้ไข',
    workflow_management: 'การจัดการเวิร์กโฟลว์',
    configure_editors_approvers_and_viewers_for_this_document:
      'ตั้งค่า บรรณาธิการ ผู้อนุมัติ และผู้ชมสำหรับเอกสารนี้',
    error_Loading_editor: 'เกิดข้อผิดพลาดในการโหลดตัวแก้ไข',
    debug_info: 'ข้อมูลดีบัก',
    loading_editor: 'กำลังโหลดตัวแก้ไข...',
    submitted_for_review: 'ส่งเพื่อทบทวน',
    editors: 'บรรณาธิการ',
    no_editors_added_yet:
      'ยังไม่มีบรรณาธิการ คลิก "เพิ่มบรรณาธิการ" เพื่อเพิ่ม',
    add_editor: 'เพิ่มบรรณาธิการ',
    approvers: 'ผู้อนุมัติ',
    no_approvers_added_yet:
      'ยังไม่มีผู้อนุมัติ คลิก "เพิ่มผู้อนุมัติ" เพื่อเพิ่ม',
    add_approvers: 'เพิ่มผู้อนุมัติ',
    viewer: 'ผู้ชม',
    no_viewers_added_yet: 'ยังไม่มีผู้ชม คลิก "เพิ่มผู้ชม" เพื่อเพิ่ม',
    add_viewer: 'เพิ่มผู้ชม',
    are_you_sure_you_want_to_delete_the_selected_items:
      'คุณแน่ใจหรือว่าต้องการลบรายการที่เลือก?'
  },
  v3: {
    reportShareSphere: 'แชร์สเฟียร์',
    overview: 'ภาพรวมโพลความคิดเห็นทางสังคม',
    triviaReport: 'ShareSphere คำถามสนุกๆ',
    overviewGraph: 'กราฟภาพรวมสังคม',
    category: 'หมวดหมู่',
    phCategory: 'เลือกหมวดหมู่',
    podcast: 'พอดแคสต์ เพลง และเรื่องราว',
    pastPodcast: 'พอดแคสต์ที่ผ่านมา',
    upcomingPodcast: 'พอดแคสต์ที่กำลังจะมา',
    podcastLanguageTitle: 'ภาษาในพอดแคสต์ เพลง และเรื่องราว',
    podcastLanguageCheckbox: 'ใช้ AI สำหรับภาษาพอดแคสต์ของฉัน',
    howRate: 'คุณให้คะแนนพอดแคสต์นี้อย่างไร?',
    podcastSubmit: 'ส่ง',
    podcastGuest: 'แขกรับเชิญ:',
    podcastReview: 'รีวิว',
    podcastEpishode: 'ตอน',
    podcastEnd: 'พอดแคสต์สิ้นสุดแล้ว',
    date_podcast: 'วันที่ของพอดแคสต์',
    skill_not_found: 'ขออภัย! ไม่มีการเดินทางทักษะ',
    coaching: 'การโค้ช',
    webinar: 'สัมมนาออนไลน์',
    public_conference: 'การประชุมสาธารณะ',
    skill_journey_subtitle:
      'เลือกทักษะของคุณ และควบคุมว่าใครสามารถเห็นและติดต่อคุณได้',
    enable_white_label: 'เปิดใช้งานฉลากขาว',
    create_new_event_org: 'สร้างกิจกรรมใหม่สำหรับองค์กรของคุณ',
    create_new_event_marketplace: 'สร้างกิจกรรมใหม่สำหรับมาร์เก็ตเพลส',
    create_new_event_both: 'สร้างกิจกรรมใหม่สำหรับทั้งองค์กรและมาร์เก็ตเพลส',
    event_outline: 'ป้อนโครงร่างกิจกรรม',
    event_obj: 'ป้อนวัตถุประสงค์ของกิจกรรม',
    event_description: 'ป้อนคำอธิบายกิจกรรม',
    create_new_metamaze_org: 'สร้างเมตามาเซใหม่สำหรับองค์กรของคุณ',
    create_new_metamaze_marketplace: 'สร้างเมตามาเซใหม่สำหรับมาร์เก็ตเพลส',
    create_new_metamaze_both:
      'สร้างเมตามาเซใหม่สำหรับทั้งองค์กรและมาร์เก็ตเพลส',
    add_key_words: 'เพิ่มคำสำคัญ',
    press_enter_make_keyword: 'กด Enter เพื่อสร้างคำสำคัญ',
    disable_skip_quiz: 'ปิดใช้งานการข้ามแบบทดสอบ',
    warning_complete_quiz: 'กรุณาทำแบบทดสอบให้เสร็จเพื่อดำเนินการต่อ',
    signup_email_verification:
      'ลิงก์ยืนยันได้ถูกส่งไปยังอีเมลของคุณ กรุณาคลิกเพื่อตรวจสอบการลงทะเบียน',
    verifying_registration: 'กำลังตรวจสอบการลงทะเบียน...',
    reset_password_linK:
      'ลิงก์สำหรับรีเซ็ตรหัสผ่านได้ถูกส่งไปยังอีเมลของคุณ กรุณาคลิกเพื่อตั้งรหัสผ่านใหม่',
    reset_email_error:
      'ไม่พบบัญชีผู้ใช้งานที่ใช้กับอีเมลนี้ กรุณาลองชื่อผู้ใช้อื่น',
    first_name: 'ชื่อจริง',
    last_name: 'นามสกุล',
    error_firstName: 'กรุณาใส่ชื่อจริงของคุณ',
    error_sharebot_organization: 'กรุณาใส่ชื่อองค์กร',
    error_lastName: 'กรุณาใส่นามสกุลของคุณ',
    private_conference: 'การประชุมส่วนตัว',
    public_conference: 'การประชุมสาธารณะ',
    discussion_room: 'ห้องอภิปราย',
    training_no_courses: 'คุณยังไม่ได้เข้าร่วมหลักสูตรใดๆ',
    training_no_events: 'คุณยังไม่ได้เข้าร่วมกิจกรรมใดๆ',
    allow_sharing_trainer_info: 'อนุญาตแชร์อีเมลของผู้ฝึกในมาร์เก็ตเพลส',
    error_username_space: 'ชื่อผู้ใช้ไม่สามารถมีช่องว่างได้',
    error_sharebot_organization_space: 'ชื่อองค์กรไม่สามารถมีช่องว่างได้',
    edit_permission: 'สิทธิ์ในการแก้ไข',
    valid_price: 'ราคาต้องมากกว่า 0',
    course_price_message:
      '*หลักสูตรนี้ใช้ได้เฉพาะกับผู้ใช้ในองค์กรเท่านั้น และไม่สามารถขายในมาร์เก็ตเพลสได้',
    valid_edit_price: 'ราคาที่แก้ไขต้องน้อยกว่าราคาที่ซื้อ',
    my_calendar: 'ปฏิทินของฉัน',
    error_valid_firstName: 'กรุณาใส่ชื่อจริงที่ถูกต้อง',
    error_valid_organization: 'กรุณาใส่ชื่อองค์กรที่ถูกต้อง',
    error_valid_lastName: 'กรุณาใส่นามสกุลที่ถูกต้อง',
    error_name_spaces: 'ชื่อไม่สามารถมีช่องว่างได้',
    items: 'รายการ',
    publish_to_channel: 'เผยแพร่ในช่องของฉัน',
    create_a_channel: 'สร้างช่องของฉัน',
    create_a_trivia: 'สร้างคำถามสนุกๆ',
    create_a_new_channel: 'สร้างช่องใหม่',
    add_videos: 'เพิ่มวิดีโอ',
    save_and_continue: 'บันทึกและดำเนินการต่อ',
    channel: 'ช่อง',
    channels: 'ช่องทั้งหมด',
    view_channel: 'ดูช่อง',
    edit_channel: 'แก้ไขช่อง',
    delete_channel: 'ลบช่อง',
    my_video_channels: 'ช่องวิดีโอของฉัน',
    training_no_channel: 'คุณยังไม่ได้เข้าร่วมช่องใดเลย',
    monthly_price_required: 'ต้องกรอกราคาต่อเดือน',
    yearly_price_required: 'ต้องกรอกราคาต่อปี',
    one_time_price_required: 'ต้องกรอกราคาแบบจ่ายครั้งเดียว',
    marketplace_quantity: 'ปริมาณ',
    report_webinar: 'สัมมนาออนไลน์',
    report_coaching: 'การโค้ช',
    report_channel: 'ช่อง',
    report_public_conference: 'การประชุมสาธารณะ',
    report_maze: 'เขาวงกต',
    channel: 'ช่อง',
    edit_price: 'แก้ไขราคา ($)',
    quantity: 'จำนวน',
    payment_type: 'ประเภทการชำระเงิน',
    total_amount: 'ยอดรวม ($)',
    net_amount: 'ยอดสุทธิ ($)',
    edit_option: 'แก้ไขตัวเลือก',
    marketplace_price: 'ราคามาร์เก็ตเพลส ($)',
    market_name: 'ชื่อ',
    duration_min: 'ระยะเวลา (นาที)',
    users_total: 'ผู้ใช้ (รวม)',
    sales_total: 'ยอดขายรวม (USD)',
    search_coaching: 'ค้นหาการโค้ช',
    search_channel: 'ค้นหาช่อง',
    search_webinar: 'ค้นหาสัมมนาออนไลน์',
    search_maze: 'ค้นหาเขาวงกต',
    search_public_conference: 'ค้นหาการประชุมสาธารณะ',
    buyer_type: 'ประเภทผู้ซื้อ',
    quanity: 'จำนวน',
    channel_unit_amount: 'ยอดสุทธิ ($)',
    channel_updated_at: 'อัปเดตเมื่อ',
    month_price: 'ราคา (ต่อเดือน)',
    year_price: 'ราคา (ต่อปี)',
    one_time_price: 'ราคา (จ่ายครั้งเดียว)',
    sharebot_organization: 'ใส่ชื่อองค์กรใหม่ของคุณ',
    share_sphere: 'แชร์สเฟียร์',
    ai_course_title: 'ชื่อหลักสูตร',
    ai_input_course_title: 'กรุณากรอกชื่อหลักสูตร!',
    learning_objective_label: 'วัตถุประสงค์การเรียนรู้',
    learning_objective_message: 'กรุณากรอกวัตถุประสงค์การเรียนรู้!',
    standard_question: 'มีมาตรฐานที่นักเรียนต้องปฏิบัติตามหรือไม่?',
    standard_details_label: 'รายละเอียดมาตรฐาน',
    standard_details_message: 'กรุณากรอกรายละเอียดมาตรฐาน!',
    estimated_duration_label: 'ระยะเวลาโดยประมาณ (นาที)',
    estimated_duration_message: 'กรุณากรอกระยะเวลา!',
    min_duration_message: 'ระยะเวลาขั้นต่ำคือ 5 นาที',
    ai_mins: '25 นาที',
    industry_specific_question: 'เกี่ยวข้องกับอุตสาหกรรมเฉพาะหรือไม่?',
    industry_label: 'ระบุอุตสาหกรรม',
    industry_message: 'กรุณากรอกชื่ออุตสาหกรรม!',
    ai_course_creation: 'สร้างหลักสูตรด้วย AI',
    course_generated: 'หลักสูตรที่สร้างโดย Sharelook',
    ai: 'AI',
    ai_you: 'คุณ',
    ai_prompt_ready: 'คำขอของคุณพร้อมแล้ว ตอนนี้สามารถสร้างสารบัญได้',
    ai_unable_respond:
      'ขออภัย! ไม่สามารถตอบกลับคำขอของคุณได้ในขณะนี้ โปรดลองอีกครั้ง',
    ai_hide_toc: 'ซ่อนสารบัญ',
    ai_preview_toc: 'แสดงตัวอย่างสารบัญ',
    ai_generate_toc_now: 'สร้างสารบัญทันที',
    ai_creation_course_title: 'ชื่อหลักสูตร:',
    ai_creation_industry_specific: 'เกี่ยวข้องกับอุตสาหกรรม:',
    ai_creation_industry: 'อุตสาหกรรม:',
    ai_creation_standard_needed: 'มีมาตรฐานที่นักเรียนต้องปฏิบัติตามหรือไม่?:',
    ai_creation_standard_details: 'รายละเอียดมาตรฐาน:',
    ai_creation_estimated_duration: 'ระยะเวลาโดยประมาณ (นาที):',
    minutes: 'นาที',
    ai_creation_learning_objective: 'วัตถุประสงค์การเรียนรู้:',
    setup_again: 'ตั้งค่าใหม่อีกครั้ง',
    ai_creation_confirm_title: 'คุณต้องการตั้งค่านี้ใหม่หรือไม่?',
    ai_creation_confirm_content:
      'การสนทนาและเนื้อหาทั้งหมดที่สร้างขึ้นจะถูกรีเซ็ต',
    ai_toc: 'สารบัญ',
    ai_note_topic: 'หมายเหตุ: สามารถลากและวางหัวข้อภายในหลักสูตรได้',
    ai_add_topic: '+ เพิ่มหัวข้อ',
    add_topic: 'เพิ่มหัวข้อ',
    add_lesson: 'เพิ่มบทเรียน',
    add_new_lesson: 'เพิ่มบทเรียนใหม่',
    ai_add_lesson: '+ เพิ่มบทเรียน',
    attention: 'แจ้งเตือน',
    before_varifying: 'ก่อนการยืนยัน',
    ai_save_later: 'บันทึกไว้ภายหลัง',
    ai_download_word_doc: 'ดาวน์โหลดเอกสาร Word',
    ai_download_course_word_doc: 'ดาวน์โหลดหลักสูตรเป็นเอกสาร Word',
    ai_create_course_button: 'สร้างหลักสูตร',
    ai_generate_course_content: 'สร้างเนื้อหาหลักสูตร',
    ai_out_of: '/',
    ai_subtopic_failed_content:
      'ไม่สามารถสร้างเนื้อหาสำหรับบางหัวข้อย่อยได้ โปรดคลิก "สร้างเนื้อหาหลักสูตร" อีกครั้ง',
    ai_edit_topic: 'แก้ไขหัวข้อ',
    ai_edit_lesson_title: 'แก้ไขชื่อบทเรียน',
    ai_save_topic: 'บันทึกหัวข้อ',
    ai_save: 'บันทึก',
    ai_save_lesson_title: 'บันทึกชื่อบทเรียน',
    ai_add_new_topic: 'เพิ่มหัวข้อใหม่',
    ai_download_ref: 'ดาวน์โหลดพร้อมแหล่งที่มา',
    ai_download_ref_content:
      'หลักสูตรจะถูกดาวน์โหลดเป็นเอกสาร Word พร้อมแหล่งที่มา',
    ai_download_without_ref: 'ดาวน์โหลดโดยไม่มีแหล่งที่มา',
    ai_download_two_word: 'ดาวน์โหลดเอกสาร Word สองฉบับ:',
    ai_download_two_word_content_one:
      '- หนึ่งฉบับมีเฉพาะเนื้อหา (ไม่มีแหล่งที่มา),',
    ai_download_two_word_content_two: 'อีกฉบับมีเฉพาะแหล่งที่มา (ไม่มีเนื้อหา)',
    ai_manage_content: 'จัดการเนื้อหา',
    ai_add_content_from_internet: '+ เพิ่มเนื้อหาจากอินเทอร์เน็ต',
    ai_confirm_start: 'ยืนยันเพื่อเริ่มต้น',
    ai_Verify: 'ยืนยัน',
    ai_undo_warning:
      'ขั้นตอนนี้อาจใช้เวลาสักครู่ โปรดอย่าปิดหน้าต่างนี้ระหว่างดำเนินการ ไม่สามารถย้อนกลับได้',
    ai_verified_content:
      'คุณได้ยืนยันเนื้อหาแล้ว ตอนนี้ไม่สามารถเข้าถึงการสนทนา AI ได้',
    ai_want_proceed: 'คุณต้องการดำเนินการต่อหรือไม่?',
    upload_simulation: 'อัปโหลดการจำลอง',
    name_simulation: 'ตั้งชื่อการจำลอง',
    selected_simulation_files: 'ไฟล์การจำลองที่เลือก',
    score_between_one_hundred: 'คะแนนต้องอยู่ระหว่าง 1 ถึง 100',
    are_sure_simulation: 'คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์การจำลองนี้?',
    required_simulation: 'จำเป็นต้องมีคะแนน',
    required_section_file: 'จำเป็นต้องมีไฟล์ส่วน',
    simulation: 'การจำลอง',
    simulation_quiz_games: 'คำถามควรอยู่ในเกมแบบทดสอบ',
    simulation_alert_des:
      'สามารถเพิ่มเกมได้เฉพาะเมื่อคำถามทั้งหมดเป็นแบบตัวเลือกเดียวหรือหลายตัวเลือก',
    alert_info: 'ข้อมูล',
    ai_number_quiz: 'จำนวนคำถามแบบทดสอบ',
    ai_point: 'คะแนน',
    ai_points: 'คะแนน',
    val_required: 'จำเป็น',
    games: 'เกม',
    add_simulation: 'เพิ่มการจำลอง',
    text_tiewer: 'ดูข้อความ',
    back_to_account: 'กลับไปที่บัญชี',
    delete_account: 'ลบบัญชี',
    delete_account_title: 'คุณต้องการลบบัญชีของคุณหรือไม่?',
    delete_account_subtitle: 'คุณสามารถลบบัญชีของคุณได้ที่นี่',
    delete_account_cannot_undo:
      'คุณกำลังจะลบบัญชีของคุณ การกระทำนี้ไม่สามารถย้อนกลับได้',
    account_org_profile: 'บัญชี หลักสูตร และข้อมูลองค์กรทั้งหมดจะถูกลบ',
    deleting_account_database:
      'เมื่อบัญชีของคุณถูกลบ ข้อมูลทั้งหมดจะถูกลบออกจากระบบ',
    account_confirm_delete: 'คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีของคุณ?',
    action_cannot_be_undone: 'การกระทำนี้ไม่สามารถย้อนกลับได้',
    account_delete_message_success: 'ลบบัญชีของคุณเรียบร้อยแล้ว',
    message_edit: 'แก้ไข',
    message_delete: 'ลบ',
    message_reply: 'ตอบกลับ',
    attached_file: 'ไฟล์แนบ',
    attach_file: 'แนบไฟล์',
    attach_des: 'สูงสุด 25 MB',
    view: 'ดู',
    go_to_marketplace: 'ไปที่ตลาด',
    learning_center: 'ศูนย์การเรียนรู้',
    knowledge_center: 'ศูนย์ความรู้',
    sharebot: 'ShareBot',
    sharebot_help_message: 'วันนี้ฉันสามารถช่วยอะไรคุณได้บ้าง?',
    my_organization: 'องค์กรของฉัน',
    world_knowledge: 'ความรู้ทั่วโลก',
    welcome_to_sharelook: 'ยินดีต้อนรับสู่ Sharelook!',
    sharelook_you_want_go: 'วันนี้คุณต้องการไปที่ใด?',
    shareLook_learning_management_system:
      'เข้าถึงระบบการจัดการการเรียนรู้ของ ShareLook เพื่อสร้างและเข้าร่วมกิจกรรมสดและหลักสูตรในองค์กรของคุณ',
    shareLook_powerful_ai_system:
      'อัปโหลดเอกสาร PDF เพื่อดึงข้อมูลอย่างรวดเร็วด้วยระบบ AI อันทรงพลังของ ShareLook รับคำตอบจากความรู้ขององค์กรหรือความรู้ระดับโลก',
    edit_now: 'แก้ไขตอนนี้',
    sharelook_log_out:
      'คุณได้ออกจากระบบ Sharelook แล้ว กรุณาเข้าสู่ระบบอีกครั้ง!',
    sorry_error: 'ขออภัย! มีข้อผิดพลาดเกิดขึ้น',
    login: 'เข้าสู่ระบบ',
    refresh_page: 'รีเฟรชหน้า',
    just_a_moment: 'กรุณารอสักครู่',
    enter_lname_fname: 'กรุณากรอกชื่อและนามสกุลเพื่อดำเนินการต่อ',
    procced_to_sharelook: 'ไปยัง Sharelook',
    option_one: 'ตัวเลือกที่ 1',
    option_two: 'ตัวเลือกที่ 2',
    selected_image: 'ภาพที่เลือก:',
    add_text: 'เพิ่มข้อความ',
    linkdin_is_required: 'จำเป็นต้องมี LinkedIn',
    bio_is_required: 'จำเป็นต้องมีประวัติย่อ',
    save_user_information: 'บันทึกข้อมูลผู้ใช้',
    select_all: 'เลือกทั้งหมด',
    enable_ai: 'เปิดใช้งาน AI',
    load_more: 'โหลดเพิ่มเติม',
    channel_id: 'รหัสช่อง',
    send: 'ส่ง',
    v4: 'ข้อมูล',
    subscription: 'การสมัครสมาชิก',
    reset_user_flag: 'รีเซ็ตสถานะผู้ใช้',
    delete_my_accont: 'ลบบัญชีของฉัน',
    sharebot_sub_error:
      'เกิดข้อผิดพลาดในการรับการสมัครสมาชิก กรุณาลองใหม่อีกครั้ง!',
    sharebot_no_sub: 'ยังไม่มีการสมัครสมาชิก',
    sharebot_dont_sub: 'ไม่มีการสมัครสมาชิกก่อนหน้านี้',
    sharebot_prev_sub: 'การสมัครสมาชิกก่อนหน้า',
    sharebot_sub: 'การสมัครสมาชิก ShareBot',
    sharebot_un_sub: 'ยกเลิกการสมัครสมาชิก ShareBot',
    sharebot_no_available: 'ไม่มีข้อมูลให้ใช้งาน',
    sharebot_start_date: 'วันที่เริ่มต้น:',
    sharebot_end_date: 'วันที่สิ้นสุด:',
    sharebot_sure: 'คุณแน่ใจหรือไม่?',
    sharebot_do_you_want: 'คุณต้องการ',
    unsubscribe: 'ยกเลิกการสมัคร',
    unsubscribe_what: 'คุณต้องการยกเลิกการสมัครหรือไม่?',
    subscribe: 'สมัครสมาชิก',
    subscribe_what: 'คุณต้องการสมัครสมาชิกหรือไม่?',
    subscribe_now: 'สมัครตอนนี้',
    confirm: 'ยืนยัน',
    sharebot_intel_knowledge_center: 'ศูนย์ความรู้ของ ShareBot',
    sharebot_welcome_paragraph:
      'ยินดีต้อนรับสู่ศูนย์ความรู้ของ ShareBot ผู้ช่วย AI ที่ออกแบบมาเพื่อช่วยผู้เชี่ยวชาญในการเข้าถึงข้อมูลอย่างรวดเร็ว',
    expired: 'หมดอายุ',
    active: 'ใช้งานอยู่',
    Inactive: 'ไม่ใช้งาน',
    yearly_subscription: 'การสมัครสมาชิกรายปี',
    monthly_subscription: 'การสมัครรายเดือน',
    no_sharebot_org: 'คุณยังไม่มีองค์กรของ ShareBot',
    sharebot_start_free_trial: 'เริ่มทดลองใช้ฟรี',
    sub_month: 'สมัครรายเดือน',
    sub_year: 'สมัครรายปี',
    question_per_month: 'พื้นที่จัดเก็บข้อมูล (1TB) และ 1000 คำถามต่อเดือน',
    sharebot_para:
      'หากคุณดำเนินการต่อ คุณกำลังยืนยันที่จะลบองค์กรทันที การกระทำนี้จะส่งผลให้ข้อมูลเชิงลึกทั้งหมดที่ ShareBot จัดเตรียมไว้สูญหาย และไม่สามารถกู้คืนได้',
    cancelled_date: 'วันที่ยกเลิก:',
    live_straming_para:
      'หากคุณต้องการเปลี่ยนขีดจำกัดการถ่ายทอดสดรายเดือน โปรดติดต่อ',
    sharelook_agree: 'ฉันตกลงกับ',
    terms_condition: 'ข้อกำหนดและเงื่อนไข',
    and: 'และ',
    privacy_policy: 'นโยบายความเป็นส่วนตัว',
    save_for_later: 'บันทึกไว้เพื่อดูภายหลัง',
    ai: 'เอไอ',
    no_video_yet: 'ยังไม่ได้เลือกวิดีโอ!',
    are_you_sure_delete_video: 'คุณแน่ใจหรือไม่ว่าจะลบวิดีโอนี้?',
    video_des: 'คำอธิบาย',
    video_now: 'ตอนนี้',
    video_playing: 'กำลังเล่น:',
    video_no: 'วิดีโอเลขที่',
    ai_generated_course: 'หลักสูตรที่สร้างโดย AI',
    create_course_on_our_own: 'สร้างหลักสูตรด้วยตนเอง',
    ai_Assisted_ourse_reation: 'สร้างหลักสูตรโดยมี AI ช่วย',
    pending: 'รอดำเนินการ',
    published: 'เผยแพร่แล้ว',
    intro_course: 'ในหลักสูตรของคุณ?',
    clone_course: 'คุณต้องการโคลนหรือไม่',
    browser_audio_not_support: 'เบราว์เซอร์ของคุณไม่รองรับแท็กเสียง',
    audio_popup_content:
      'คุณสามารถใช้สไตล์เสียงต่าง ๆ เหนือข้อความที่พิมพ์ของคุณ Lorem Ipsum คือข้อความตัวอย่างมาตรฐานในอุตสาหกรรมการพิมพ์และการจัดหน้า',
    close: 'ปิด',
    podcast_rec: 'บันทึก',
    create_podcast: 'สร้างพอดแคสต์',
    add_admin: 'เพิ่มผู้ดูแลระบบ',
    delete_all: 'ลบทั้งหมด',
    ai_podcast_audio: 'เสียงพอดแคสต์ AI',
    language: 'ภาษา',
    podcast_download_content:
      '*ดาวน์โหลดไฟล์เสียง AI เพื่อนำไปแก้ไขเป็นไฟล์เสียงของคุณเอง',
    upload_audio: 'อัปโหลดเสียง',
    browser_do_not_support_audio: 'เบราว์เซอร์ของคุณไม่รองรับองค์ประกอบเสียง',
    upload_cover: 'อัปโหลดภาพปก',
    upload_ai_creator: 'ผู้สร้าง AI',
    required_cover_image: 'จำเป็นต้องมีภาพหน้าปก!',
    room_required_name: 'จำเป็นต้องมีชื่อพอดแคสต์!',
    add_guest_list: 'โปรดเพิ่มรายการแขกรับเชิญ!',
    podcast_add_participants: 'เพิ่มผู้เข้าร่วม',
    topic_required: 'จำเป็นต้องมีหัวข้ออย่างน้อยหนึ่งหัวข้อ',
    podcast_description: 'รายละเอียด',
    podcast_date: 'วันที่',
    date: 'วันที่',
    podcast_time: 'เวลา',
    podcast_to: 'ถึง',
    podcast_all_day: 'ทั้งวัน',
    podcast_start_date_time: 'ต้องมีวันและเวลาที่เริ่มต้น!',
    podcast_id: 'ID',
    selected_user: 'เชิญผู้ใช้ที่เลือก',
    see_more: 'ดูเพิ่มเติม',
    see_less: 'ดูน้อยลง',
    no_review_yet: 'ยังไม่มีรีวิว มาเป็นคนแรกที่รีวิวกันเถอะ',
    request_to_speak: 'ยอมรับคำขอจากผู้ใช้ให้พูดหรือไม่?',
    kick_user: 'ต้องการเตะผู้ใช้นี้หรือไม่?',
    accept_request: 'ยอมรับคำขอ',
    kick: 'เตะออก',
    started: 'เริ่มแล้ว',
    end: 'สิ้นสุด',
    join_now: 'เข้าร่วมตอนนี้',
    podcast_end: 'พอดแคสต์ได้สิ้นสุดลงแล้ว',
    connecting: 'กำลังเชื่อมต่อ...',
    knowledge_center_know_today: 'วันนี้คุณอยากรู้เรื่องอะไร?',
    knowledge_center_question: 'กรุณาใส่คำถามก่อน',
    knowledge_center_error: 'ขออภัย! เกิดข้อผิดพลาด',
    knowledge_center_tooltrip:
      'รับคำตอบจากแหล่งเรียนรู้ในองค์กรของคุณที่ ShareLook พร้อมการอ้างอิงและให้คุณดูตัวอย่างหรือดาวน์โหลดเอกสาร PDF',
    my_organization: 'องค์กรของฉัน',
    world_knowledge: 'ความรู้ทั่วโลก',
    open_file: 'เปิดไฟล์',
    reference: 'อ้างอิง',
    are_you_cancel: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิก?',
    are_you_remove_media: 'คุณแน่ใจหรือไม่ว่าต้องการลบสื่อ?',
    terms_agree: 'ฉันยอมรับสิ่งเหล่านี้',
    ready: 'พร้อม',
    send_email: 'ส่งอีเมล',
    active_users: 'ผู้ใช้ที่ใช้งานอยู่',
    sign_up_user: 'ผู้ใช้ที่ลงทะเบียน',
    non_sign_up_user: 'ผู้ใช้ที่ยังไม่ได้ลงทะเบียน',
    organisation: 'องค์กร',
    usage_report: 'รายงานการใช้งาน',
    check_email: 'ตรวจสอบอีเมลของคุณ',
    delete_schedule: 'ลบตารางเวลา',
    are_you_sure_delete_schedule: 'คุณแน่ใจหรือไม่ว่าจะลบตารางเวลานี้?',
    add_task: 'โปรดใส่ภารกิจ!',
    coaching_available: 'มาร์กเป็นพร้อมให้คำแนะนำ',
    message_booking_coaching: 'ช่วงเวลานี้ถูกจองไว้สำหรับการโค้ชโดยผู้ใช้',
    task_day: 'วันภารกิจ',
    created_task_day: 'คุณได้สร้างภารกิจสำหรับวันนี้แล้ว',
    event_day: 'วันจัดงาน',
    has_booked_coaching: 'มีการจองโค้ชในวันนี้',
    active_day: 'วันที่ใช้งานได้',
    selectable_time_slots: 'ช่วงเวลาที่เลือกได้ทางขวาถูกเปิดใช้งานสำหรับวันนี้',
    compare_last_month: 'เปรียบเทียบกับเดือนที่แล้ว',
    uploading_file: 'กำลังอัปโหลดไฟล์ของคุณ',
    attach_file_course: 'แนบกับหลักสูตรนี้',
    fetch_request: 'กำลังประมวลผลคำขอของคุณ',
    finilize_upload: 'กำลังกำหนดการอัปโหลด',
    scorm_scanned: 'โปรดรอสักครู่... กำลังสแกนไฟล์ SCORM ของคุณ',
    scan_status: 'สถานะการสแกน:',
    scan_completed: 'สแกนเสร็จสิ้น ขณะนี้ไฟล์ของคุณคือ',
    scan_progress: 'กําลังสแกน...',
    check_scorm: 'กำลังตรวจสอบรูปแบบไฟล์ SCORM... โปรดรอ',
    file_check_success: 'ตรวจสอบไฟล์เสร็จสมบูรณ์',
    file_check_progress: 'การตรวจสอบไฟล์กำลังดำเนินการ',
    scorm_not_upload:
      'ไฟล์ที่คุณอัปโหลดไม่เป็นไปตามมาตรฐาน SCORM 1.2 กรุณาอัปโหลดไฟล์ที่รองรับอีกครั้ง',
    select_question: 'ตัวเลือกคำตอบ (เลือกคำตอบที่ถูกต้องหนึ่งข้อ)',
    select_answer: 'กรุณาเลือกคำตอบ!',
    check_option_one: 'กรุณาใส่ตัวเลือกที่หนึ่ง!',
    check_option_two: 'กรุณาใส่ตัวเลือกที่สอง!',
    check_option_three: 'กรุณาใส่ตัวเลือกที่สาม!',
    check_option_four: 'กรุณาใส่ตัวเลือกที่สี่!',
    question_image: 'รูปภาพคำถาม',
    select_question_image: 'กรุณาเลือกรูปภาพคำถาม!',
    ans_image: 'รูปภาพคำตอบ',
    upload_image_question: 'อัปโหลดรูปคำตอบ',
    select_image_answer: 'กรุณาเลือกรูปภาพคำตอบ!',
    save_question: 'บันทึกคำถาม',
    do_you_leave: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้?',
    loose_all_progress: 'คุณจะสูญเสียความคืบหน้าทั้งหมด',
    welcome: 'ยินดีต้อนรับ',
    team_knowledge_quest: 'ภารกิจความรู้กลุ่ม',
    your_score: 'คะแนนของคุณ',
    start_playing: 'เริ่มเล่น',
    share_sphere_complete: 'ShareSphere เสร็จสมบูรณ์',
    final_score: 'คะแนนสุดท้าย',
    play_next: 'เล่นต่อไป',
    you_donot_access_event: 'คุณไม่สามารถเข้าถึงเหตุการณ์นี้ได้',
    ai_content_generated: 'มีการสร้างเนื้อหาสำหรับหัวข้อนี้แล้ว',
    ai_popup_confirm_content: 'ยืนยันการสร้างเนื้อหา',
    limit_transcribe_text:
      'เวลาที่เหลือสำหรับการถอดเสียง: <0>{{ transcribe_limit }}</0> นาที <1/><2/> <3>. หากต้องการเปลี่ยนขีดจำกัดการถอดเสียง โปรดติดต่อ </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'คุณไม่มีสิทธิ์เข้าถึงกิจกรรมนี้',
    ai_course_title_training: 'หลักสูตรการฝึกอบรมภาวะผู้นำ',
    ai_course_object: 'การนำทางความเป็นผู้นำในยุคดิจิทัล',
    create_ai_video: 'สร้างวิดีโอ AI',
    generate: 'สร้าง',
    video_generate_process:
      'กระบวนการสร้างวิดีโออาจใช้เวลาสักครู่ คุณจะได้รับอีเมลเมื่อเสร็จสิ้นแล้ว',
    stripe_account_connect:
      'บัญชี Stripe ของคุณยังไม่เปิดใช้งาน โปรดเชื่อมต่อหรือเปิดใช้งานเพื่อดำเนินการต่อ',
    ai_creator: 'ผู้สร้าง AI',
    check_video_status: 'กำลังตรวจสอบสถานะการสร้างวิดีโอ...',
    video_on_queue: 'วิดีโอกำลังอยู่ในคิวเพื่อสร้าง',
    video_fail_generation: 'ขออภัย การสร้างวิดีโอล้มเหลว กรุณาลองวิดีโออื่น',
    video_currently_generated: 'วิดีโอนี้กำลังอยู่ในระหว่างการสร้าง',
    checking_status: 'กำลังตรวจสอบสถานะ',
    check_status: 'ตรวจสอบสถานะ',
    browser_does_not_support_audio: 'เบราว์เซอร์ของคุณไม่รองรับแท็กเสียง',
    existing_edit_scenario:
      'คุณต้องการแก้ไขสถานการณ์เดิมหรือสร้างสถานการณ์ใหม่? หากสร้างใหม่ สถานการณ์เดิมจะถูกลบ',
    generate_scenario: 'สร้างสถานการณ์',
    layout: 'เลย์เอาต์',
    confirm_change: 'ยืนยันการเปลี่ยนแปลง',
    generated_ai_creation_message:
      'โปรดทราบว่าเฉพาะองค์ประกอบข้อความที่สร้างโดย AI เท่านั้นที่จะถูกเก็บไว้ องค์ประกอบอื่น ๆ ทั้งหมดจะถูกลบออกจากหน้า',
    generate_story: 'สร้างเรื่องราว',
    save_original_content: 'บันทึกเนื้อหาต้นฉบับ:',
    story_added_specified_position:
      'ตำแหน่งของเรื่องราวในบทเรียน เรื่องราวจะถูกเพิ่มเป็นบล็อกในตำแหน่งที่กำหนด',
    position_of_story: 'ตำแหน่งของเรื่องราว',
    start_the_lesson: 'เริ่มบทเรียน',
    end_the_lesson: 'จบบทเรียน',
    add_story_pages: 'เพิ่มเรื่องราวลงในหน้า',
    browser_does_not_support: 'เบราว์เซอร์ของคุณไม่รองรับองค์ประกอบเสียง',
    no_video_available: 'ไม่มีวิดีโอที่พร้อมใช้งาน',
    no_podcast_available: 'ไม่มีพอดแคสต์ที่พร้อมใช้งาน',
    no_item_baskets: 'ไม่มีรายการในตะกร้า',
    ai_course_object: 'การนำทางความเป็นผู้นำในยุคดิจิทัล'
  },
  v2: {
    n_data: 'ไม่มีข้อมูล',
    change: 'เปลี่ยน',
    remove: 'ลบ',
    auto_background: 'พื้นหลังอัตโนมัติ',
    create_new_course_org: 'สร้างคอร์สใหม่สำหรับองค์กรของคุณ',
    create_new_course_marketplace: 'สร้างคอร์สใหม่สำหรับตลาด',
    create_new_course_both: 'สร้างคอร์สใหม่สำหรับทั้งองค์กรและตลาด',
    ok: 'ตกลง',
    page_bg: 'พื้นหลังหน้า',
    lesson_cover: 'ภาพปกบทเรียน',
    create_skill_journey: 'สร้างเส้นทางทักษะ',
    Metamaze: 'Metamaze',
    events: 'กิจกรรม',
    scroms: 'SCORMs',
    min_score_pass: 'คะแนนขั้นต่ำที่ผ่าน',
    no_scorms_available: 'ไม่มี SCORMs ที่พร้อมใช้งาน',
    no_events_available: 'ไม่มีเหตุการณ์ที่พร้อมใช้งาน',
    no_courses_available: 'ไม่มีคอร์สที่พร้อมใช้งาน',
    no_courses_baskets: 'ไม่มีคอร์สในตะกร้า',
    no_mazes_baskets: 'ไม่มีเขาวงกตในตะกร้า',
    no_scroms_baskets: 'ไม่มี SCORMs ในตะกร้า',
    no_events_baskets: 'ไม่มีเหตุการณ์ในตะกร้า',
    sorry: 'ขออภัย!',
    option_1: 'ตัวเลือก 1',
    option_2: 'ตัวเลือก 2',
    enter_number_words: 'กรอกจำนวนคำสูงสุด',
    summarize: 'สรุป',
    answer: 'คำตอบ',
    hold_tight_one_minute:
      'รอแป๊บนึง! กำลังเตรียมการอยู่ อาจใช้เวลาถึงหนึ่งนาที',
    enter_question: 'กรอกคำถามของคุณ',
    enter_relevant_documents: 'กรอกจำนวนเอกสารที่เกี่ยวข้อง',
    please_input_relevant_documents: 'กรุณากรอกจำนวนเอกสารที่เกี่ยวข้อง!',
    please_wait_loading_results: 'กรุณารอผลลัพธ์กำลังโหลด...',
    proceed_to_add_voice: 'ดำเนินการเพิ่มเสียง',
    results: 'ผลลัพธ์',
    no_result_found_try_asking_questions: 'ไม่พบผลลัพธ์ ลองถามคำถามเพิ่มเติม',
    eg: 'เช่น,',
    what_make_sales_manager: 'อะไรที่จะทำให้ฉันเป็นผู้จัดการฝ่ายขาย?',
    please_select_lang: 'กรุณาเลือกภาษาหนึ่งภาษา!',
    search: 'ค้นหา',
    please_copy_desired_content:
      'กรุณาคัดลอกเนื้อหาที่ต้องการจากกล่องด้านซ้ายไปยังกล่องด้านขวา',
    rating_req: 'การให้คะแนนเป็นฟิลด์ที่จำเป็น',
    review_req: 'รีวิวเป็นฟิลด์ที่จำเป็น',
    rating_review_req: 'ต้องให้คะแนนและรีวิวทั้งสองอย่าง',
    how_rate_this: 'คุณจะให้คะแนนสิ่งนี้อย่างไร?',
    amazing_above_expectations: 'น่าทึ่ง! เกินความคาดหมาย!',
    certificates: 'ใบรับรอง',
    you_no_certificates: 'คุณไม่มีใบรับรองในขณะนี้',
    please_add_review: 'กรุณาให้รีวิวพร้อมกับการให้คะแนน ขอบคุณ!',
    post: 'โพสต์',
    rate: 'ให้คะแนน',
    avg_rating: 'คะแนนเฉลี่ย',
    no_review_found: 'ไม่พบรีวิว',
    are_sure_to_disale_zoom_integration:
      'คุณแน่ใจหรือว่าต้องการปิดการเชื่อมต่อ Zoom?',
    badges: 'ตราสัญลักษณ์',
    you_no_badge_available: 'คุณไม่มีตราสัญลักษณ์ในขณะนี้',
    download_certificate: 'ดาวน์โหลดใบรับรอง',
    loading: 'กำลังโหลด...',
    no_file_attached: 'ไม่มีไฟล์แนบ',
    you_do_not_have_any_notes: 'คุณไม่มีบันทึกใด ๆ',
    question: 'คำถาม',
    score: 'คะแนน',
    alert_score_message: 'บุคคล(หลายคน) ได้ส่งคะแนนแล้ว',
    alert_question_message: 'ยังไม่มีคำถามถูกเพิ่ม',
    button_submit: 'ส่ง',
    button_allScores: 'ส่งคะแนนทั้งหมดแล้ว',
    record_wait: 'กำลังเริ่มบันทึก โปรดรอ...',
    buttonSubmit_warning: 'กรุณากรอกคะแนนทั้งหมดก่อนส่ง',
    upload_ar_assets: 'อัปโหลดทรัพย์สิน AR',
    edit_ar_assets: 'แก้ไขทรัพย์สิน AR',
    edit_maze_assets: 'แก้ไขทรัพย์สิน MetaMaze',
    upload_assets: 'อัปโหลดทรัพย์สิน',
    upload_maze_assets: 'อัปโหลดทรัพย์สิน MetaMaze',
    trigger_title: 'ชื่อทริกเกอร์',
    model_title: 'ชื่อโมเดล',
    trigger_description: 'คำอธิบายทริกเกอร์',
    model_description: 'คำอธิบายโมเดล',
    please_type_target_description: 'กรุณาพิมพ์คำอธิบายเป้าหมาย',
    please_type_model_description: 'กรุณาพิมพ์คำอธิบายโมเดล',
    trigger_image: 'รูปทริกเกอร์*',
    model_image: 'รูปโมเดล*',
    upload_trigger_image: 'อัปโหลดรูปทริกเกอร์',
    upload_model_image: 'อัปโหลดรูปโมเดล',
    drag_n_drop: 'ลากและวาง',
    file_size_should_not_exceed: '(ขนาดไฟล์รูปภาพ (JPEG) ไม่ควรเกิน 512 KB)',
    zip_size_should_not_exceed: '(ขนาดไฟล์ ZIP ไม่ควรเกิน 60 MB)',
    ar_content: 'เนื้อหา AR*',
    model_content: 'โมเดล 3D*',
    upload_3d_zip: 'อัปโหลด ZIP / วิดีโอ',
    upload_3d_maze_zip: 'อัปโหลด ZIP',
    audio_content: 'เนื้อหาเสียง',
    _mp3: '(.mp3)',
    content_attached: 'แนบไฟล์ ZIP แล้ว',
    video_attached: 'แนบวิดีโอแล้ว',
    audio_attached: 'แนบเสียงแล้ว',
    enter_trigger_image_title: 'กรอกชื่อรูปทริกเกอร์',
    enter_model_title: 'กรอกชื่อโมเดล MetaMaze',
    ar_preview_image: 'รูปตัวอย่าง AR',
    upload_preview_image: 'อัปโหลดรูปตัวอย่าง',
    upload_audio: 'อัปโหลดเสียง',
    creating___: 'กำลังสร้าง...',
    updating___: 'กำลังอัปเดต...',
    create: 'สร้าง',
    update: 'อัปเดต',
    ar_assets: 'ภาพ 3D',
    _3d_files_mp4: '(ไฟล์ .obj, .fbx หรือวิดีโอ .mp4 ที่บีบอัด)',
    _3d_files_mp4_ar: '(ไฟล์ .obj, .fbx ที่บีบอัด)',
    maze_3d_files_mp4: '(ไฟล์ .obj, .fbx ที่บีบอัด)',
    _jpg_files: 'รองรับเฉพาะ .jpg',
    persons_have_submitted_their_scores: 'บุคคลได้ส่งคะแนนของพวกเขาแล้ว',
    no_questions_added_till_now: 'ยังไม่มีคำถามถูกเพิ่ม',
    submit: 'ส่ง',
    all_scores_submitted: 'คะแนนทั้งหมดถูกส่งแล้ว',
    recording_is_starting: 'กำลังเริ่มบันทึก โปรดรอ...',
    please_input_scores_before_submitting: 'กรุณาใส่คะแนนทั้งหมดก่อนส่ง',
    end_for_all: 'จบสำหรับทุกคน',
    full_screen: 'เต็มหน้าจอ',
    breakout_room: 'ห้องแยก',
    send_invitations: 'ส่งคำเชิญ',
    add_participants: 'เพิ่มผู้เข้าร่วม',
    create_breakout_room: 'สร้างห้องแยก',
    connecting: 'กำลังเชื่อมต่อ...',
    currently_broadcaster_unavailable: 'ผู้ถ่ายทอดสดไม่พร้อมใช้งานในขณะนี้',
    how_many_breakout_room_to_create: 'ต้องการสร้างห้องแยกกี่ห้อง?',
    create_upto_three_breakout_rooms: '*สร้างห้องแยกได้สูงสุด 3 ห้อง',
    allow: 'อนุญาต',
    additional: 'เพิ่มเติม',
    attachment: 'ไฟล์แนบ',
    no_description_available: 'ไม่มีคำอธิบาย',
    people: 'ผู้คน',
    waiting: 'กำลังรอ',
    hand_raising_users: 'ผู้ยกมือ',
    invite: 'เชิญ',
    create_room: 'สร้างห้อง',
    create_live_event: 'สร้างกิจกรรมถ่ายทอดสด',
    support_upto_fivethousand_participants:
      'รองรับผู้เข้าร่วมได้สูงสุด 5,000 คนสำหรับกิจกรรม',
    support_upto_ten_participants:
      'รองรับผู้เข้าร่วมถ่ายทอดสดวิดีโอได้สูงสุด 10 คน',
    support_upto_twohundred_participants:
      'รองรับผู้เข้าร่วมได้สูงสุด 200 คนสำหรับกิจกรรม',
    supprt_upto_five_participants:
      'รองรับผู้เข้าร่วมถ่ายทอดสดวิดีโอได้สูงสุด 5 คน',
    support_upto_twentyfive_participants:
      'รองรับผู้เข้าร่วมถ่ายทอดสดวิดีโอได้สูงสุด 25 คนสำหรับกิจกรรม',
    two_live_video_participants:
      'มีกลุ่มผู้เข้าร่วมถ่ายทอดสดวิดีโอ 2 คน (ผู้จัดและผู้เข้าร่วม)',
    you_can_have_upto_five_examinees: 'คุณสามารถมีผู้เข้าสอบได้สูงสุด 5 คน',
    you_can_have_upto_twentyfive_participants:
      'คุณสามารถมีผู้เข้าร่วมได้สูงสุด 25 คน',
    you_can_have_upto_five_participants: 'คุณสามารถมีผู้เข้าร่วมได้สูงสุด 5 คน',
    you_can_have_upto_ten_participants: 'คุณสามารถมีผู้เข้าร่วมได้สูงสุด 10 คน',
    select_hosts_email: 'เลือกอีเมลของเจ้าภาพ',
    send_invite_email: 'ส่งอีเมลเชิญ',
    do_not_send_invite_email: 'ไม่ส่งอีเมลเชิญ',
    error: 'ข้อผิดพลาด',
    max_twentyfive_users_allowed: 'อนุญาตให้เลือกผู้ใช้สูงสุด 25 คน',
    max_five_users_allowed: 'อนุญาตให้เลือกผู้ใช้สูงสุด 5 คน',
    max_ten_users_allowed: 'อนุญาตให้เลือกผู้ใช้สูงสุด 10 คน',
    no_user_found: 'ไม่พบผู้ใช้',
    transcribe_to: 'ถอดความเป็น',
    integrate_zoom_to_start_meeting:
      'ผสาน Zoom กับบัญชีของคุณเพื่อเริ่มการประชุม Zoom',
    zoom_is_not_integrated: 'Zoom ยังไม่ได้เชื่อมต่อ',
    delete_poll: 'ลบแบบสำรวจ',
    add_poll: 'เพิ่มแบบสำรวจ',
    live_now: 'ถ่ายทอดสดตอนนี้!',
    average_rating: 'คะแนนเฉลี่ย',
    review: 'รีวิว',
    time_spent: 'เวลาที่ใช้',
    total: 'รวม',
    mins: 'นาที',
    no_data: 'ไม่มีข้อมูลสำหรับแบบทดสอบนี้',
    total_score: 'คะแนนรวม',
    pass_score: 'คะแนนผ่าน',
    point: 'คะแนน',
    wrong: 'ผิด',
    response: 'การตอบกลับ',
    submitted: 'ส่งแล้ว',
    average: 'ค่าเฉลี่ย',
    total_play: 'จำนวนครั้งที่เล่น',
    view_graph: 'ดูกราฟ',
    time_spent_mins: 'เวลาที่ใช้ (นาที)',
    play: 'เล่น',
    ideal_path: 'เส้นทางที่เหมาะสม',
    user_incorrect_path: 'เส้นทางที่ผู้ใช้ผิดพลาด',
    ideal_path_taken: 'เส้นทางที่ผู้ใช้เลือกเดิน',
    scenario: 'สถานการณ์',
    option: 'ตัวเลือก',
    spend: 'ใช้เวลา',
    average_spending_time: 'เวลาที่ใช้เฉลี่ย',
    activity_overview: 'ภาพรวมกิจกรรม',
    live_event: 'กิจกรรมสด',
    live_assessment: 'การประเมินสด',
    report_download: 'ดาวน์โหลดรายงาน',
    all_workshops: 'เวิร์กช็อปทั้งหมด',
    overview_average_activity: 'ภาพรวมกิจกรรมเฉลี่ย',
    overview_workshop_graph: 'กราฟภาพรวมเวิร์กช็อป',
    mazes: 'เขาวงกต',
    correct_feedback: 'คำติชมที่ถูกต้อง',
    incorrect_feedback: 'คำติชมที่ไม่ถูกต้อง',
    checkin_checkout: 'เช็คอิน - เช็คเอาท์',
    minutes: 'นาที',
    incorrect_path: 'เส้นทางผิด',
    answer_not_available: 'ไม่มีคำตอบ',
    views: 'ยอดวิว',
    item: 'รายการ',
    questions: 'คำถาม',
    total_points: 'คะแนนรวม',
    total_attempts: 'จำนวนครั้งที่พยายาม',
    created_date: 'วันที่สร้าง',
    host_name: 'ชื่อเจ้าภาพ',
    host_section: 'ส่วนเจ้าภาพ',
    choose_products: 'เลือกสินค้า',
    add_to_basket: 'เพิ่มในตะกร้า',
    basket: 'ตะกร้า',
    times: 'ครั้ง',
    scorms: 'SCORMs',
    skill_journey_overview: 'ภาพรวมเส้นทางทักษะ',
    how_to_use: 'วิธีใช้งาน',
    live_broadcast_description:
      'เราได้รวมวิดีโอถ่ายทอดสดเข้ากับเครื่องมือสร้างหลักสูตรที่ใช้งานง่าย',
    live_broadcast_subdescription:
      'ด้วยระบบถ่ายทอดสดที่จดสิทธิบัตรของ ShareLook คุณสามารถสร้างการมีส่วนร่วม อัตโนมัติการเรียนรู้ และเพิ่มการแบ่งปันความรู้ได้อย่างเต็มที่',
    disclaimer: `ฉันรับประกันว่าเส้นทางทักษะของฉันจะไม่:
  - ละเมิดสิทธิของบุคคลที่สามใด ๆ
  - มีเนื้อหาที่ผิดกฎหมาย เช่น หมิ่นประมาท ลามกอนาจาร ลามก เลวทราม รุนแรง ดูถูก เหยียดหยาม หรือข่มขู่ แม้จะแอบอ้างด้วยสัญลักษณ์ต่าง ๆ
  - มีการโจมตีส่วนบุคคล
  - แอบอ้างเป็นบุคคลอื่น บุคคลสาธารณะ หรือคนดัง
  - มีการบันทึกหรือข้อมูลส่วนตัวของบุคคลใดโดยไม่ได้รับอนุญาต และไม่ละเมิดกฎระเบียบคุ้มครองข้อมูลใด ๆ ในทุกส่วนของโลก
  - มีการชักชวนเชิงพาณิชย์หรือสแปมใด ๆ`,
    price: 'ราคา',
    video_link: 'ลิงก์วิดีโอ',
    category: 'หมวดหมู่',
    objectives: 'วัตถุประสงค์',
    marketplace_description: 'คำอธิบายตลาด',

    live_discussion: 'การสนทนาสด',
    poll: 'โพล',
    hide_grid: 'ซ่อนกริด',
    show_grid: 'แสดงกริด',
    stop_screen_share: 'หยุดแชร์หน้าจอ',
    screen_share: 'แชร์หน้าจอ',
    mute: 'ปิดเสียง',
    unmute: 'เปิดเสียง',
    raise_hand: 'ยกมือ',
    waiting__: 'กำลังรอ...',
    audio_active: 'เสียงเปิดใช้งาน'
  },
  general: {
    save: 'บันทึก',
    autosaved: 'บันทึกอัตโนมัติแล้ว',
    back_to: 'กลับไปยัง',
    by: 'โดย',
    chat: 'การพูดคุย',
    completed: 'สำเร็จแล้ว',
    canceled: 'ยกเลิกแล้ว',
    component: 'ส่วนประกอบ',
    confirm: 'ยืนยัน',
    course: 'คอร์สเรียน',
    skill: 'เส้นทางทักษะ',
    maze: 'เมตาเมซ',
    channel: 'ช่อง',
    podcast: 'พอดคาสต์',

    date: 'วันที่',
    details: 'รายละเอียด',
    empty: 'ไม่มีข้อมูล',
    enrolled: 'ลงเรียนสำเร็จ',
    free: 'ฟรี',
    graph: 'กราฟ',
    loading: 'กำลังโหลด…',
    lesson: 'บทเรียน',
    lessons: 'บทเรียน',
    live_assessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    live_event: 'วีดีโอถ่ายทอดสด',
    no: 'ไม่',
    of: 'จาก',
    or: 'หรือ',
    organization: 'องค์กร',
    page: 'หน้า',
    pages: 'หน้า',
    personal: 'ส่วนตัว',
    poll: 'แบบสำรวจ',
    rating: 'ให้คะแนน',
    reset: 'ล้างข้อมูล',
    signin: 'เข้าสู่ระบบ',
    signup: 'สมัครใช้งาน',
    soon: 'เร็วๆ นี้',
    type: 'พิมพ์',
    uploading: 'กำลังอัพโหลด',
    yes: 'ใช่',
    something_went_wrong: 'มีบางอย่างผิดพลาด',
    view_all: 'ดูทั้งหมด',
    upload_successful: 'อัพโหลดสำเร็จ',
    upload_successful_message:
      'ไฟล์ของคุณอัพโหลดแล้ว ตอนนี้กำลังประมวลผล อาจใช้เวลาเล็กน้อย',
    check_email_upload_successful:
      'กรุณา<0>เช็คอีเมลของคุณ</0> สำหรับ <1>รายงาน</1>การอัพโหลดรายชื่อผู้ใช้งาน',
    is_private: 'ความเป็นส่วนตัว'
  },

  account: {
    title: 'บัญชี',
    subtitle: 'จัดการการตั้งค่าและข้อมูลบัญชีของคุณ',
    saved: 'เปลี่ยนแปลงข้อมูลบัญชีเรียบร้อยแล้ว'
  },

  assessments: {
    title: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    subtitle: 'สร้างการประเมินผลแบบวีดีโอนถ่ายทอดสด',
    finished: 'การประเมินผลแบบวีดีโอนถ่ายทอดสดเสร็จสิ้นแล้ว',
    countdown: 'การประเมินผลแบบวีดีโอถ่ายทอดสดจะเริ่มใน ',
    create: 'สร้างการประเมินผลแบบวีดีโอถ่ายทอดสด',
    list_title: 'การประเมินผลแบบวีดีโอนถ่ายทอดสดของคุณ',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้',
    details_title: 'เพิ่มรายละเอียดการประเมินผลสด',
    details_subtitle:
      'กรุณาตั้งชื่อการประเมินผลแบบวีดีโอถ่ายทอดสดนี้ พร้อมคำบรรยายสิ่งที่ผู้ร่วมชมจะได้รับจากการประเมินผลนี้',
    disclaimer: `ฉันรับประกันว่าการบันทึกการประเมินผลแบบวีดีโอถ่ายทอดนี้จะไม่:
    - ไม่ละเมิดสิทธิ์ของบุคคลที่สาม
    -  ไม่มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจาร รุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งแฝงด้วยเครื่องหมายดอกจัน
    - ไม่มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
    - ไม่มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
    - ไม่มีการบันทึกหรือข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับในการคุ้มครองข้อมูลใด ๆ ในส่วนใดของโลก
    - ไม่มีการชักชวนทางการค้าหรือ "สแปม" "ในรูปแบบใด ๆ'`,

    // newlyadded
    assessment_details: 'รายละเอียดการประเมิน',
    assessment_settings: 'การตั้งค่าการประเมิน'
  },

  buildersettings: {
    title: 'การตั้งค่าการเผยแพร่',
    subtitle:
      'เพิ่มการตั้งค่าอีเว้นท์ เลือกคนที่สามารถมองเห็นและมีส่วนร่วมกับอีเว้นท์ของคุณ'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'เพิ่ม',
    add_page: 'เพิ่มหน้า',
    add_lesson: 'เพิ่มบทเรียน',
    add_answer: 'เพิ่มคำตอบใหม่',
    add_group: 'เพิ่มกรุ๊ป',
    add_organization: 'เพิ่มองค์กร',
    add_question: 'เพิ่มคำถาม',
    add_quiz: 'เพิ่มแบบสอบถาม',
    add_users: 'เพิ่มผู้ใช้งานหลายคน',
    back: 'ย้อนกลับ',
    back_to_course: 'กลับสู่หน้ารวมคอร์ส ',
    back_to_lesson: 'กลับสู่หน้ารวมบทเรียน',
    back_to_media: 'กลับสู่คลังภาพ',
    back_to_details: 'กลับสู่รายละเอียด',
    cancel: 'ยกเลิก',
    clear: 'ล้างข้อมูล',
    close: 'ปิด',
    clone: 'สร้างสำเนา',
    close_lesson: 'ปิดบทเรียน',
    clone_course: 'สร้างสำเนาคอร์ส',
    confirm: 'ยืนยัน',
    create: 'สร้าง',
    download: 'ดาวโหลด',
    download_mass_user_tamplate: 'ดาวน์โหลดเทมเพลต',
    add_mass_users: 'เพิ่มผู้ใช้หลายคน',
    upload_excel_list: 'อัพโหลดไฟล์ excel',
    delete: 'ลบสื่อ',
    edit: 'แก้ไข',
    edit_course: 'แก้ไขคอร์สเรียน',
    enroll: 'ลงเรียน',
    finish: 'เสร็จสิ้น',
    upload_image: 'อัพโหลดรูปภาพ',
    upload_image_video: 'อัพโหลดรูปภาพหรือวีดีโอ',
    select_media_library: 'เลือกรูปจากคลังรูป',
    make_public: 'เผยแพร่สู่สาธารณะ',
    make_private: 'ตั้งค่าความเป็นส่วนตัว',
    make_org: 'ทำให้เป็นองค์กร',
    media: 'คลังรูปภาพ',
    my_theme: 'ธีมของฉัน',
    next: 'ถัดไป',
    next_lesson: 'บทเรียนถัดไป',
    next_step: 'ขั้นตอนต่อไป',
    previous_step: 'ขั้นตอนก่อนหน้า',
    publish: 'เผยแพร่',
    publish_assessment: 'เผยแพร่การประเมินผลแบบวีดีโอถ่ายทอดสด',
    publish_course: 'เผยแพร่คอร์สของคุณ',
    publish_event: 'เผยแพร่วีดีโอถ่ายทอดสดของคุณ',
    reset: 'กลับสู่ค่าเริ่มต้น',
    reset_elements: 'กลับสู่ค่าเริ่มต้นขององค์ประกอบ',
    save: 'บันทึก',
    creating: 'กำลังสร้าง',
    updating: 'กำลังอัพโหลด',
    saved: 'บันทึกแล้ว',
    save_for_later: 'บันทึกสำหรับภายหลัง',
    save_settings: 'บันทึกการตั้งค่า',
    select_files: 'เลือกไฟล์',
    select_theme: 'เลือกธีม',
    start_lesson: 'เริ่มบทเรียน',
    update: 'อัพโหลด',
    upload: 'อัพโหลด',
    upload_audio: 'อัพโหลดเสียง',
    upload_photo: 'อัพโหลดรูปโปรไฟล์ ',
    upload_video: 'อัพโหลดวีดีโอ',
    enrolled: 'ลงเรียน',
    unenroll: 'ยกเลิกการลงเรียน',
    from_library: 'คลังรูปภาพ',
    remove: 'ลบ',
    removed: 'ลบสำเร็จ',
    start_broadcast: 'เริ่มการถ่ายทอดสด',
    end_broadcast: 'จบการถ่ายทอดสด',
    camera: 'กล้อง',
    screen: 'หน้าจอ',
    screen_with_camera: 'แสดงหน้าจอคอมพร้อมกล้อง',

    // newlyadded
    insert: 'แทรก',
    inserting: 'การแทรก'
  },

  card: {
    quick_add: 'การเพิ่มแบบรวดเร็ว',
    add: 'เพิ่ม',
    clone: 'สร้างสำเนา',
    completed: 'บทเรียนสำเร็จแล้ว'
  },

  course: {
    upcoming_course: 'คอร์สใหม่เร็วๆ นี้',
    unPublishEvent: 'วีดีโอถ่ายทอดสดที่ยังไม่ได้เผยแพร่',
    unPublishAssessment: 'การประเมินผลแบบถ่ายทอดสดที่ยังไม่ได้เผยแพร่',
    pastCourse: 'หลักสูตรการเรียน',
    upcoming: 'วีดีโอถ่ายทอดสดใหม่เร็วๆ นี้',
    pastEvent: 'วีดีโอถ่ายทอดสดที่ผ่านมาแล้ว',
    pastAssessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสดที่ผ่านมาแล้ว',
    upcomingAssessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสดใหม่ เร็วๆ นี้ ',
    created: 'วันที่สร้าง:',
    assignees: 'ผู้รับสิทธิ',
    organisations: ' {{ organizations }} องค์กร, <2> {{ users }} ผู้ใช้งาน</2>',
    event_date: 'วันที่ถ่ายทอดสด <1> {{ date }} </1>',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้',
    clonning_no_lesson:
      'เลือกเพิ่มบทเรียนอย่างน้อยหนึ่งบทเรียนเพื่อทำการสร้างสำเนาคอร์สเรียนนี้.',
    clone_warning: 'คุณแน่ใจหรือว่าต้องการสร้างสำเนา',
    clone_success: 'อยู่ระหว่างการสร้างสำเนา',
    disclaimer: `ฉันรับประกันว่าคอร์สเรียนของฉันจะไม่:
    - ไม่ละเมิดสิทธิ์ของบุคคลที่สาม
    -  ไม่มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจาร รุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งแฝงด้วยเครื่องหมายดอกจัน
    - ไม่มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
    - ไม่มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
    - ไม่มีการบันทึกหรือข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับในการคุ้มครองข้อมูลใด ๆ ในส่วนใดของโลก
    - ไม่มีการชักชวนทางการค้าหรือ "สแปม" "ในรูปแบบใด ๆ'`
  },

  coursecreate: {
    dropzone_text: 'ใส่รูปภาพ',
    sidebar_text: 'เลือกธีม <1/> บทเรียน <3/> ของคุณ',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบบทเรียนนี้'
  },

  coursepage: {
    quizview_loading: 'กำลังตรวจสอบคำตอบ กรุณารอสักครู่',
    quizview_answer: 'คำตอบของคุณ'
  },

  coursequiz: {
    title: 'คำถามทั้งหมดในทุกบทเรียน'
  },

  dashboard: {
    tooltip_title: 'ไม่ต้องแสดงวีดีโอนี้อีก',
    page_title: 'สถิติคอร์สเรียนของคุณ',
    page_subtitle: 'สถานะของคอร์สเรียนที่คุณสร้าง',
    profile_add_info:
      'เพิ่มข้อมูลของคุณ <1>{{uncompletedText}}</1> เพื่อให้โปรไฟล์ของคุณสมบูรณ์.',
    profile_build:
      'สร้างโปรไฟล์ของคุณ<1>ที่นี่</1>,แจ้งให้เราทราบความสนใจพิเศษหรือความสามารถของคุณ',
    profile_title: 'โปรไฟล์มีความแข็งแรง',
    more_details: 'รายละเอียดเพิ่มเติม'
  },

  errors: {
    answer: 'กรุณาใส่คำตอบ',
    answer_correct: 'เลือกคำตอบที่ถูกต้อง',
    code: 'กรุณาใส่รหัสโคดของคุณ',
    criterion: 'กรุณาใส่เกณฑ์',
    duration: 'กรุณาใส่ระยะเวลา',
    element: 'กรุณาใส่องค์ประกอบอื่นๆ',
    email: 'กรุณาใส่อีเมลของคุณ',
    email_invalid: 'อีเมลไม่ถูกต้อง',
    feedback_correct: 'กรุณาใส่คำตอบที่ถูกต้อง',
    feedback_incorrect: 'กรุณาใส่คำตอบที่ไม่ถูกต้อง',
    host: 'กรุณาใส่ผู้ที่จะทำการถ่ายทอดสด',
    host_assessment: ' กรุณาใส่ผู้ที่จะทำการประเมินผลแบบวีดีโอถ่ายทอดสด',
    image: 'กรุณาอัพโหลดรูปภาพ',
    location: 'กรุณาใส่สถานที่ของคุณ',
    live_location: 'กรุณาเลือกสถานที่ที่คุณจะทำวีดีโอถ่ายทอดสด',
    limit: ' กรุณาใส่จำนวนนาทีที่คุณต้องการทำการถ่ายทอดสด',
    min_3char: 'อย่างน้อยสามตัวอักษร',
    number: 'กรุณาใส่ตัวเลขที่ถูกต้อง',
    host_email_require: ` จำเป็นต้องใส่อีเมลผู้จะทำการถ่ายทอดสด`,
    attendee_email_require: ` จำเป็นต้องใส่อีเมลผู้เข้าร่วมการถ่ายทอดสด`,
    name: 'กรุณาใส่ชื่อของคุณ',
    not_found_course: 'ไม่พบคอร์สนี้',
    not_found_event: 'ไม่พบอีเว้นท์นี้',
    not_found_assessment: 'ไม่พบการประเมินผลโดยวีดีโอนี้',
    password: 'กรุณาใส่รหัสผ่านของคุณ',
    password_digit: 'อย่างน้อยตัวเลขหนึ่งตัว',
    password_short: 'รหัสผ่านสั้นเกินไป อย่างน้อยควรมี 10 ตัวอักษร',
    password_special: 'อย่างน้อยควรมีสัญลักษณ์พิเศษหนึ่งตัว',
    password_uppercase: 'อย่างน้องควรมีตัวพิมพ์ใหญ่หนึ่งตัว',
    password_lowercase: 'อย่างน้อยควรมีตัวพิมพ์เล็กหนึ่งตัว ',
    phone: 'กรุณาใส่เบอร์โทรศัพท์ของคุณ',
    phone_invalid: 'ไม่พบหมายเลขโทรศัพท์นี้',
    position: 'กรุณาใส่ตำแหน่งของคุณ',
    question: 'กรุณาใส่คำถาม',
    start_date: ' กรุณาระบุวันและเวลาที่จะเริ่ม',
    tag: 'กรุณาเลือก tag',
    topics: 'กรุณาเลือกอย่างน้อยหนึ่งหัวข้อ.',
    live_topics: 'กรุณาเพิ่มหัวข้อ',
    title: 'กรุณาใส่หัวเรื่องหรือชื่อเรื่อง',
    title_assessment: 'กรุณาใส่ชื่อการประเมินผลโดยวีดีโอถ่ายทอดสด',
    title_course: 'กรุณาใส่ชื่อคอร์ส',
    title_empty: 'หัวเรื่องไม่สามารถเว้นว่างได้',
    title_event: 'กรุณาใส่ชื่ออีเว้นท์',
    title_lesson: 'กรุณาใส่ชื่อบทเรียน',
    title_quiz: 'กรุณาใส่ชื่อของชุดคำถาม',
    username: 'กรุณาใส่บัญชีผู้ใช้งานของคุณ',
    upload_error: 'ผิดพลาด ไฟล์ของคุณผิดประเภท',
    upload_more_than_10: 'คุณสามารถอัพโหลดรูปภาพพร้อมกันมากสุดได้ 10 ไฟล์',
    topics_max: 'กรุณาเพิ่มหัวข้อสูงสุดได้ 3 หัวข้อ',
    upload_excel: 'กรุณาตรวจสอบไฟล์ที่คุณอัพโหลดถูกต้องหรือไม่',
    title_excel: 'เกิดข้อผิดพลาดในการอัพโหลดแบบ',
    file_size_exceed: 'ขนาดของไฟล์เกินข้อกำหนด',
    subtitle_excel:
      'กรุณาตรวจสอบว่าคุณใช้แบบของเราและใส่ข้อมูลถูกต้องตามแถวและหัวข้อ',
    select_broadcast_option: ' กรุณาเลือกรูปแบบที่คุณต้องการทำการถ่ายทอดสด',
    multi_hosts_number_error:
      'จำนวนของผู้ที่จะทำการถ่ายทอดสดไม่สามารถเกินกว่าที่ได้ระบุไว้ในรายการการถ่ายทอดสด',
    conference_people_number_error: ` จำนวนของผู้ร่วมชมไม่สามารถเกินกว่าที่ได้ระบุไว้ในรายการการถ่ายทอดสด`,
    select_max_host: 'กรุณาเลือกอย่างน้อยหนึ่งคนสำหรับคนที่จะทำการถ่ายทอดสด',
    select_max_conference:
      'เลือกอย่างน้อยหนึ่งคนสำหรับผู้ที่จะเข้าร่วมรายการการถ่ายทอดสด',
    stream_stop_error: 'วีดีโอถ่ายทอดสดหยุดกะทันหัน',
    unsecure_context:
      'ข้อผิดพลาดร้ายแรง: เบราเซอร์ไม่สามารถเข้าถึงกล้องและไมโครโฟนเนื่องจากบริบทที่ไม่ปลอดภัย กรุณาติดตั้ง SSL และเข้าถึงผ่าน https',
    ws_not_supported: 'ข้อผิดพลาดร้ายแรง: ไม่รองรับ WebSocket ในเบราเซอร์นี้',

    // newlyadded
    no_org: 'เลือกอย่างน้อย 1 องค์กรเพื่อดำเนินการต่อ',
    no_org_group: 'เลือกกลุ่มองค์กรอย่างน้อย 1 กลุ่มเพื่อดำเนินการต่อ'
  },

  events: {
    title: ' เพิ่มรายละเอียดของวีดีโอถ่ายทอดสด',
    change_host: 'เปลี่ยนผู้ทำการถ่ายทอดสด',
    finished: 'วีดีโอถ่ายทอดสดเสร็จสิ้น',
    countdown: 'วีดีโอถ่ายทอดสดจะเริ่มถ่ายทอดสดใน',
    subtitle:
      ' ตั้งชื่อวีดีโอถ่ายทอดสดนี้และบอกให้ผู้ชมรู้ว่าเขาจะได้เรียนรู้อะไรจากการถ่ายทอดสดนี้',
    poll_disabled: 'แบบสำรวจความคิดเห็นไม่สามารถใช้ได้ในวีดีโอถ่ายทอดสดนี้',
    disclaimer: `ฉันรับประกันว่าวีดีโอถ่ายทดสดที่ได้บันทึกจะไม่:
    - ไม่ละเมิดสิทธิ์ของบุคคลที่สาม
    -  ไม่มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจาร รุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งแฝงด้วยเครื่องหมายดอกจัน
    - ไม่มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
    - ไม่มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
    - ไม่มีการบันทึกหรือข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับในการคุ้มครองข้อมูลใด ๆ ในส่วนใดของโลก
    - ไม่มีการชักชวนทางการค้าหรือ "สแปม" "ในรูปแบบใด ๆ'`,
    prompt_message:
      'ออกจากหน้านี้จะให้รายการที่คุณสร้างอยู่สิ้นสุดลง คุณแน่ใจหรือว่าต้องการจะออกจากหน้านี้',
    duration_exceed_message:
      'เวลาถ่ายทอดสดของคุณเกินเวลาที่คุณสามารถทำได้ โปรแกรมกำลังจะหยุดการถ่ายทอดสด',
    before_schedule_message:
      'คุณกำลังจะเริ่มการถ่ายทอดสดก่อนเวลา โปรดทราบว่าถ้าคุณกดหยุด การถ่ายทอดสดจะสิ้นสุดทันที ',
    browser_unsupportive_message:
      'เบราว์เซอร์ของคุณไม่รองรับการแชร์หน้าจอ คุณสามารถตรวจสอบเบราว์เซอร์ที่รองรับได้ในลิ้งนี้ ',
    cancel_switch_host_message:
      'ผู้ที่จะทำการถ่ายทอดสดไม่ว่างขณะนี้ โดยคุณจะเป็นผู้ดำเนินการถ่ายทอดสดต่อไป',
    coaching_prompt_message:
      'คุณไม่สามารถออกจากหน้านี้ได้จนว่าการถ่ายทอดสดจะจบลง',
    event_modal_warn: 'คุณต้องการออกจากการถ่ายทอดสดนี้ใช้ใหม?',
    confirm_message: 'รายการถ่ายทอดสดของคุณจะจบลงเมื่อคุณกดที่ปุ่มตกลง',
    screen_share_denied: 'ปฏิเสธที่จะแชร์หน้าจอของคุณ',
    media_not_found: 'ไม่พบกล้องหรือไมค์ หรืออุปกรณ์ของคุณไม่ยินยอมให้ใช้งาน',
    media_not_access:
      ' กล้องหรือไมค์ถูกใช้งานอยู่ในโปรแกรมอื่นที่ไม่อนุญาตให้ใช้งาน',
    constraint_error:
      'ไม่พบอุปกรณ์ที่เหมาะกับข้อจำกัดด้านวิดีโอและเสียงของคุณ คุณสามารถเปลี่ยนข้อจำกัดของวิดีโอและเสียงได้',
    media_access_denied: 'คุณยังไม่ได้ยินยอมให้ใช้งานกล้องและไมค์'
  },

  filters: {
    days7: '7 วันที่ผ่านมา',
    days15: '15 วันที่ผ่านมา',
    days30: '30 วันที่ผ่านมา',
    days365: '365 วันที่ผ่านมา',
    date: 'วันที่สร้าง',
    relevance: 'ที่เกี่ยวข้อง',
    popularity: 'ที่ได้รับความนิยม',
    name: 'ชื่อ',
    group: 'กรุ๊ป',
    Newest_to_Oldest: 'ใหม่สุดถึงเก่าสุด',
    Oldest_to_Newest: 'เก่าสุดถึงใหม่สุด',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'เพื่อความปลอดภัยของบัญชีของคุณเราต้องใช้ตัวพิมพ์เล็กอย่างน้อยหนึ่งตัว และตัวเลข และคุณต้องมีความยาวขั้นต่ำ 10 ตัวอักษร',
    phone: 'โปรดระบุรหัสประเทศของโทรศัพท์ของคุณตัวอย่างเช่น: +66',
    username:
      'ชื่อผู้ใช้ของคุณถือเป็นข้อมูลสาธารณะและแชร์กับผู้ใช้รายอื่นตามความจำเป็น ดังนั้นเราขอแนะนำให้คุณอย่าใช้ข้อมูลส่วนบุคคลในชื่อผู้ใช้ของคุณ',
    public_description_normal:
      'ของคุณ <0><0/></0> ได้รับการบันทึกแล้วและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณเท่านั้นที่เห็นเนื้อหานี้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่สู่สาธารณะหมายความผู้ใช้งานทุกคนในองค์กรที่คุณเลือกสามารถมองเห็นได้ คุณยังสามารถเลือกเฉพาะเจาะจงบัญชีผู้ใช้งาน โดยการระบุที่อยู่อีเมลของบัญชีผู้ใช้งานที่ลงทะเบียนไว้ใน  Sharelook',
    public_description_admin:
      'ข้อมูลนี้ <0><0/></0> ได้รับการบันทึกแล้วและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณ (และผู้สร้างเนื้อหา) เท่านั้นที่สามารถดูเนื้อหานี้ได้. หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่หลักสูตรของคุณสู่สาธารณะหมายความว่าหลักสูตรนี้จะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์มรวมถึงผู้ที่อยู่นอกองค์กรของคุณ. การเผยแพร่ไปยังองค์กรหมายความว่าผู้ใช้ทุกคนภายในองค์กรจะสามารถมองเห็นได้. นอกจากนี้คุณยังสามารถเผยแพร่ไปยังกลุ่มได้อย่างน้องหนึ่งกรุ๊ป หรือหลายกรุ๊ป ซึ่งหมายความว่ามีเพียงผู้ใช้ในกรุ๊ปเหล่านั้นเท่านั้นที่จะเห็นได้ สุดท้ายนี้คุณมีตัวเลือกในการเผยแพร่ให้กับผู้ใช้เฉพาะภายในและภายนอกองค์กรของคุณโดยใช้ที่อยู่อีเมลของบัญชี Sharelook'
  },

  labels: {
    add: 'เพิ่ม',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'ตัวเลือกของคำตอบ',
    answers: 'คำตอบ',
    back_to_quiz: 'กลับสู่หน้ารายการชุดแบบสอบถาม',
    back_to_question: 'กลับสู่หน้ารายการชุดคำถาม',
    chat: 'บทสนทนา',
    chat_available: 'ไม่สามารถใช้บทสนทนาในวีดีโอถ่ายทอดสดนี้',
    chat_report: 'รายงานบทสนทนา',
    choice_single: 'สามารถเลือกคำตอบได้ข้อเดียวเท่านั้น',
    choice_multiple: 'สามารถเลือกคำตอบได้หลายข้อ',
    choice_free: '"ฟรี" ทางเลือก',
    choice_sorting: '"การเรียงลำดับ" ตัวเลือก',
    choice_matrix: '"การจับวางเรียงลำดับ" ตัวเลือก',
    clone_lesson_permission: 'สร้างสำเนาสิทธิ์การอนุญาติ',
    code: 'รหัส',
    correct: 'ถูกต้อง',
    created: 'วันที่สร้าง',
    clone_modal: 'สร้างสำเนาคอร์สเรียน',
    cloning_course: 'กำลังสร้างสำเนาคอร์สเรียน',
    cloning: 'กำลังสร้างสำเนา',
    cloning_course_desc: ' กรุณารอสักครู่ ขั้นตอนนี้อาจใช้เวลาเล็กน้อย',
    cloning_success: 'คอร์สเรียน "<0/>"สร้างสำเนาสำเร็จแล้ว',
    description: 'รายละเอียด',
    disclaimer: 'ขอสงวนสิทธิ์',
    drop_file: 'วางไฟล์ที่นี่',
    duration: 'ระยะเวลา',
    edit: 'แก้ไข',
    email: 'อีเมล',
    event: 'อีเว้นท์',
    event_all: 'อีเว้นท์ของเขาทั้งหมด',
    event_date: 'วันเวลาท้องถิ่นของวีดีโอถ่ายทอดสด',
    event_this: 'อีเว้นท์นี้',
    expire: 'หมดอายุเมื่อ',
    expiry_date: 'วันที่หมดอายุ',
    forgot: 'ลืมรหัสผ่าน?',
    group: 'กรุ๊ป',
    groups_list: 'รายชื่อกรุ๊ป',
    host: 'ผู้ทำการถ่ายทอดสด',
    id_annotation: 'รหัสป๊อปอัพ',
    id_quiz: 'รหัสคำถาม',
    incorrect: 'ไม่ถูกต้อง',
    interests: 'ความสนใจ',
    invited: 'รับเชิญ',
    live_chat: 'บทสนทนาพูดคุยในวีดีโอถ่ายทอดสด',
    live_stream_limit: 'นาทีการถ่ายทอดสด',
    contact_text: 'หากต้องการเปลี่ยนขีดจำกัด การถ่ายทอดสดรายเดือนโปรดติดต่อ',
    contact_admin:
      '<0>หากคุณต้องการเปลี่ยนแปลงขีดจำกัด การถ่ายทอดสดรายเดือนโปรดติดต่อ</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'เวลาการทำวีดีโอถ่ายทอดสดของคุณที่เหลืออยู่: <0>{{ limit }}</0> นาที <1/><2/> <3>หากคุณต้องการเปลี่ยนแปลงขีดจำกัด การถ่ายทอดสดรายเดือนโปรดติดต่อ</3> <4>admin@sharelook.com</4>',
    location: 'สถานที่',
    lessons: 'บทเรียน',
    location_broadcast: 'ตำแหน่งเซิร์ฟเวอร์ของผู้ทำการถ่ายทอดสด',
    location_broadcast_subtitle:
      'เพิ่มสถานที่ที่ใกล้ที่สุดกับตำแหน่งที่คุณจะทำการถ่ายทอดสดเพื่อลดความล่าช้าของภาพและเสียง',
    media_manager: 'การจัดการรูปภาพ',
    minutes: 'นาที',
    name: 'ชื่อ',
    online_quiz: 'คำถามออนไลน์',
    organiser: 'ผู้แต่ง',
    organization: 'องค์กร',
    overall_emotion: 'ประสบการณ์โดยรวม:',
    organizations_list: 'รายชื่อองค์กร',
    password: 'รหัสผ่าน',
    participants: 'ผู้เข้าร่วม',
    picture: 'รูปภาพ (16:9)',
    phone: 'โทรศัพท์มือถือ',
    photo: 'รูปถ่าย',
    poll: 'แบบสำรวจความคิดเห็น',
    position: 'ตำแหน่ง',
    processing: 'กำลังประมวลผล',
    privacy_settings: 'ตั้งค่าความเป็นส่วนตัว',
    question: 'คำถาม',
    quiz_create: 'สร้างชุดคำถาม',
    quiz_name: 'ชื่อคำถาม',
    quiz_update: 'อัพเดทชุดคำถาม',
    select_organization: 'เลือกองค์กร',
    settings: 'การตั้งค่า',
    show: 'แสดง',
    show_graph: 'แสดงผลในรูปแบบกราฟ',
    signin: 'เข้าสู่ระบบ',
    signup: 'สมัครการใช้งาน',
    sort_by: 'เรียงลำดับจาก',
    start_date: 'เริ่มจากวันที่',
    tags: 'Tags',
    terms: 'ฉันยอมรับ<1>ในข้อกำหนดและเงื่อนไข</1>.',
    title: 'ชื่อเรื่อง',
    topics: 'หัวข้อ',
    topic: 'หัวข้อ',
    total_comments: 'คอมเม้นต์ทั้งหมด',
    username: 'ชื่อผู้ใช้',
    users_list: 'รายชื่อผู้ใช้งาน',
    users_emails: 'ใส่อีเมลผู้ใช้งานเฉพาะเจาะจง',
    description_specifiction_email:
      'กรุณาใส่หนึ่งอีเมลต่อหนึ่งบรรทัดเพื่อทำการแชร์สำหรับผู้ใช้งานหลายคน',
    message_specific_email: ' กรุณาใส่อีเมลผู้ใช้งานที่เฉพาะเจาะจง',
    viewers: 'ผู้ชม',
    edit_course: 'แก้ไข',
    edit_assessment: 'แก้ไข',
    edit_event: 'แก้ไข',
    delete_course: 'ลบ',
    delete_event: 'ลบ',
    delete_assessment: 'ลบ',
    view_course: 'เปิดดู',
    view_event: 'เปิดดู',
    view_assessment: 'เปิดดู',
    date_event: 'วันที่วีดีโอถ่ายทอดสด',
    date_assessment: 'วันที่การประเมินผลแบบวีดีโอถ่ายทอดสด',
    clone_of: 'สร้างสำเนา',
    clone_course:
      'สร้างสำเนาคอร์สเรียนนี้รวมถึงเก็บข้อมูลทุกบทเรียนไว้แบบดั้งเดิมเพื่อทำการแก้ไขและปรับเปลี่ยนได้',
    make: 'ทำ',
    available_to: 'ผู้ใช้งานภายในองค์กร Sharelook สามารถใช้ได้',
    uploaded_by: 'อัพโหลดจาก: ',
    course: 'บทเรียน',
    assessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    user_not_exist: 'ไม่พบบัญชีผู้ใช้นี้ คุณต้องการส่งคำเชิญหรือไม่',
    check_user: 'แจ้งให้ทราบ',
    user_not_exist_in_org:
      'ไม่พบบัญชีผู้ใช้นี้ในองค์กรนี้คุณต้องการส่งคำเชิญหรือไม่',
    title_modal_stream: 'เปลี่ยนจำนวนลิมิตการวีดีโอถ่ายทอดสดขององค์กร',
    des_warning_stream: 'คุณกำลังจะทำการเปลี่ยนแปลง',
    monthly_stream: 'ลิมิตต่อเดือนของการทำวีดีโอถ่ายทอดสด',
    min_per_month: 'นาที/เดือน',
    broadcast_label: 'ฉันต้องการจะทำ:',
    hosts_emails: `กรุณาใส่อีเมลของผู้ที่จะทำการถ่ายทอดสด`,
    attendee_emails: `กรุณาใส่อีเมลผู้เข้าร่วม`,
    description_host_specifiction_email: 'กรุณาใส่หนึ่งอีเมลต่อหนึ่งบรรทัด',
    presenter_label: 'ผู้นำเสนอ',
    presenter_label_conference: 'จำนวนคน',
    event_privacy: 'โหมดการประชุม'
  },

  broadcastOptions: {
    stream_from_phone: 'ไลฟ์บรอดแคสต์จากมือถือ',
    other_webrtc: 'สัมมนาออนไลน์จากคอมพิวเตอร์',
    multihost: 'สัมมนาออนไลน์แบบหลายคนจากคอมพิวเตอร์',
    peer2peer: ' รายการการฝึกสอน',
    conference: 'การประชุมแบบวีดีโอถ่ายทอดสด'
  },

  lessoncreate: {
    title: 'เพิ่มรายละเอียดบทเรียน',
    subtitle:
      'ตั้งชื่อบทเรียนของคุณและบอกผู้เรียนว่าเขาจะได้อะไรจากบทเรียนนี้บ้าง',
    input_label_title: 'ชื่อบทเรียน',
    input_label_topics: 'หัวเรื่องบทเรียน',
    input_label_description: 'รายละเอียดของบทเรียน',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบหน้านี้'
  },

  lessonoverview: {
    title: 'เพิ่มบทเรียน',
    subtitle: 'เพิ่มบทเรียนที่มีอยู่แล้วหรือสร้างบทเรียนใหม่',
    new_lesson: 'สร้างบทเรียนใหม่',
    new_lesson_sub: 'สร้างบทเรียนใหม่ตั้งแต่เริ่มต้น',
    existing_lesson: 'เลือกจากบทเรียนที่มีอยู่แล้ว',
    existing_lesson_sub:
      'เชื่อมโยงไปยังบทเรียนที่มีอยู่แล้ว, การเปลี่ยนแปลงบทเรียนนี้จะทำให้บทเรียนนี้ที่อยู่ในคอร์สเรียนอื่นๆ เปลี่ยนแปลงไปด้วย ',
    clone_lesson: 'สร้างสำเนาจากบทเรียนที่มีอยู่แล้ว',
    clone_lesson_sub:
      'ทำการคัดลอกแบบเฉพาะเจาะจง การเปลี่ยนแปลงบทเรียนนี้จะไม่ส่งผลใด ๆ ต่อบทเรียนต้นฉบับ',
    clone_lesson_modal_sub:
      'โปรดคลิกปุ่มโคลนใต้บทเรียนที่คุณต้องการเพิ่มลงคอร์สเรียนของคุณ'
  },

  management: {
    groups_title: 'จักการกรุ๊ป',
    delete_warning: 'คุณแน่ใจหรือ?',
    organizations_title: 'องค์กรของฉัน',
    organizations_subtitle: ' เพิ่มองค์กรในรายการของคุณ',
    users_title: 'จัดการผู้ใช้งาน',
    users_position: 'ผู้จัดการบัญชีอาวุโส',
    user_not_found: 'ไม่พบบัญชีผู้ใช้งานนี้',
    select_org: ' กรุณาเลือกองค์กรที่คุณต้องการจะจัดการผู้ใช้งาน'
  },

  audio: {
    modal_title: 'ใส่ไฟล์เสียง',
    list_view: 'รายชื่อคนดู',
    create_audio_modal_title: 'สร้างไฟล์เสียง',
    edit_audio_modal_title: 'แก้ไขไฟล์เสียง',
    public_audio_not_found: 'ไม่พบไฟล์เสียง',
    private_audio_not_found: 'คุณยังไม่ได้อัพโหลดไฟล์เสียง',
    are_you_sure_to_delete: 'คุณแน่ใจหรือว่าต้องการลบ',
    type_something: 'ลองพิมพ์อะไรสักอย่าง',
    select_voice: 'เลือก',
    file_name: 'ชื่อไฟล์',
    description: 'รายละเอียด',
    topic: 'หัวข้อ',
    key_words_tag: 'คีย์เวิร์ด Tag',
    mp3_audio: 'ไฟล์เสียง mp3',
    created: 'สร้างแล้ว',
    duration: 'ระยะเวลา',
    close: 'ปิด'
  },

  image: {
    modal_title: 'ใส่รูปภาพ',
    image: 'รูปภาพ',
    pixel: 'พิกเซล',
    dimension: 'ขนาดกว้างยาว',
    public_image_not_found: 'ไม่พบรูปภาพ',
    private_image_not_found: 'คุณยังไม่ได้อัพโหลดรูปภาพ'
  },

  annotation: {
    modal_title: 'ป๊อปอัพ'
  },

  text: {
    modal_title: 'เครื่องมือการแก้ไขข้อความ'
  },

  video: {
    modal_title: 'ใส่ไฟล์วีดีโอ',
    image: 'ไฟล์วีดีโอ',
    mp4_video: 'ไฟล์วีดีโอ mp4',
    public_video_not_found: 'ไม่พบไฟล์วีดีโอ',
    private_video_not_found: 'คุณยังไม่ได้อัพโหลดไฟล์วีดีโอ'
  },

  media: {
    title: 'คลังรูปภาพ',
    subtitle: 'คลังไฟล์ของคุณ',
    modal_title: 'อัพโหลดไฟล์ภาพ',
    delete_warning: 'ยืนยันการลบ',
    delete_message:
      'หากคุณทำการสื่อในคลังรูปภาพ มันยังคงปรากฏในหน้าที่มีการใช้งาน',
    dropzone_text: 'หรือลากแล้ววาง',
    delete_success: 'ไฟล์ภาพถูกลบเรียบร้อยแล้ว',
    upload_file: 'อัพโหลดไฟล์',
    drag_drop: 'หรือลากแล้ววาง',
    import_file: 'ดึงไฟล์จากคอมพิวเตอร์ของคุณ',
    no_media: 'คุณยังไม่ได้อัพโหลดไฟล์',
    media_type: 'ประเภทไฟล์สื่อ',
    video: 'วีดีโอ',
    image: 'รูปภาพ',
    audio: 'เสียง',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'ไม่พบไฟล์สื่อ',
    of: 'จาก',
    disclaimer: `ฉันรับประกันว่าสื่อของฉันไม่:
     - ละเมิดสิทธิ์ของบุคคลที่สาม
     - มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจารรุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งปลอมตัวด้วยเครื่องหมายดอกจัน
     - มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
     - มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
     - มีข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับด้านการคุ้มครองข้อมูลในส่วนใดของโลก
     - มีการชักชวนทางการค้าหรือ“ สแปม” รูปแบบใด ๆ`,

    // newlyadded
    my_media: 'สื่อของฉัน',
    public_library: 'ห้องสมุดสาธารณะ',
    organization_library: 'ห้องสมุดองค์กร',
    upload_from_computer: 'อัปโหลดจากคอมพิวเตอร์',
    pexel_images: 'รูปภาพ Pexel',
    create: 'สร้าง',
    all: 'ทั้งหมด',
    male: 'ชาย',
    female: 'หญิง',
    processing_audio: 'การประมวลผลเสียง',
    create_annotation: 'สร้างคำอธิบายประกอบ',
    popup_over_lesson_text:
      'คำอธิบายประกอบจะปรากฏขึ้นเหนือหน้าบทเรียนหลังจากคลิก',
    edit_detail: 'แก้ไขรายละเอียด',
    delete: 'ลบ',
    go_create_audio: 'ไปสร้างเสียง',
    show_more_details: 'แสดงรายละเอียดเพิ่มเติม',
    show_less_details: 'แสดงรายละเอียดน้อยลง',
    drop_files: 'วางไฟล์และตำแหน่งที่จะอัปโหลด',
    or: 'หรือ',
    import_files: 'นำเข้าไฟล์จากคอมพิวเตอร์'
  },

  navigation: {
    account: 'บัญชี',
    assessments: 'การประเมิน',
    dashboard: 'แดชบอร์ด',
    groups: 'การจัดการกรุ๊ป',
    logout: 'ออกจากระบบ',
    organisations: 'องค์กร',
    organizations_users: 'องค์กรและผู้ใช้งาน',
    reports: 'รายงาน',
    schedule: 'การตั้งเวลา',
    training: 'หลักสูตรการเรียน',
    users: 'ผู้ใช้งาน',
    workshop: 'การประชุมเชิงปฏิบัติการของฉัน',
    nowLive: 'ออกอากาศ'
  },

  onboarding: {
    step1_title: 'ขั้นตอนแรกบอกให้เราทราบเกี่ยวกับตัวคุณเล็กน้อย',
    step1_subtitle: 'คุณชื่ออะไร คุณมาจากไหน และคุณทำงานอะไร',
    step2_title:
      'ขั้นตอนที่สอง เลือกความสามารถหรือสิ่งที่คุณสนใจและต้องการจะปรับปรุงหรือเรียนรู้เพิ่มเติม',
    step2_subtitle:
      'ถัดไปจากนั้น บอกสิ่งที่คุณต้องการทำความเข้าใจให้ดีขึ้น อาจเป็นสิ่งที่คุณยังไม่ได้เลือก หรือหลักสูตรใหม่ ๆ  หรืออะไรที่คุณชอบและสนในอยากจะเรียนรู้?'
  },

  pagebuilder: {
    title: 'สร้างบทเรียน',
    subtitle:
      'ถึงเวลาสร้างเนื้อหาเพื่อให้ผู้ชมของคุณได้เรียนรู้ คุณสามารถเพิ่มรูปภาพวิดีโอและอินโฟกราฟิก',
    select_layout: 'เลือกรูปแบบโครงร่าง',
    template1: 'หน้าเปล่า',
    template2: 'หัวเรื่อง และหัวเรื่องย่อ',
    template3: 'หัวเรื่องและข้อความ',
    template4: 'หัวเรื่อง สื่อภาพสื่อวีดีโอและข้อความ',
    template5: 'หัวเรื่องและสื่อภาพสื่อวีดีโอ',
    template6: 'หัวเรื่องและชุดคำถาม'
  },

  pageconstructor: {
    title: 'สร้างและสร้างสำเนาบทเรียน',
    subtitle:
      'ถึงเวลาสร้างเนื้อหาเพื่อให้ผู้ชมของคุณได้เรียนรู้ คุณสามารถเพิ่มรูปภาพวิดีโอและอินโฟกราฟิก'
  },

  passwordreset: {
    success_coded:
      'เราได้ส่งรหัสยืนยันทางอีเมลไปยังที่อยู่ที่คุณให้ไว้โปรดคัดลอกรหัสลงในฟิลด์ด้านล่างเพื่อตั้งรหัสผ่านใหม่',
    success_changed:
      'คุณตั้งรหัสผ่านใหม่สำเร็จแล้ว คุณสามารถลงชื่อเข้าใช้ได้เลย'
  },

  placeholders: {
    search: 'ค้นหา',
    answer: 'คำตอบ',
    chat: 'กรุณาพิมพ์ข้อความ',
    code: 'รหัส',
    criterion: 'เกณฑ์/บรรทัดฐาน',
    date_event: 'เลือกวันและเวลา',
    date_start: 'วันที่เริ่ม',
    date_expire: 'วันที่หมดอายุ',
    description: 'รายละเอียด',
    elements: 'จัดเรียงโดยองค์ประกอบ',
    email: 'อีเมล',
    feedback_correct: 'คำตอบถูกตอบ',
    feedback_incorrect: 'คำตอบไม่ถูกต้อง',
    host: 'ผู้ทำการถ่ายทอดสด',
    keywords: 'ค้นหาโดยคีย์เวิร์ด',
    lesson_description: 'คำอธิบายบทเรียน',
    location: 'สถานที่',
    minutes: 'จำนวนนาที',
    name: 'ชื่อ',
    organiser: 'ผู้สร้าง',
    organization: 'องค์กร',
    password: 'รหัสผ่าน',
    phone: 'โทรศัทพ์มือถือ',
    photo: 'รูปถ่าย',
    picture: 'รูปภาพ',
    point: 'คะแนน',
    position: 'ตำแหน่ง',
    question: 'คำถาม',
    quiz: 'ชื่อแบบสอบถาม',
    search_course: 'ค้นหาจากคอร์สเรียน',
    search_media: 'ค้นหารูปภาพและวีดีโอ',
    search_name: 'ค้นหาจากชื่อ',
    search_title: 'ค้นหาจากชื่อหัวเรื่อง',
    search_training: 'ค้นหาหลักสูตรการเรียน',
    settings: 'การตั้งค่า',
    tags: 'Tags',
    title: 'หัวเรื่อง',
    topics: 'หัวข้อ',
    username: 'บัญชีผู้ใช้งาน',
    keyword: 'คีย์เวิร์ด',
    max_500_characters: 'เยอะสุดไม่กิน 500 ตัวอักษร',
    no_description: 'ไฟล์นี้ไม่มีรายละเอียด',
    no_keyword: 'ไฟล์นี้ไม่มีคีย์เวิร์ด',
    no_topics: 'ไฟล์นี้ยังไม่มีการตั้งหัวข้อ',
    feedback: 'ข้อความ',
    contact: 'คุณต้องการความช่วยเหลือใช่ใหม?'
  },

  publishsettings: {
    title: 'การตั้งค่าการเผยแพร่',
    event_subtitle:
      'เพิ่มการตั้งค่าในวีดีโอถ่ายทอดสดของคุณ เพื่อกำหนดว่าใครสามารถมองเห็นและเข้าร่วมได้',
    assessment_subtitile:
      'ตั้งชื่อการประเมินผลแบบวีดีโอถ่ายทอดสดของคุณและบอกผู้ชมของคุณว่าพวกเขาควรจะเรียนรู้อะไรจากมัน',
    course_subtitle:
      'เพิ่มการตั้งค่าคอร์สเรียนของคุณว่าใครสามารถเข้ามาดูหรือมีส่วนร่วมในคอร์สเรียนของคุณได้',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'จำเป็นต้องใส่วันที่ของทั้งสองส่วน',
    emails_validation_error: 'รายชื่ออีเมลไม่ถูกต้อง',
    specific_email_validation_error: 'อนุญาตให้ใช้อีเมลเดียวเท่านั้น',
    i_agree_to_these: 'ฉันเห็นด้วยและยินยอมกับสิ่งเหล่านี้',
    terms_and_conditions: 'ข้อกำหนดและเงื่อนไข',
    PublicDescription:
      'บัญชีผู้ใช้งานทัวไป: (ตัวเลือกความเป็นส่วนตัวและสาธารณะ)ของคุณ [คอร์สเรียน|รายการ|การประเมินผลแบบวีดีโอถ่ายทอดสด] ได้รับการบันทึกและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณเท่านั้นที่เห็นเนื้อหานี้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกให้เป็นสาธารณะด้านล่าง ซึ่งหมายความว่าหลักสูตรนี้จะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์ม',
    OrganisationsDescription:
      'บัญชีผู้ใช้งานทั่วไปในองค์กร: (แทนที่จะใช้" "เสร็จสิ้น" "ให้ใช้" "เผยแพร่" และนำ ไปยังหน้าเผยแพร่เช่นเดียวกับผู้ใช้รายอื่น แต่ไม่มีตัวเลือกการเผยแพร่ใด ๆ ) [หลักสูตร | กิจกรรม | การประเมินผล] ของคุณได้รับการบันทึกและ เป็นส่วนตัว ซึ่งหมายความว่ามีเพียงคุณและแอดมินในองค์กรของคุณเท่านั้นที่สามารถมองเห็นได้  และเนื่องจากบัญชีของคุณเป็นเพียงบัญชีผู้ใช้งานทั่วไปไม่ใช่แอดมิน ดังนั้นคุณไม่สามารถเผยแพร่เนื้อหาของคุณภายในองค์กรของคุณด้วยตัวคุณเองได้ โปรดติดต่อผู้ดูแลระบบหรือผู้ที่เป็นแอดมิน และขอให้พวกเขาเผยแพร่เนื้อหาของคุณแบบสาธารณะไปยังทั้งองค์กรไปยังกลุ่มเฉพาะภายในองค์กรของคุณหรือให้กับผู้ใช้ที่ระบุ',
    OrganisationGroupsDescription:
      'บัญชีผู้ดูแลระบบขององค์กรหรือแอดมิน: (สำหรับเนื้อหาที่สร้างขึ้นภายในองค์กร: ส่วนตัวสาธารณะองค์กรกลุ่มผู้ใช้เฉพาะ): [คอร์สเรียน | รายการกิจกรรม | การประเมินผล] นี้ได้รับการบันทึกและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณ (และผู้สร้างเนื้อหา) เท่านั้นที่สามารถดูเนื้อหานี้ได้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่หลักสูตรของคุณสู่สาธารณะหมายความว่าหลักสูตรนี้จะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์มรวมถึงผู้ที่อยู่นอกองค์กรของคุณ การเผยแพร่ไปยังองค์กรหมายความว่าผู้ใช้ทุกคนภายในองค์กรจะสามารถมองเห็นได้ นอกจากนี้คุณยังสามารถเผยแพร่ไปยังกรุ๊ปได้อย่างน้อยหนึ่งกรุ๊ปหรือมากกว่า ซึ่งหมายความว่ามีเพียงผู้ใช้ในกรุ๊ปเหล่านั้นเท่านั้นที่จะเห็นได้ สุดท้ายนี้คุณมีตัวเลือกในการเผยแพร่ให้กับผู้ใช้เฉพาะภายในและภายนอกองค์กรของคุณโดยใช้ที่อยู่อีเมลของบัญชี Sharelook ',
    SpecificUsersDescription:
      'บัญชีผู้ใช้งานแบบชำระเงิน: (ความเป็นส่วนตัว สาธารณะและเฉพาะเจาะจง) [คอร์สเรียน | รายการกิจกรรม | การประเมินผล] ของคุณได้รับการบันทึกแล้วและถือว่าเป็นส่วนตัวตามค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณเท่านั้นที่เห็นเนื้อหานี้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่คอร์สเรียนของคุณสู่สาธารณะหมายความว่าคอร์สเรียนจะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์ม ตัวเลือกผู้ใช้เฉพาะจะช่วยให้คุณสามารถแบ่งปันคอร์สเรียนของคุณกับผู้ใช้งานแบบเฉพาะเจาะจง โดยใช้ที่อยู่อีเมลที่พวกเขาใช้ลงทะเบียนหรือมีบัญชีผู้ใช้งานกับ Sharelook '
  },

  quiz: {
    quiz_empty: 'คุณยังไม่ได้สร้างชุดแบบสอบถาม',
    questions_empty: 'คุณยังไม่ได้สร้างคำถาม'
  },

  regions: {
    asia_pacific_australia: 'ออสเตเรีย',
    asia_pacific_india: 'อินเดีย',
    asia_pacific_japan: 'ญี่ปุ่น',
    asia_pacific_s_korea: 'เกาหลีใต้',
    asia_pacific_singapore: 'สิงคโปร์ ',
    asia_pacific_taiwan: 'ไต้หวัน',
    eu_belgium: 'เบลเยี่ยม',
    eu_germany: 'เยอรมัน',
    eu_ireland: 'ไอร์แลนด์',
    south_america_brazil: 'บราซิล',
    us_central_iowa: 'ไอโอวา',
    us_east_s_carolina: 'เซาท์แคโรไลนา',
    us_east_virginia: 'เวอร์จิเนีย',
    us_west_california: 'แคลิฟอร์เนีย',
    us_west_oregon: 'ออริกอน'
  },

  reports: {
    title: 'รายงาน',

    // newlyadded
    workshop_report: 'รายงานการประชุมเชิงปฏิบัติการ',
    user_report: 'รายงานผู้ใช้',
    organization_workshop: 'การประชุมเชิงปฏิบัติการขององค์กร',
    course: 'ภาพรวมของคอร์ส',
    live_event: 'ถ่ายทอดสด',
    workShop_graph: 'กราฟการประชุมเชิงปฏิบัติการ',
    organization_account: 'บัญชีองค์กร',
    all: 'ทั้งหมด',
    name: 'ชื่อ',
    id_number: 'เลขประจำตัว',
    email: 'อีเมล์',
    search_user_report: 'ค้นหารายงานผู้ใช้',
    participant: 'ผู้เข้าร่วม',
    participants: 'ผู้เข้าร่วม',
    host: 'เจ้าภาพ',
    username: 'ชื่อผู้ใช้',
    event: 'อีเว้นท์',
    quiz: 'แบบทดสอบ',
    assessment: 'การประเมิน',
    time: 'เวลา',
    no_recent_activity: 'ไม่มีกิจกรรมล่าสุด',
    workshops: 'เวิร์คช็อป',
    courses: 'หลักสูตร',
    live_events: 'เหตุการณ์สด',
    live_assessments: 'การประเมินสด',
    quizzes: 'แบบทดสอบ',
    overview: 'ภาพรวม',
    by: 'โดย',
    views: 'มุมมอง',
    status: 'สถานะ',
    poll: 'แบบสำรวจ',
    comment: 'แสดงความคิดเห็น',
    comments: 'ความคิดเห็น',
    no_comments: 'ไม่มีความคิดเห็น',
    no_polls: 'ไม่มีการสำรวจ',
    live_date: 'วันที่ถ่ายทอดสด',
    score: 'คะแนน',
    question: 'คำถาม',
    submit: 'ส่ง',
    recent_activity: 'กิจกรรมล่าสุด',
    ago: 'ที่ผ่านมา',
    no_data_found: 'ไม่พบข้อมูล',
    start_end_live: 'เริ่ม / สิ้นสุดการถ่ายทอดสด',
    join_leave_date: 'เข้าร่วม / ออกจากการถ่ายทอดสด',
    watched_time: 'เวลาในการรับชม',
    complete: 'เสร็จสมบูรณ์',
    in_complete: 'ในเสร็จสมบูรณ์',
    today: 'วันนี้',
    seven_days: '7 วัน',
    last_month: 'เดือนที่แล้ว',
    one_year: '1 ปี',
    all_time: 'ตลอดเวลา',
    report: 'รายงาน',
    from_date: 'จากวันที่',
    to_date: 'ถึงวันที่',
    all_workshop: 'การประชุมเชิงปฏิบัติการทั้งหมด',
    all_participants: 'ผู้เข้าร่วมทั้งหมด',
    live_assessment: 'การประเมินสด',
    users: 'ผู้ใช้',
    download: 'ดาวน์โหลด',
    recent: 'ล่าสุด',
    WorkShop: 'การประชุมเชิงปฏิบัติการ',
    Activity: 'กิจกรรม',
    created_date: 'สร้างเมื่อ',
    lessons: 'บทเรียน',
    lesson: 'บทเรียน',
    completed: 'บทเรียน',
    report_download: 'ดาวน์โหลดรายงาน',
    this_month: 'เดือนนี้',
    search_course: 'หลักสูตรการค้นหา',
    participants_graph: 'กราฟผู้เข้าร่วม',
    viewed: 'ดูแล้ว',
    enrolled: 'ลงทะเบียนแล้ว',
    description: 'คำอธิบาย',
    topic: 'หัวข้อ',
    analytic: 'วิเคราะห์',
    quiz_list: 'รายการคำถาม',
    select_one: 'เลือกหนึ่งอัน',
    group_status: 'สถานะกลุ่ม',
    duration_min: 'ระยะเวลา (นาที)',
    submit_poll: 'ส่งแบบสำรวจ',
    download_events: 'ดาวน์โหลดเหตุการณ์',
    search_event: 'ค้นหาเหตุการณ์',
    duration: 'ระยะเวลา',
    total_participants: 'ผู้เข้าร่วมทั้งหมด',
    message: 'ข้อความ',
    avg_message: 'ข้อความเฉลี่ย',
    per_message: 'เปอร์เซ็นต์ของข้อความ / เหตุการณ์'
  },

  signup: {
    success_step1:
      'เราได้ส่งรหัสยืนยันไปยังที่อยู่ที่คุณให้ไว้ทางอีเมล โปรดคัดลอกรหัสลงในฟิลด์ด้านล่างเพื่อยืนยันการลงทะเบียนของคุณ',
    success_step2: 'ขอบคุณ คุณลงทะเบียนเรียบร้อยแล้ว',
    privacy: `ฉันยอมรับกับ Sharelook <1> ข้อกำหนดและเงื่อนไข</1> และ <3> นโยบายความเป็นส่วนตัว</3>`
  },

  stream: {
    emotion_impressive: 'ประทับใจ',
    emotion_unimpressive: 'ไม่ประทับใจ',
    message_not_started: 'เร็วๆ นี้',
    message_running: 'วีดีโอถ่ายทอดสด',
    message_processing:
      ' เรากำลังดำเนินการบันทึกการถ่ายทอดสดของคุณ คุณสามารถย้อนกลับมาดูหรือนำกลับมาใช้งานต่อไป โปรดกลับมาตรวจสอบในภายหลังเพื่อดูวิดีโอและเพิ่มคะแนนและข้อเสนอแนะต่อไป '
  },

  tabs: {
    audience: 'ผู้ชม',
    course: 'ภาพรวมของคอร์ส',
    details: 'ข้อมูลวีดีโอถ่ายทอดสด',
    description: 'รายละเอียด',
    host: 'ผู้ทำการถ่ายทอดสด',
    lesson: 'ภาพรวมของบทเรียน',
    lessons: 'บทเรียน',
    overview: 'ภาพรวม',
    page: 'ตัวสร้างเพจ',
    publish: 'เผยแพร่',
    settings: 'ตั้งค่าการเผยแพร่',
    total_views: 'จำนวนผู้ชมทั้งหมด',
    live_participates: 'ผู้เข้าร่วมในวีดีโอถ่ายทอดสด',
    live_chats: 'บทสนทนาวีดีโอถ่ายทอดสด',
    live_quiz: 'แบบสอบถามวีดีโอถ่ายทอดสด',
    trainer_rating: 'การให้คะแนนผู้ฝึกสอน',
    trainer_times: 'เวลาของผู้ฝึกสอน',
    courses_quizzes: 'ชุดคำถามของคอร์ส',
    user_list: 'รายชื่อผู้ใช้',
    discussion: 'บทสนทนา',
    notes: 'บันทึกส่วนตัว'
  },

  topics: {
    SALES_TRAINING: 'Sales Training',
    NEGOTIATION_TRAINING: 'Negotiation Training',
    CROSS_CULTURAL_AWARENESS: 'Cross-Cultural Awareness',
    NETWORKING_SKILLS: 'Networking Skills',
    SOFTWARE_ARCHITECTURE: 'Software Architecture',
    PROJECT_MANAGEMENT: 'Project Management',
    DIGITAL_TRANSFORMATION: 'Digital Transformation',
    IT_CONSULTING: 'IT Consulting',
    MANAGEMENT_CONSULTING: 'Management Consulting',
    HR_CONSULTING: 'HR Consulting',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Cybersecurity',
    PRIVACY_AND_GDRP: 'Privacy and GDPR'
  },

  training: {
    title: 'หลักสูตรการเรียน',
    title_assessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    subtitle: ' คอร์สและวีดีโอถ่ายทอดสด',
    enrolled_title: 'ลงชื่อเรียนคอร์สและวีดีโอถ่ายทอดสด',
    enrolled_subtitle: ' คอร์สเรียนและวีดีโอถ่ายทอดสดที่คุณลงชื่อเข้าร่วม',
    enrolled_message:
      'ตอนนี้คุณยังไม่ได้ลงชื่อเข้าร่วมในคอร์สเรียนและวีดีโอถ่ายทอดสด',
    past_live_event_title: ' วีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',
    past_live_event_subTitle: 'เสร็จสิ้นวีดีโอถ่ายทอดสด',
    past_live_event: 'ตอนนี้ยังไม่มีวีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',
    recomended_title: 'คอร์สเรียนและวีดีโอถ่ายทอดสดที่แนะนำ',
    now_live_event_title: 'ถ่ายทอดสดอยู่ขณะนี้',
    now_live_event_subTitle: 'รายการที่คุณจะทำการถ่ายทอดสดจะเกิดขึ้นเร็วๆ นี้',
    now_live_event: 'ตอนนี้ยังไม่มีรายการวีดีโอถ่ายทอดสด',
    webinar_event_title: 'ช่องทางการสัมนาทางเว็บ',
    webinar_event_subTitle: 'จบการสัมนาทางเว็บออนไลน์',
    webinar_event: 'ตอนนี้ยังไม่มีการสัมนาทางเว็บ',
    p2p_event_title: 'การฝึกสอน',
    p2p_event_subTitle: 'เสร็จสิ้นรายการการฝึกสอน',
    p2p_event: 'ตอนนี้ยังไม่มีรายการการฝึกสอน',

    now_live_assessment_title: 'ถ่ายทอดสดอยู่ขณะนี้',
    now_live_assessment_subTitle:
      ' การประเมินผลแบบวีดีโอถ่ายทอดสดที่คุณเป็นผู้ดำเนินรายการหรือมีส่วนร่วมกำลังจะเกิดขึ้นเร็วๆ นี้',
    now_live_assessment_message: 'ตอนนี้ยังไม่มีการประเมินผลแบบวีดีโอถ่ายทอดสด',

    upcoming_assessment_title:
      'การประเมินผลแบบวีดีโอถ่ายทอดสดที่กำลังจะเกิดขึ้น',
    upcoming_assessment_subtitle:
      'การประเมินผลแบบวีดีโอถ่ายทอดสดที่กำลังจะเกิดขึ้น',
    upcoming_assessment_message:
      'ตอนนี้ยังไม่มีการประเมินผลแบบวีดีโอถ่ายทอดสดที่กำลังจะเกิดขึ้น',
    past_live_assessment_title: 'การประเมินผลแบบวีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',
    past_live_assessment_subTitle: 'เสร็จสิ้นการประเมินผลแบบวีดีโอนถ่ายทอดสด',
    past_live_assessment_message:
      'ตอนนี้ยังไม่มีการประเมินผลแบบวีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'เราได้ดูแลจัดการคอร์สเรียนและวีดีโอนถ่ายทอดสดโดยอ้างอิงจากข้อมูลของคุณ <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: ' ค้นหาหลักสูตรการเรียน',
    search_assessment: 'ค้นหาการประเมินผลแบบวีดีโอถ่ายทอดสด',
    recomended_message: 'ขณะนี้ยังไม่มีคอร์สเรียนและกิจกรรมแนะนำ'
  },

  warnings: {
    delete: 'คุณแน่ใจหรือไม่?'
  },

  workshop: {
    title: 'การประชุมเชิงปฏิบัติการของฉัน',
    subtitle: 'สร้างคอร์สเรียนหรือถ่ายทอดสดด้วยตัวของคุณเอง',
    new_course: ' สร้างคอร์สเรียนใหม่',
    new_event: 'สร้างวีดีโอถ่ายทอดสดใหม่',
    new_assessment: 'สร้างกระประเมินผลแบบวีดีโอถ่ายทอดสดใหม่',
    courses_title: 'สร้างคอร์สเรียนและการถ่ายทอดสด',
    courses_subtitle:
      'แก้ไขและเผยแพร่คอร์สเรียนที่คุณสร้างขึ้นและวางแผนการถ่ายทอดสด',
    tags_course: 'คอร์สเรียน',
    tags_live: 'การถ่ายทอดสด',
    tags_assessment: ' การประเมินผลแบบวีดีโอถ่ายทอดสด'
  },

  help_center: {
    sidebar: {
      title: 'เราสามารถช่วยคุณได้อย่างไร?',
      back_to: 'แดชบอร์ด'
    },
    menu: {
      help_center: 'ศูนย์ช่วยเหลือ',
      whats_new: 'มีข่าวอะไรใหม่ ๆ ใหม',
      feedback: 'ความคิดเห็น',
      feedback_title: 'ส่งความคิดเห็นให้ sharelook',
      terms_and_conditions: 'ข้อตกลงและเงื่อนไข',
      privacy_policy: 'นโยบายความเป็นส่วนตัว',
      contact_us: 'ติดต่อเรา'
    },
    get_started: {
      title: 'เริ่มการใช้งานกับ sharelook',
      description: {
        main:
          'เราได้รวบรวมวิดีโอสาธิตการใช้งานต่าง ๆ ไว้ในตัวสร้างคอร์สเรียนเพื่อใช้งานง่ายขึ้น',
        tagline:
          'ด้วยระบบถ่ายทอดสดที่ได้รับการจดสิทธิบัตรของ ShareLook คุณสามารถสร้าง และมีส่วนร่วมการเรียนรู้ และเพิ่มเติมการเรียนรู้ของคุณรวมถึงการแบ่งปันความรู้ได้สูงสุด'
      }
    },
    whats_new: {
      title: 'เริ่มการใช้งานกับ sharelook',
      description: {
        main:
          'คุณรู้ไหมว่าการสร้างบทเรียนหรือหลักสูตรการเรียนรู้รูปแบบการเล่าเรื่อง สามารถสร้างได้ในเวลาอันสั้นและไม่แพงเลย คุณควรสร้างหลักสูตรหรือความสามารถของคุณลงใน ShareLook เพื่อให้มีคนติดตามสนใจ ติดต่อเราสำหรับข้อมูลเพิ่มเติม',
        tagline: ''
      }
    },
    create_workshop: 'Hวิธีสร้างเวิร์กชอป',
    create_course: ' สร้างคอร์สเรียนอย่างไร',
    create_user: 'สร้างบัญชีผู้ใช้งานอย่างไร',
    create_group: 'สร้างกรุ๊ปอย่างไร',
    create_webinar: ' สร้างการสัมมนาออนไลน์อย่างไร',
    create_live_event: 'สร้างการถ่ายทอดสดอย่างไร',
    create_live_assessment: ' สร้างการประเมินผลแบบวีดีโอถ่ายทอดสดอย่างไร',
    create_live_on_mobile: 'สร้างการถ่ายทอดสดด้วยโทรศัพท์มือถือ',
    personalize_profile: 'ปรับแต่งแก้ไขโปรโฟล์',
    manage_group: 'จัดการกรุ๊ป',
    report: 'รายงาน',
    add_annotations: 'เพิ่มป๊อบอัพอย่างไร',
    add_audio: 'เพิ่มหรือใส่เสียงอย่างไร',
    add_header_and_footer: 'เพิ่มหัวกระดาษและท้ายกระดาษอย่างไร',
    add_image: 'เพิ่มรูปภาพอย่างไร',
    add_quiz_content: 'เพิ่มชุดแบบสอบถามอย่างไร',
    add_text_content: 'เพิ่มข้อความตัวอักษรอย่างไร',
    add_user: 'เพิ่มบัญชีผู้ใช้งานอย่างไร',
    add_video: ' เพิ่มวีดีโออย่างไร',
    clone_course: 'สร้างสำเนาคอร์สเรียนอย่างไร',
    find_live_broadcast: 'ค้นหารายการการถ่ายทอดสดอย่างไร',
    contact_us: {
      title: 'ติดต่อเรา',
      subject_placeholder: 'ใส่หัวเรื่อง *',
      content_placeholder: 'ใส่ข้อความ*',
      subject_required: '*จำเป็นต้องใส่หัวเรื่อง',
      content_required: '*จำเป็นต้องใส่ข้อความ',
      submit: 'ส่ง',
      cancel: 'ยกเลิก',
      sent: 'ส่งแล้ว'
    },
    feedback: {
      title: 'ส่งความคิดเห็นไปยัง sharelook',
      attach_title: 'แนบไฟล์',
      choose: 'เลือกไฟล์',
      detail: ' ไฟล์นี้จะถูกแบ่งปันกับทีมซัพพอร์ต',
      content_placeholder: 'ใส่ข้อความ*',
      content_required: '*จำเป็นต้องใส่ข้อความ',
      submit: 'ส่ง',
      cancel: 'ยกเลิก',
      sent: 'ส่งแล้ว'
    }
  },
  discussion: {
    join_discussion: 'ร่วมพูดคุยในบทสนทนา'
  },
  notes: {
    title: 'บันทึกส่วนตัวของฉัน',
    add_note: 'เพิ่มบันทึกของฉัน'
  }
}
